import kit from '@binaa-almajal/ui-kit/locales/kit/ar';

// Arabic. Must carry the same keys as en.js — a missing key silently falls back
// to English mid-sentence, which reads as a bug rather than a gap.
//
// The UI flips to RTL on this locale (see I18nProvider and utils/i18nUtils).
// Use logical CSS properties in components — ms-/me-/ps-/pe- and start/end —
// not left/right, or the layout breaks here only.

// See en.js: the kit's own copy first, this application's keys after.
export default {
    ...kit,
    // ─── التطبيق ─────────────────────────────────────────────────────────────
    'app.name': 'أكاديمية VDC',
    'app.logoAlt': 'شعار بناء المجال',

    // ─── العلامة التجارية ────────────────────────────────────────────────────
    // اسم الشركة كما يرد في الشعار. لا تُكتب بالحروف اللاتينية هنا: الشعار
    // نفسه يحمل «BIM» و«Binaa Al-Majal» رسمًا لا نصًا، فيبقى المكتوب عربيًا.
    'brand.name': 'بناء المجال',
    'brand.tagline': 'نبني بذكاء. ننمذج بإتقان. نسلّم المستقبل.',
    'brand.discipline': 'البناء الرقمي',

    // ─── التنقل ──────────────────────────────────────────────────────────────
    'nav.dashboard': 'لوحة القيادة',
    'nav.people': 'الأشخاص',
    'nav.cohorts': 'الدفعات',
    'nav.arrivals': 'واردات',
    'nav.cohortRequests': 'طلبات الدفعات',
    'nav.grading': 'التقييم',
    'nav.enrollmentsQueue': 'بانتظار الإتمام',
    'nav.credentials': 'الشهادات',
    'nav.curriculum': 'المنهج',
    'nav.my': 'تعلّمي',
    'nav.my.what': 'ما عليك فعله الآن وما هو مستحق',
    'nav.group.home': 'الرئيسية',
    'nav.group.queues': 'قوائم الانتظار',
    'nav.group.register': 'السجل',
    'nav.group.catalogue': 'الفهرس',

    // ─── ما الذي يحتويه كل عنصر في الشريط الجانبي ───────────────────────────
    'nav.dashboard.what': 'اليوم في لمحة',
    'nav.company.what': 'مقاعدكم وأفرادكم',
    'nav.arrivals.what': 'المتعلمون المنضمون حديثًا',
    'nav.cohortRequests.what': 'شركات تنتظر مواعيد',
    'nav.grading.what': 'أعمال بانتظار الحكم',
    'nav.enrollmentsQueue.what': 'أشخاص أنهوا العمل ولم يُغلق تسجيلهم بعد',
    'nav.people.what': 'كل من في السجل',
    'nav.cohorts.what': 'البرامج الجارية فعلاً',
    'nav.availability': 'التوافر',
    'nav.availability.what': 'من هو غائب، من الموارد البشرية',
    'nav.credentials.what': 'من يحمل ماذا',
    'nav.companies.what': 'من يشتري المقاعد',
    'nav.curriculum.what': 'ما ندرّسه',
    'nav.programs.what': 'ما نبيعه',
    'nav.checkCodes.what': 'ما يجوز للمقيّم الاستناد إليه',

    // ─── شريط مسار الفهرس ────────────────────────────────────────────────────
    'pipeline.curriculum': 'مستويات ووحدات ودروس',
    'pipeline.programs': 'وحدات مجمّعة للبيع',
    'pipeline.cohorts': 'برنامج قيد التنفيذ فعلياً',
    'nav.group.system': 'النظام',
    'nav.menu': 'فتح التنقل',

    // ─── الهوية ──────────────────────────────────────────────────────────────
    'auth.signIn': 'تسجيل الدخول',
    'auth.signOut': 'تسجيل الخروج',
    'auth.signInRequired': 'سجّل الدخول للمتابعة.',

    // ── الواجهة الأمامية لتسجيل الدخول (screens/SignIn.jsx) ──
    'auth.gateLead': 'التدريب والتقييم ومنح الشهادات لمنصة بناء.',
    'auth.gateTitle': 'سجّل الدخول للمتابعة',
    'auth.gateSignInHint': 'سيتم تحويلك إلى صفحة تسجيل الدخول الخاصة بالأكاديمية لإدخال بياناتك.',
    'auth.gateNoProvider': 'لا يوجد مزوّد لتسجيل الدخول في هذه النسخة.',
    'auth.noAccountTitle': 'ليس لديك حساب؟',
    'auth.noAccountEnquiryHint': 'الحسابات تصدرها الأكاديمية. تواصل معنا وسيجهّز فريقنا كل شيء لك.',
    'auth.getInTouch': 'تواصل معنا',
    'auth.haveAccount': 'لديك حساب بالفعل؟',
    'auth.gateVerify': 'التحقق من الشهادة',
    'auth.notProvisioned':
        'حسابك غير مرتبط بسجل شخص بعد. اطلب من المسؤول ربطه — إعادة تسجيل الدخول لن تحل المشكلة.',
    'auth.notProvisionedTitle': 'حسابك بحاجة إلى ربط',
    'auth.notProvisionedQuote': 'أعطِ المسؤول هذه الهوية:',
    'auth.claimHint':
        'سجّلت وتمت الموافقة عليك؟ إذا سجّلت الدخول بالبريد الإلكتروني الذي سجّلت به، يمكنك المطالبة بسجلاتك بنفسك.',
    'auth.claimAction': 'المطالبة بسجلاتي',
    'auth.claimNotFound':
        'لا يوجد تسجيل معتمد يطابق هذا البريد الإلكتروني. إذا سجّلت بعنوان مختلف، فاطلب من المسؤول ربط حسابك بدلًا من ذلك.',
    'error.generic': 'حدث خطأ ما.',

    // ─── عام ─────────────────────────────────────────────────────────────────
    'common.save': 'حفظ',
    'common.delete': 'حذف',
    'common.backHome': 'العودة إلى لوحة القيادة',
    'common.toggleTheme': 'تبديل المظهر',
    'common.or': 'أو',

    // ─── الأسواق ─────────────────────────────────────────────────────────────
    'market.select': 'اختر دولة…',
    'market.none': 'لا توجد دول متاحة',
    'market.allMarkets': 'لم يتم اختيار دول — متاح في كل مكان',
    'market.label': 'الدول',
    'market.add': 'أضف دولة…',
    'market.remove': 'إزالة {code}',
    'market.all': 'كل الدول',
    'countryFilter.label': 'التصفية حسب الدولة',
    'countryFilter.all': 'كل الدول',

    'person.languageNotSet': 'غير محدَّد',
    'person.languageUnsupported': 'لغة غير مدعومة',
    'common.switchLanguage': 'تغيير اللغة',
    'common.user': 'مستخدم',
    'common.userMenu': 'قائمة المستخدم',
    'common.noData': 'لا توجد بيانات',
    'common.yes': 'نعم',
    'common.no': 'لا',

    'action.close': 'إغلاق',

    // ─── لوحة القيادة ────────────────────────────────────────────────────────
    'dashboard.purpose': 'ما يحتاج انتباهك، وكيفية التعامل معه.',
    'screen.dashboard.intro': 'ما يحتاج انتباهك، وكيفية التعامل معه — ابدأ بقسم «يحتاجك»، ثم الطوابير أسفله.',
    'screen.cohorts.intro': 'البرامج الجارية فعلاً — افتح أحدها لترى قائمته وتواريخه ومدرّبه.',
    'dashboard.people': 'الأشخاص',
    'dashboard.learners': 'المتدربون',
    'dashboard.instructors': 'المدربون',
    'dashboard.myLearners': 'متدربيّ',
    'dashboard.myLearnersHint': 'عبر الدفعات التي تدرّسها',
    'dashboard.myTeachingStatus': 'حالة التدريس',
    'dashboard.teachingNow': 'يدرّس حاليًا',
    'dashboard.notTeaching': 'لا يدرّس حاليًا',
    'dashboard.gradingQueue': 'بانتظار التقييم',
    'dashboard.outboxDepth': 'عمق صندوق الصادر',
    'dashboard.outboxHint': 'أحداث تكامل بانتظار الإرسال',
    'dashboard.cohortsByState': 'الدفعات حسب الحالة',
    'dashboard.enrollmentsByState': 'التسجيلات حسب الحالة',
    'dashboard.credentialsByStatus': 'الشهادات حسب الحالة',
    'dashboard.noCohortsYet': 'لا دفعات بعد',
    'dashboard.noEnrollmentsYet': 'لا تسجيلات بعد',
    'dashboard.noCredentialsYet': 'لا شهادات بعد',
    'dashboard.total': 'الإجمالي',
    'dashboard.openCohorts': 'فتح سجل الدفعات',
    'dashboard.programScoringTitle': '{count} برامج بلا درجات للوحدات',
    'dashboard.programScoringTitleOne': 'برنامج واحد بلا درجات للوحدات',
    'dashboard.programScoringBody': 'حدّ البرنامج فيها لا يضع أي درجات دنيا، فالاعتمادات لا تتطلب سوى الاجتياز. حدّد درجة دنيا للوحدات التي ينبغي أن تشترطها.',
    'dashboard.programScoringCta': 'تحديد درجات الوحدات',
    'dashboard.queues': 'بانتظار قرار',
    'dashboard.queueEmpty': 'لا شيء بالانتظار',
    'dashboard.gradingQueueHint': 'تقييمات بانتظار مدرّب',
    'dashboard.awaitingCompletionQueue': 'بانتظار الإغلاق',
    'dashboard.awaitingCompletionQueueHint': 'أنهى كل الوحدات ولم يُعلَّم مكتملًا بعد',
    'dashboard.delivery': 'التنفيذ',
    'dashboard.hoursTaught': 'ساعات التدريس',
    'dashboard.hoursTaughtHint': 'عبر {held} جلسة مُنعقدة',
    'dashboard.sessionsHeld': 'الجلسات المنعقدة',
    'dashboard.lastHeld': 'آخر انعقاد {when}',
    'dashboard.neverHeld': 'لم تنعقد أي جلسة بعد',
    'dashboard.attendanceRate': 'الحضور',
    'dashboard.noRegisters': 'لم يُرصد الحضور بعد',
    'dashboard.attendanceBasis': '{present} من {expected}، عبر {registers} كشف حضور',
    'dashboard.cancellationRate': 'الإلغاءات',
    'dashboard.nothingDecided': 'لم تنعقد أو تُلغَ أي جلسة بعد',
    'dashboard.cancellationBasis': '{cancelled} مُلغاة · {scheduled} لم تنعقد بعد',
    'dashboard.instructorsTeaching': 'يدرّسون الآن',
    'dashboard.instructorsTeachingHint': 'مُسنَدون إلى دفعة قائمة',
    'dashboard.instructorsDelisted': 'مشطوبون',
    'dashboard.instructorsDelistedHint': 'لم يعودوا يستلمون دفعات',
    'dashboard.satisfaction': 'الرضا',
    'dashboard.unrated': 'لا تقييمات بعد',
    'dashboard.outOfTen': '{score} / 10',
    'dashboard.ratingsCount': '{count} تقييمًا',
    'dashboard.sessionsAhead': 'مجدولة',
    'dashboard.sessionsAheadHint': 'جلسات لم تنعقد بعد',
    'dashboard.sessionsByOutcome': 'الجلسات حسب النتيجة',
    'dashboard.instructorDelivery': 'المدربون بحسب التنفيذ',
    'dashboard.instructorDeliveryLead':
        'من درّس، وكم، وكيف سارت الأمور. المدربون المشطوبون يبقون في القائمة ويأتون في آخرها — سجل التنفيذ لا يختفي بتوقف صاحبه عن التدريس.',
    'dashboard.noInstructors': 'لم يدرّس أي مدرّب هنا بعد',
    'dashboard.noInstructorsHint': 'يظهر المدرّب حين تُسنَد إليه دفعة في هذا السوق.',
    'dashboard.delisted': 'مشطوب',
    'dashboard.heldOfScheduled': '{held} منعقدة · {ahead} قادمة',
    'dashboard.cancelled': 'مُلغاة',
    'dashboard.cancelledCount': '{count} ({rate})',
    'dashboard.cohortsTaught': 'الدفعات',
    'dashboard.cohortsRunningOf': '{total}، منها {running} قائمة',
    'dashboard.learnersTaught': 'من درّسهم',
    'dashboard.lastTaught': 'آخر تدريس',

    // ─── التحقق العام ────────────────────────────────────────────────────────
    'verify.title': 'التحقق من شهادة',
    'verify.subtitle': 'أدخل الرقم المطبوع على الشهادة. لا حاجة إلى حساب.',
    'verify.placeholder': 'رقم الشهادة',
    'verify.submit': 'تحقّق',
    'verify.notFound': 'لم يُعثر على شهادة بهذا الرقم.',
    'verify.rateLimited': 'عدد كبير من المحاولات من هذه الشبكة. انتظر دقيقة ثم أعد المحاولة.',
    'verify.publicNo': 'رقم الشهادة',
    'verify.issuer': 'جهة الإصدار',
    'verify.issuedOn': 'تاريخ الإصدار',
    'verify.validUntil': 'صالحة حتى',
    'verify.competencies': 'الكفاءات',

    'credential.status.Active': 'سارية',
    'credential.status.Expired': 'منتهية',
    'credential.status.Revoked': 'ملغاة',
    'credential.status.Superseded': 'مُستبدَلة',

    // ─── الأخطاء ─────────────────────────────────────────────────────────────
    'error.not_found': 'هذا السجل لم يعد موجودًا.',
    'error.conflict': 'هذا التغيير يتعارض مع الحالة الحالية.',
    'error.validation': 'تم رفض الطلب.',
    'error.forbidden': 'لا تملك صلاحية لهذا الإجراء.',
    'error.seat_capacity': 'الدفعة مكتملة العدد.',
    'error.curriculum_frozen': 'نسخة المنهج مثبّتة بدفعة — لم يعد بالإمكان تغيير بنيتها أو أرصدتها أو درجات النجاح. الدروس والمواد والموجزات تبقى قابلة للتعديل.',
    'error.instructor_delisted': 'أنت المدرّب المعيَّن، لكن صفتك مشطوبة. إعادة الاعتماد تعيد صلاحية التأليف.',
    'error.cohort_closed': 'هذه الدفعة مكتملة أو ملغاة — محتوى تقديمها للقراءة فقط.',
    'error.quiz_unconfigured': 'هذا الاختبار غير جاهز بعد — أخبر المنسّق.',
    'error.requirements_unmet': 'لم يُستوفَ حدّ البرنامج.',
    'error.program_unconfigured': 'لا وحدات إلزامية في هذا البرنامج، فلا يوجد حدّ يُصدَر الاعتماد على أساسه.',
    'error.already_enrolled': 'هذا الشخص مسجّل بالفعل في تلك الدفعة.',
    'error.not_confirmable': 'هذا التقييم ليس في حالة تسمح بالاعتماد.',
    'error.ai_unavailable': 'الصياغة بالذكاء الاصطناعي غير متاحة.',
    'error.ai_quota_reached': 'تم بلوغ حد استخدام الذكاء الاصطناعي لهذه الفترة. يرجى المحاولة لاحقًا، أو المتابعة يدويًا.',
    'error.artifact_unavailable': 'تخزين الملفات غير مُعدّ في هذا النشر.',
    'error.live_unavailable': 'الفصول المباشرة غير مُعدّة في هذا النشر.',
    'error.credential_lapsed': 'انتهت صلاحية هذه الشهادة.',
    'error.stale_write': 'قام شخص آخر بالحفظ أولًا. أعد التحميل، ثم أعد تطبيق التعديل واحفظ.',
    'error.idempotency_mismatch': 'لا يمكن إعادة إرسال هذا الطلب. أعد تحميل الصفحة وابدأ من جديد.',
    'error.actor_unmatched': 'حسابك غير مرتبط بسجل شخص. اطلب من المسؤول ربطه.',

    'error.unauthenticated': 'جلستك غير صالحة. سجّل الدخول مجددًا.',
    'error.rate_limited': 'عدد كبير من الطلبات. انتظر قليلًا.',
    'error.model_binding': 'رُفضت بعض الحقول قبل وصول الطلب إلى الخادم.',
    'error.network': 'تعذّر الوصول إلى الخادم.',

    'error.pageNotFound': 'تعذّر العثور على هذه الصفحة.',

    // ─── الاتصال ─────────────────────────────────────────────────────────────
    'connection.noInternetDesc': 'تحقّق من الشبكة ثم أعد المحاولة.',
    'connection.serverUnreachable': 'تعذّر الوصول إلى الأكاديمية',
    'connection.retry': 'إعادة المحاولة',
    'connection.retryFailed': 'ما زال غير متاح.',

    // ─── التحقق من المدخلات ──────────────────────────────────────────────────
    'validation.fieldRequired': '{field} مطلوب',
    'validation.emailInvalid': 'أدخل بريدًا إلكترونيًا صالحًا',
    'validation.nameMinLength': 'يجب ألا يقل {field} عن حرفين',
    'validation.nameLettersOnly': 'يمكن أن يحتوي {field} على حروف ومسافات وشرطات وفواصل عليا فقط',
    'validation.nameLatin': 'أدخل الاسم بالأحرف الإنجليزية (اللاتينية) — تصدر الشهادات بالإنجليزية وتطبع الاسم تمامًا كما هو مكتوب هنا.',
    'validation.minLength': 'يجب ألا يقل عن {min} حرفًا',
    'validation.maxLength': 'يجب ألا يزيد عن {max} حرفًا',
    'validation.invalidNumber': 'يجب أن يكون {field} رقمًا صالحًا',
    'validation.fieldPositive': 'يجب أن يكون {field} أكبر من صفر',
    'validation.fieldDate': 'يجب أن يكون {field} تاريخًا صالحًا',
    'validation.invalidPhone': 'أدخل رقم هاتف صالحًا',
    'phone.countryLabel': 'الدولة ومفتاح الاتصال',
    'phone.numberPlaceholder': 'رقم الهاتف',
    'phone.noCountry': 'بدون دولة',
    'validation.invalidUrl': 'أدخل رابطًا صالحًا',
    'validation.fileType': 'يجب أن يكون نوع الملف أحد التالي: {types}',
    'validation.fileSize': 'يجب أن يكون حجم الملف أقل من {size} ميغابايت',

    // ─── مكوّنات الواجهة ─────────────────────────────────────────────────────
    'search.placeholder': 'بحث…',
    'search.group.screens': 'الشاشات',
    'search.group.tabs': 'التبويبات',
    'search.group.people': 'الأشخاص',
    'search.group.cohorts': 'الدفعات',




    'date.pick': 'اختر تاريخًا',
    'date.today': 'اليوم',
    'date.tomorrow': 'غدًا',
    'date.yesterday': 'أمس',

    'uploadForm.chooseFile': 'اختر ملفًا',
    'uploadForm.dropFile': 'أفلت الملف هنا',
    'uploadForm.uploadFile': 'رفع',
    'uploadForm.downloadTemplate': 'تنزيل القالب',
    'uploadForm.templateText': 'استخدم القالب حتى تتطابق الأعمدة.',

    // ─── مكوّنات المجال — حالات دورة الحياة ─────────────────────────────────
    'state.draft': 'مسودة',
    'state.filling': 'قيد التعبئة',
    'state.confirmed': 'مؤكَّد',
    'state.running': 'جارٍ',
    'state.completed': 'مكتمل',
    'state.cancelled': 'ملغى',
    'state.invited': 'مدعو',
    'state.active': 'نشط',
    'state.withdrawn': 'منسحب',
    'state.failed': 'راسب',
    'state.awaitingInstructor': 'بانتظار المدرّب',
    'state.returned': 'معاد',
    'state.expired': 'منتهي الصلاحية',
    'state.revoked': 'مسحوب',
    'state.superseded': 'مستبدَل',
    'state.submitted': 'مُقدَّم',
    'state.approved': 'مقبول',
    'state.rejected': 'مرفوض',
    'state.awaitingApproval': 'بانتظار الاعتماد',
    'state.pending': 'قيد الانتظار',
    'state.passed': 'ناجح',
    'state.notReady': 'غير جاهز',
    'state.conditionallyReady': 'جاهز بشروط',
    'state.ready': 'جاهز',
    'state.notStarted': 'لم يبدأ',
    'state.inProgress': 'قيد التقدم',
    'state.notAttempted': 'لم يُحاوَل',
    'state.waived': 'مُعفى',

    // ─── مكوّنات المجال — نتائج الدُفعات ────────────────────────────────────
    'batch.allSucceeded': 'نجحت جميع العناصر ({count})',
    'batch.partialFailure': 'فشل {failed} من أصل {total} عنصرًا',

    // ─── مكوّنات المجال — تعارض الحفظ ───────────────────────────────────────
    'staleWrite.title': 'قام شخص آخر بالحفظ أولًا',
    'staleWrite.hint': 'أعد التحميل للحصول على نسخته — تبقى تعديلاتك غير المحفوظة في النموذج لتراجعها وتحفظ مجددًا.',
    'staleWrite.reload': 'إعادة تحميل السجل',

    'problem.traceId': 'معرّف التتبّع: {traceId}',

    // ─── مكوّنات المجال — الكفاءة ───────────────────────────────────────────
    'competency.trainingProgress': 'تقدّم التدريب',
    'competency.trainingProgressHint': 'محتوى مُستهلَك — ليس ادعاء كفاءة',
    'competency.passedCreditRatio': 'نسبة الساعات المجتازة',
    'competency.passedCreditRatioHint': 'الساعات المجتازة من الساعات القابلة للتقييم',
    'competency.mandatoryOutstanding': 'ما زالت هناك وحدات إلزامية غير مكتملة.',
    'competency.noModulesOnTrack': 'لا وحدات في هذا المسار',
    'competency.progressShort': 'التقدّم',
    'competency.passedShort': 'المجتاز',
    'competency.modulesShort': 'الوحدات',
    'competency.noModules': 'لا وحدات بعد',
    'competency.noModulesHint': 'برنامج الفوج لا يتضمن وحدات بعد. تظهر صفوف الوحدات بعد إعداد البرنامج.',
    'competency.module': 'الوحدة',
    'competency.completion': 'الإكمال',
    'competency.assessment': 'التقييم',
    'competency.bestScore': 'أفضل درجة',
    'competency.credits': 'الساعات',
    'competency.notAssessedModule': 'غير مُقيَّمة',

    // ─── مكوّنات المجال — حدّ البرنامج ───────────────────────────────────────────
    'programBar.title': 'حدّ البرنامج',
    'programBar.meets': 'يستوفي حدّ البرنامج',
    'programBar.notYet': 'ليس بعد',
    'programBar.unconfigured': 'لا حدّ محدَّد',
    'programBar.unconfiguredHint': 'لا وحدات إلزامية في هذا البرنامج، فلا يوجد حدّ لاستيفائه بعد. يحدّده المسؤول على البرنامج.',
    'programBar.unmetHeading': 'ما زال مطلوبًا',
    'programBar.unmetCount': '{count} وحدة متبقية',
    'programBar.reasonNotPassed': 'لم يُجتَز',
    'programBar.reasonScore': 'الدرجة {actual} أقل من {required}',
    'programBar.reasonNoScore': 'لا درجة بعد (المطلوب {required})',
    'programBar.reasonCapstone': 'المشروع التطبيقي مفقود',

    // ─── ترقيم المؤشر ────────────────────────────────────────────────────────

    // ─── أعمدة سجل الدفعات ───────────────────────────────────────────────────
    'cohort.code': 'الرمز',
    'cohort.program': 'البرنامج',
    'cohort.market': 'الدولة',
    'cohort.state': 'الحالة',
    'cohort.fill': 'المقاعد',
    'cohort.startsOn': 'يبدأ',
    'cohort.instructor': 'المدرّب',
    'cohort.searchPlaceholder': 'ابحث في الدفعات بالرمز أو البرنامج…',
    'cohort.stateAll': 'كل الحالات',
    'cohort.unstaffedOnly': 'بلا مدرّب بعد',
    'cohort.noneMatch': 'لا دفعة مطابقة',
    'cohort.noneMatchHint': 'امسح البحث أو المرشّحات لرؤية السجل كاملًا.',
    'cohort.statTotal': 'الدفعات',
    'cohort.statRunning': 'قيد التنفيذ',
    'cohort.statFilling': 'قيد التعبئة',
    'cohort.statUnstaffed': 'بلا مدرّب',

    // ─── ملف المتدرب 360 ─────────────────────────────────────────────────────
    'trainee.title': 'ملف المتدرب 360',
    'trainee.enrolledAt': 'سُجّل {date}',
    'trainee.dimensions': 'الأبعاد',
    'trainee.modules': 'الوحدات',

    // ─── تفاصيل التسجيل ──────────────────────────────────────────────────────
    'enrollment.title': 'التسجيل',
    'enrollment.completedAt': 'اكتمل {date}',
    'enrollment.dualCredit': 'ساعات مزدوجة',

    // ─── الأشخاص ─────────────────────────────────────────────────────────────
    'person.fullName': 'الاسم',
    'person.fullNameLatinHint': 'بالأحرف الإنجليزية، تمامًا كما ينبغي أن يظهر على الشهادات.',
    'person.email': 'البريد الإلكتروني',
    'person.market': 'الدولة',
    'person.preferredLanguage': 'اللغة المفضلة',
    'person.kindLearner': 'المتدربون',
    'person.kindManager': 'مسؤولو الشركات',
    'person.kindInstructor': 'المدربون',
    'person.kindUnaffiliated': 'غير مرتبطين',
    'person.statTotal': 'الأشخاص',
    'person.statLearners': 'المتعلّمون',
    'person.statInstructors': 'المدرّبون',
    'person.statUnaffiliated': 'غير مرتبطين',
    'person.company': 'الشركة',
    'person.profiles': 'الملفات',
    'person.learner': 'متدرب',
    'person.instructor': 'مدرّب',
    'person.identity': 'هوية تسجيل الدخول',
    'person.identityLinked': 'مرتبطة',
    'person.identityNotLinked': 'غير مرتبطة — لا أحد يستطيع تسجيل الدخول بهذا الشخص',
    // ─── واردات ─────────────────────────────────────────────────────────
    'arrivals.subtitleHrm': 'ما كلّفت به الموارد البشرية — موظفون داخليون أُرسلوا للتدريب أو سُمّوا مدرّبين. أصدر تسجيل دخولهم ثم ضع المتعلمين في دفعة.',
    'arrivals.subtitle': 'ما سلّمه — تحقّق من الشخص أو الشركة، وأصدر بيانات دخولهم، ثم سجّلهم بناءً على العرض المؤكد.',
    'arrivals.total': 'الوافدون',
    'arrivals.totalHint': 'كل الأبواب، ضمن الفلتر الحالي',
    'arrivals.awaitingAdmissionCount': 'بانتظار القبول',
    'arrivals.awaitingAdmissionHint': 'تم تحصيل الدفعة، القبول بحاجة لنقرة',
    'arrivals.notPlacedCount': 'لم يُوزَّع بعد',
    'arrivals.notPlacedHint': 'يمكنه تسجيل الدخول، ولا ينتمي لأي فوج',
    'arrivals.loginIssuedCount': 'تم منح الوصول',
    'arrivals.loginIssuedHint': 'من أصل {total} معروضين',
    'arrivals.received': 'تاريخ الوصول',
    'arrivals.who': 'مَن',
    'arrivals.kind': 'الحساب',
    'arrivals.person': 'شخص',
    'arrivals.company': 'شركة',
    'arrivals.instructor': 'مدرّب',
    'arrivals.learner': 'متعلم',
    'arrivals.role': 'وصل بصفة',
    'arrivals.sourceAll': '\u0643\u0644 \u0627\u0644\u0645\u0635\u0627\u062f\u0631',
    'arrivals.sourceCrm': '\u0645\u0646 \u0627\u0644\u0645\u0628\u064a\u0639\u0627\u062a',
    'arrivals.sourceHrm': '\u0645\u0646 \u062c\u0647\u0629 \u0627\u0644\u0639\u0645\u0644',
    'arrivals.sourceAcademy': '\u0634\u0631\u0627\u0621 \u0645\u0628\u0627\u0634\u0631',
    'arrivals.all': 'الكل',
    'arrivals.people': 'أشخاص',
    'arrivals.companies': 'شركات',
    'arrivals.universities': 'جامعات',
    'arrivals.university': 'جامعة',
    'arrivals.seats': '{count} مقاعد',
    'arrivals.deal': 'الصفقة',
    'arrivals.access': 'الدخول',
    'arrivals.loginIssued': 'صدر الدخول',
    'arrivals.placed': 'مُلحق بـ',
    'arrivals.seatsPlaced': '{placed} من {seats} مقعدًا مُلحقة',
    'arrivals.notPlaced': 'لم يُلحق بعد',
    'arrivals.notPlacedYet': 'لم يُلحق بأي مجموعة بعد — ألحقه قبل تسجيل الدخول، وإلا لن يجد ما يحضره.',
    'arrivals.invited': 'تمت الدعوة',
    'arrivals.offer': 'العرض',
    'arrivals.searchPlaceholder': 'ابحث بالاسم أو البريد أو الصفقة…',
    'arrivals.empty': 'لا واردات بعد',
    'arrivals.emptyHint': 'الاستفسارات المحوّلة والصفقات المكسوبة تصل هنا فور حدوثها.',
    'arrivals.emptyHintHrm': 'الموظفون الذين تكلّفهم الموارد البشرية بالتدريب — أو تسمّيهم مدرّبين — يصلون هنا فور حدوث ذلك.',
    'arrivals.offerTitle': 'العرض — {name}',
    'arrivals.requirements': 'المتطلبات',
    'arrivals.programs': 'البرامج',
    'arrivals.modules': 'الوحدات',
    'arrivals.moduleVerified': 'مُتحقق منها',
    'arrivals.moduleUnverified': 'غير مُتحقق منها',
    'arrivals.attachments': 'المرفقات (محفوظة في)',
    'arrivals.offerEmpty': 'العرض لا يحمل تفاصيل منظّمة.',

    'person.emptyList': 'لا أشخاص بعد',
    'person.searchPlaceholder': 'ابحث بالاسم أو البريد الإلكتروني…',
    'person.newArrival': 'جديد',
    'person.newArrivalsBanner': '{count} واردون جدد بانتظار بيانات دخولهم — راجعهم.',
    'person.signInAccess': 'الدخول إلى الحساب',
    'person.signInActive': 'يستطيع الدخول',
    'person.signInNone': 'لا دخول بعد',
    'person.signInActiveHint': 'لهذا الشخص حساب ويسجّل الدخول ببريده الإلكتروني.',
    'person.signInNoneHint': 'أصدر بيانات الدخول لإنشاء حسابه: يحصل على بريده الإلكتروني وكلمة مرور مؤقتة تُغيَّر عند أول دخول.',
    'person.signInNoneAutoLink': 'عند تسجيل دخول هذا الشخص، سيُربط تلقائيًا عبر بريده الإلكتروني.',
    'person.issueSignIn': 'إصدار دخول',
    'person.resetSignIn': 'إعادة تعيين كلمة المرور',
    'person.signInIssuedLead': 'حساب {email} جاهز. كلمة المرور المؤقتة:',
    'person.copy': 'نسخ',
    'person.copied': 'تم النسخ',
    'person.signInEmailQueued': 'أُرسلت البيانات نفسها إليه بالبريد.',
    'person.signInIssuedOnce': 'تظهر كلمة المرور هذه المرة فقط ويجب تغييرها عند أول تسجيل دخول.',
    'person.identityAdvanced': 'متقدم: ربط هوية موجودة',
    'person.emptyListHint': 'يُنشأ الأشخاص باعتماد طلب تسجيل أو مباشرة من مكتب التسجيل.',
    'person.learnerProfile': 'ملف المتدرب',
    'person.instructorProfile': 'ملف المدرّب',
    'person.upgradedAt': 'تمت الترقية',
    'person.crmAccount': 'حساب',
    'person.tier': 'الفئة',
    'person.nps': 'مؤشر الرضا',
    'person.certifiedAt': 'اعتُمد',
    'person.delistedAt': 'أُلغي إدراجه',
    'person.instructorInactive': 'غير نشط',
    'person.noProfiles': 'لا ملف متدرب ولا مدرّب — شكل اعتيادي لموظف إداري.',
    'person.tabProfile': 'الملف',
    'person.tabCredentials': 'الشهادات',

    'learnerTrack.internalHire': 'توظيف داخلي',
    'learnerTrack.external': 'خارجي',
    'instructorKind.founder': 'مؤسِّس',
    'instructorKind.dualHat': 'مزدوج المهام',
    'instructorKind.certifiedTrainer': 'مدرّب معتمد',
    'trainerTier.associate': 'مشارك',
    'trainerTier.professional': 'محترف',
    'trainerTier.master': 'خبير',

    // ─── الشهادات (عرض الحامل) ───────────────────────────────────────────────
    'credential.emptyForHolder': 'لا شهادات',
    'credential.emptyForHolderHint': 'تظهر هنا الشهادات الصادرة لهذا الشخص، بما فيها المسحوبة والمنتهية.',
    'credential.issuedOn': 'صدرت',
    'credential.validUntil': 'صالحة حتى',

    // ─── الجاهزية (تبويب الشخص) ──────────────────────────────────────────────

    // ─── سجل التدقيق ─────────────────────────────────────────────────────────
    'availability.title': 'توافر المدربين',
    'availability.subtitle': 'الغيابات المعتمدة كما يذكرها نظام الموارد البشرية. لا شيء هنا يمنع الحجز — الجلسة فوق غياب تحذير يُقرأ، لا كتابة مرفوضة.',
    'availability.from': 'من',
    'availability.to': 'إلى',
    'availability.person': 'الشخص',
    'availability.startDate': 'أول يوم غياب',
    'availability.endDate': 'آخر يوم غياب',
    'availability.statedAt': 'ذُكر في',
    'availability.statTotal': 'الغيابات ضمن النطاق',
    'availability.statCurrentlyAway': 'غائبون اليوم',
    'availability.statInstructors': 'المدربون المتأثرون',
    'availability.statUnlinked': 'غير مرتبطين بأحد هنا',
    'availability.notLinked': 'غير مرتبط بأحد هنا',
    'availability.lastApplied': 'آخر تسليم {when} ({ago})، وذُكر {count} غيابًا.',
    'availability.empty': 'لا أحد غائب في هذه المدة',
    'availability.emptyHint': 'التغذية وصلت — هذه مدة هادئة، لا مدة مفقودة.',
    'availability.neverDelivered': 'لم يُسلَّم أي غياب قط',
    'availability.neverDeliveredHint': 'لم يذكر نظام الموارد البشرية أي غياب لهذه الأكاديمية قط، فالقائمة الفارغة هنا لا تعني شيئًا.',

    // ─── كتابة بيانات الأشخاص ────────────────────────────────────────────────
    'person.emailOptional': 'اختياري — يمكن أن يوجد شخص بدون بريد.',
    'person.marketHint': 'دولة الشخص.',
    'person.clearableHint': 'اتركه فارغًا واحفظ لمسح هذا الحقل — المسح يكتب NULL عن قصد.',
    'person.clearField': 'مسح',
    'person.noLearnerProfile': 'لا ملف متدرب. إرفاقه هو ما يجعل هذا الشخص قابلًا للتسجيل.',
    'person.noInstructorProfile': 'لا ملف مدرّب. يُعيَّن المدرّبون من نظام الموارد البشرية، لا من هذه الشاشة.',
    'person.learnerTrack': 'المسار',
    'person.crmAccountHint': 'معرّف حساب اختياري لمتدرب مؤسسي.',
    'person.identityLink': 'ربط هوية تسجيل الدخول',
    'person.identityLinkedTo': 'مرتبطة بمعرّف الهوية',
    'person.identityUserId': 'معرّف الهوية',
    'person.identityLinkHint': 'يسجّل من هو صاحب الرمز. لا يمنح شيئًا — الأدوار في Keycloak. وهو أيضًا حل مشكلة "الحساب غير مرتبط".',
    'person.linkIdentity': 'ربط',
    'person.rateInstructor': 'تقييم المدرّب',
    'person.ratingCohort': 'معرّف الدفعة',
    'person.ratingScore': 'الدرجة (0–10)',
    'person.ratingScoreHint': 'إضافة فقط: التصحيح تقييم جديد، لا تعديل.',
    'person.ratingComment': 'تعليق',
    'person.ratingSource': 'المصدر',
    'person.submitRating': 'إرسال التقييم',
    'person.recordAudit': 'تسجيل تدقيق',
    'person.auditReviewedAt': 'تاريخ المراجعة',
    'person.auditOutcome': 'النتيجة',
    'person.auditDelistWarning': 'إلغاء الإدراج يختم ملف المدرّب أيضًا، في المعاملة نفسها.',
    'person.auditFindings': 'الملاحظات',
    'person.submitAudit': 'تسجيل النتيجة',

    'inputSource.instructor': 'مدرّب',
    'inputSource.lms': 'نظام التعلم',
    'inputSource.import': 'استيراد',
    'inputSource.selfReported': 'تصريح ذاتي',
    'auditOutcome.passed': 'ناجح',
    'auditOutcome.coached': 'توجيه',
    'auditOutcome.downTiered': 'خفض فئة',
    'auditOutcome.delisted': 'إلغاء إدراج',

    // ─── الدفعات ─────────────────────────────────────────────────────────────
    'cohort.create': 'دفعة جديدة',
    'cohort.emptyListHint': 'أنشئ أول دفعة لبدء ملء المقاعد.',
    'cohort.availability': 'التوفر',
    'cohort.seatsAvailable': '{count} مقاعد متاحة',
    'cohort.notAccepting': 'لا تقبل',
    'cohort.curriculum': 'المنهج',
    'cohort.selectCurriculumFirst': 'اختر المنهج أولاً.',
    'cohort.curriculumVersion': 'إصدار المنهج',
    'cohort.currentVersion': '{label} (الحالي)',
    'cohort.pinFreezesVersion': 'إنشاء هذه الدفعة يثبّت إصدار المنهج المحدد ويجمّد بنيته — تُرفض تعديلات المستويات والوحدات والأرصدة ودرجات النجاح بعدها. الدروس والمواد وموجزات التكليف تبقى قابلة للتعديل.',
    'cohort.format': 'الصيغة',
    'cohort.sourcing': 'المصدر',
    'cohort.deliveryLayer': 'طبقة التقديم',
    'cohort.seats': 'المقاعد',
    'cohort.statFilled': 'ممتلئة',
    'cohort.statFilledOf': '{filled} من {seats}',
    'cohort.statActive': 'نشطون',
    'cohort.statFinished': 'منتهون',
    'cohort.statSeatsOpen': 'مقاعد متاحة',
    'cohort.seating': 'مكان التدريس',
    'cohort.seatingHint': 'قاعة مَن وأجهزة مَن. لا يُبلَّغ سجل الأصول بمقاعد المعمل إلا للدفعات التي تُدرَّس في مقارّنا.',
    'cohortSeating.unstated': 'غير محدد',
    'cohortSeating.remote': 'عن بُعد',
    'cohortSeating.academyPremises': 'مقارّنا',
    'cohortSeating.clientPremises': 'مقر العميل',
    'cohort.endsOn': 'ينتهي',
    'cohort.instructorOptional': 'اختياري — دفعة مسودة بلا مدرّب أمر طبيعي.',
    'cohort.versionNotEditable': 'مثبّتة على {label}. إصدار المنهج غير قابل للتعديل عمدًا — إعادة التثبيت تعيد تقييم المتدربين.',
    'cohort.moveTo': 'نقل إلى:',
    'cohort.viewList': 'قائمة',
    'cohort.viewBoard': 'لوحة',
    'cohort.boardDropHere': 'أفلت الدفعات هنا',
    'cohort.moveToAria': 'نقل {code} إلى حالة أخرى',
    'cohort.everyoneFinished': 'أنهى جميع المتعلّمين ({count}). هل تريد إغلاق هذه الدفعة؟',
    'cohort.everyoneFinishedShort': 'أنهى كل متعلّم',
    'cohort.completeNow': 'إكمال الدفعة',
    'cohort.confirmTransition': 'تأكيد النقل',
    'cohort.transitionCopy': 'نقل {code} إلى',
    'cohort.cancelWarning': 'الإلغاء نهائي. لا يمكن إعادة فتح الدفعة.',
    'cohort.confirmMove': 'تأكيد',
    'cohort.assignInstructor': 'تعيين مدرّب',
    'cohort.currentInstructor': 'حاليًا: {name}',
    'cohort.assign': 'تعيين',
    'cohort.linkCrmAccount': 'ربط شركة',
    'cohort.crmAccountId': 'معرّف حساب الشركة',
    'cohort.crmAccountPick': 'الشركة أو الجامعة',
    'cohort.selectCompany': 'اختر شركة أو جامعة...',
    'cohort.noCompaniesYet': 'لا شركات بعد — أنشئ واحدة أولاً',
    'cohort.crmAccountPickHint': 'اختيار حساب يملأ المعرّف أدناه ويقترح الدور؛ ويمكنك تغيير أيٍّ منهما.',
    'cohort.crmRole': 'الدور',
    'cohort.link': 'ربط',
    'cohort.crmAccount': 'الشركة',
    'cohort.tabOverview': 'نظرة عامة',
    'cohort.tabEnrollments': 'التسجيلات',
    'cohort.tabContent': 'المحتوى',
    'cohort.tabEngagement': 'التفاعل',

    'cohortFormat.corporateBootcamp': 'معسكر مؤسسي',
    'cohortFormat.openEnrollment': 'تسجيل مفتوح',
    'cohortFormat.universityDiploma': 'دبلوم جامعي',
    'cohortFormat.selfPacedLms': 'تعلم ذاتي',
    'cohortFormat.certificationPrep': 'تحضير للشهادة',
    'cohortFormat.executiveMasterclass': 'ماستركلاس تنفيذي',
    'cohortFormat.recruitmentLinked': 'مرتبط بالتوظيف',
    'cohortSourcing.academySourced': 'من الأكاديمية',
    'cohortSourcing.selfSourced': 'مصدر ذاتي',
    'crmRole.corporateClient': 'عميل مؤسسي',
    'crmRole.universityPartner': 'شريك جامعي',

    // ─── التسجيل في الدفعات ──────────────────────────────────────────────────
    'enroll.title': 'تسجيل في {code}',
    'enroll.learner': 'المتدرب',
    'enroll.submit': 'تسجيل',
    'enroll.offerAnotherCohort': 'ابحث عن دفعة أخرى بمقاعد متاحة',
    'enroll.goToExisting': 'افتح سجل هذه الدفعة',
    'enroll.learnersArriveFromTheCrm': 'يصل المتدربون من صفقة محوّلة، أو من شركة تضيف موظفًا إلى سجلها. لا توجد طريقة لإنشاء متدرب من هذه الشاشة.',
    'enroll.batch': 'تسجيل جماعي',
    'enroll.batchTitle': 'تسجيل جماعي',
    'enroll.addLearner': 'إضافة متدرب',
    'enroll.batchSubmit': 'تسجيل {count} متدربًا',
    'enroll.emptyRegister': 'لا أحد مسجّل بعد',
    'enroll.emptyRegisterHint': 'سجّل متدربًا، أو اعتمد طلب تسجيل يسمّي هذه الدفعة.',
    'enroll.enrolledAt': 'سُجّل',
    'enroll.detail': 'الكفاءة',
    'enroll.openDetail': 'فتح',
    'enrollmentsQueue.lead': 'كل الوحدات مكتملة والتسجيل ما زال نشطًا — افتح المتعلّم لإغلاق تسجيله، أو الدفعة لإغلاق الصف كله.',
    'enrollmentsQueue.empty': 'لا أحد بانتظار الإغلاق',
    'enrollmentsQueue.emptyHint': 'يظهر المتعلّم هنا فور اكتمال وحدته الأخيرة.',
    'enrollmentsQueue.totalWaiting': 'بانتظار الإغلاق',
    'enrollmentsQueue.totalWaitingHint': 'اكتملت كل الوحدات، ولم يُغلق بعد',
    'enrollmentsQueue.dualCreditWaiting': 'بانتظار الاعتماد الجامعي',
    'enrollmentsQueue.dualCreditWaitingHint': 'شهادة جامعية مرتبطة بهؤلاء',
    'enrollmentsQueue.oldestWaiting': 'الأطول انتظارًا',
    'enrollmentsQueue.oldestWaitingHint': 'سُجِّل {when}',
    'enrollmentsQueue.noneWaiting': 'لا أحد بالانتظار',
    'enroll.moveTo': 'نقل إلى:',
    'enroll.confirmTransition': 'تأكيد النقل',
    'enroll.transitionCopy': 'نقل {name} إلى',
    'enroll.occurredAt': 'تاريخ الحدوث',
    'enroll.occurredAtHint': 'متى حدث فعلًا — لا متى كُتب.',
    'enroll.reevaluate': 'إعادة تقييم',
    'enroll.reevaluateHint': 'فرض تقييم كفاءة جديد بعد تغييرات خارجية.',

    // ─── مفردات الدُفعات ─────────────────────────────────────────────────────
    'batch.mode': 'وضع الدفعة',
    'batch.chooseMode': 'اختر سلوك الإخفاقات…',
    'batch.modeHint': 'أفضل جهد افتراضيًا: سجّل من يمكن تسجيله واذكر من تعذّر. الكل-أو-لا-شيء يُلغي الدفعة كلها عند أول رفض.',
    'batch.atomic': 'ذرّي — الكل أو لا شيء',
    'batch.atomicHint': 'رفض واحد يتراجع عن الدفعة كلها. لم يُكتب شيء.',
    'batch.bestEffort': 'أفضل جهد — نتائج لكل عنصر',
    'batch.bestEffortHint': 'كل عنصر ينجح أو يفشل وحده؛ راجع النتائج أدناه.',

    // ─── تسجيل الإكمال ───────────────────────────────────────────────────────
    'completion.title': 'تسجيل إكمال',
    'completion.module': 'الوحدة',
    'completion.pct': 'نسبة الإكمال %',
    'completion.pctHint': '0–100 هنا؛ لا حقل درجة — النجاح يأتي من تأكيد تقييم.',
    'completion.state': 'الحالة',
    'completion.source': 'المصدر',
    'completion.note': 'ملاحظة',
    'completion.submit': 'تسجيل',
    'completionBatch.title': 'استيراد إكمال جماعي',
    'completionBatch.hint': 'الصق صفوف CSV بصيغة تصدير نظام التعلم. صف العناوين اختياري؛ تُتحقق الصفوف قبل الإرسال.',
    'completionBatch.invalidLine': 'سطر',
    'completionBatch.skippedRows': 'سيُتجاهل {count} صفًا:',
    'completionBatch.parsed': 'تم تحليل {count} صفًا وجاهزة.',
    'completionBatch.submit': 'استيراد {count} صفًا',

    // ─── الإعفاء ─────────────────────────────────────────────────────────────
    'waive.title': 'إعفاء وحدة',
    'waive.signerNote': 'الإعفاء يحل محل النجاح بالسلطة لا بالدرجة. أنت الموقّع — يحمل السجل هويتك من الرمز.',
    'waive.reason': 'السبب',
    'waive.reasonHint': 'مطلوب. تعلم سابق معترف به، تحويل ساعات — السبب هو السجل.',
    'waive.nothingToWaive': 'كل الوحدات ناجحة أو معفاة بالفعل.',
    'waive.submit': 'إعفاء',

    // ─── نوع الطلب (نموذج التسجيل العام) ─────────────────────────────────────
    'registration.kind.learner': 'متدرب',
    'registration.kind.instructor': 'مدرّب',

    // ─── التسجيل العام ───────────────────────────────────────────────────────
    'register.title': 'التقديم إلى الأكاديمية',
    'register.subtitle': 'عرّفنا بنفسك وسيتواصل معك فريقنا. التقديم لا ينشئ حسابًا — ولا يُجهَّز لك شيء قبل التحدث معك.',
    'register.emailHint': 'نرد على هذا البريد، ويُطابَق به تسجيل الدخول لاحقًا — استخدم بريدًا تملكه.',
    'register.kind': 'أتقدم بصفة',
    'register.message': 'هل من شيء نودّ معرفته؟ (اختياري)',
    'register.messageHint': 'ما ترغب في تعلّمه أو تدريسه، وخلفيتك، والتوقيت المناسب.',
    'register.submit': 'إرسال الطلب',
    'register.receivedTitle': 'تم استلام الطلب',
    'register.receivedCopy': 'سيقرأه فريقنا ويرد على البريد الذي ذكرته. لا توجد صفحة حالة للمتابعة، ولم يُنشأ شيء باسمك بعد.',

    // ─── المنتقيات ───────────────────────────────────────────────────────────
    'picker.person': 'ابحث في الأشخاص…',
    'picker.noPeople': 'لا أشخاص مطابقين',

    // ─── التقييم ─────────────────────────────────────────────────────────────
    'grading.allKinds': 'الكل',
    'grading.emptyQueue': 'لا شيء بانتظار التقييم',
    'grading.emptyQueueHint': 'الحالة الطبيعية لدفعة تُدار جيدًا — تظهر التسليمات الجديدة هنا.',
    'grading.openDetail': 'فتح',
    'grading.quizzesTab': 'الاختبارات',
    'grading.quizzesEmpty': 'لا توجد اختبارات بانتظار التصحيح',
    'grading.quizzesEmptyHint': 'تظهر الإجابات المكتوبة هنا بعد أن يرسلها المتعلم.',
    'grading.aiCouldNotMark': 'تعذّر على الذكاء الاصطناعي التصحيح',
    'grading.markedByInstructorBadge': 'المدرّب',
    'grading.quizMarkingTitle': 'تصحيح إجابات الاختبار',
    'grading.markMode': 'تصحيح',
    'grading.overrideMode': 'تعديل درجة',
    'grading.overrideBanner': 'تغيير درجة مسجَّلة يُسجَّل في سجل التدقيق.',
    'grading.choiceScoreLine': 'أسئلة الاختيار: {earned} من {possible} نقطة',
    'grading.markingGuide': 'دليل التصحيح',
    'grading.emptyAnswer': '(لم تُقدَّم إجابة)',
    'grading.aiSuggestion': 'يقترح الذكاء الاصطناعي {points} نقطة',
    'grading.useSuggestion': 'استخدام الاقتراح',
    'grading.pointsLabel': 'النقاط (الحد الأقصى {max})',
    'grading.feedbackLabel': 'الملاحظات',
    'grading.saveMarks': 'حفظ الدرجات',
    'grading.aiDraftingInfo': 'الذكاء الاصطناعي يُعِدّ مسودة درجة — يمكنك التقييم الآن أيضًا.',
    'grading.scoreShort': 'الدرجة',
    'grading.detailTitle': 'التقييم',
    'grading.submission': 'التسليم',
    'grading.resubmit': 'إعادة التسليم',
    'grading.resubmitNote': 'حفظ تسليم جديد يمسح كتلة الإرجاع ويعيده إلى قائمة المدرّب.',
    'grading.checks': 'فحوص المعايير',
    'grading.noChecks': 'لا نتائج فحص. بمفردات فارغة يقيّم المدرّبون دون مساعدة — وهذا نظام يعمل.',
    'grading.finalScore': 'الدرجة النهائية',
    'grading.confirm': 'تأكيد الدرجة',
    'grading.confirmerNote': 'أنت المؤكِّد — يحمل السجل هويتك من الرمز.',
    'grading.notConfirmable': 'لم يعد هذا التقييم قابلًا للتأكيد — ربما سبقك شخص آخر.',
    'grading.refreshQueue': 'حدّث القائمة',
    'grading.confirmedScore': 'مؤكَّد: {score}',
    'grading.returnTitle': 'إرجاع إلى المتدرب',
    'grading.returnReason': 'السبب',
    'grading.returnReasonHint': 'مطلوب — السبب هو محتوى حالة الإرجاع؛ بدونه يرى المتدرب «معاد» ولا شيء غيره.',
    'grading.returnConfirm': 'إرجاع',
    'grading.returnedTitle': 'أُعيد إلى المتدرب',
    'grading.returnedBy': 'بواسطة',
    'grading.aiDraft': 'مسودة ذكاء اصطناعي',
    'grading.aiDraftHint': 'تكتب درجة مسودة ونتائج فحص. ليست درجة أبدًا.',
    'grading.aiDraftLabel': 'مسودة ذكاء اصطناعي — ليست درجة',
    'grading.aiDraftScore': 'مسودة الذكاء الاصطناعي: {score}',
    'grading.batchSelected': 'تم اختيار {count} تقييمًا بدرجات',
    'grading.batchConfirm': 'تأكيد {count}',
    'grading.openTitle': 'فتح تقييم',
    'grading.kind': 'النوع',
    'grading.enrollmentModuleId': 'معرّف وحدة التسجيل',
    'grading.enrollmentId': 'معرّف التسجيل',
    'grading.capstoneSpecId': 'معرّف مواصفة المشروع الختامي',
    'grading.capstoneSpecHint': 'مطلوب — مشروع أي مستوى هذا. مشروع غير منسوب لا يمكنه منح شهادة.',
    'grading.artifact': 'المرفق',
    'grading.artifactHint': 'يُرفع مباشرة من المتصفح إلى التخزين بعد فتح التقييم؛ الـ API يوقّع ويسجّل فقط.',
    'grading.openSubmit': 'فتح',
    'grading.openArtifact': 'فتح المرفق',
    'grading.handedInAt': 'سلّمه المتدرّب في {when}',
    'grading.handedInUnrecorded': 'لم يُسجَّل تسليم — فُتح هذا التقييم بواسطة الطاقم.',
    'grading.artifactUploadFailed': 'فشل رفع المرفق — فُتح التقييم بدونه.',
    'grading.openedButArtifactFailed': 'فُتح التقييم، لكن:',

    'assessmentKind.moduleRubric': 'معيار وحدة',
    'assessmentKind.capstone': 'مشروع ختامي',
    'verdict.pass': 'ناجح',
    'verdict.gap': 'فجوة',
    'verdict.fail': 'راسب',
    'verdict.notApplicable': 'لا ينطبق',

    // ─── الشهادات (الإصدار / دورة الحياة) ────────────────────────────────────
    'credential.homeSubtitle': 'إصدار ما تمنحه الأكاديمية والبحث فيه والتحقق منه.',
    'credential.byHolder': 'البحث عن حامل شهادة',
    'credential.pickHolder': 'اختر شخصًا',
    'credential.pickHolderHint': 'الشهادات يحملها أشخاص، فابدأ بالحامل. يظهر سجله كاملًا هنا — بما فيه الملغاة والمنتهية التي لا يعرضها التحقق العام.',
    'credential.publicVerifier': 'فتح صفحة التحقق العامة',
    'credential.detailTitle': 'الشهادة',
    'credential.publicVerify': 'التحقق العام',
    'credential.holder': 'الحامل',
    'credential.holderSnapshot': 'الحامل (عند الإصدار)',
    'credential.holderSnapshotNote': 'اسم الحامل لقطة أُخذت عند الإصدار — تقول الشهادة ما قالته حين طُبعت حتى لو تغيّر اسم الشخص.',
    'credential.program': 'البرنامج',
    'credential.renews': 'تجدّد',
    'credential.previousCredential': 'الشهادة السابقة',
    'credential.noCompetencies': 'لا كفاءات مسجلة على هذه الشهادة.',
    'credential.issueTitle': 'إصدار شهادة',
    'credential.issueModuleTitle': 'شهادة وحدة',
    'credential.issueConfirm': 'إصدار',
    'credential.permanentNote': 'الإصدار فعل عام دائم: تصبح الشهادة قابلة للتحقق دون حساب لحظة وجودها.',
    'credential.programUnconfigured': 'لا حدّ محدَّد لهذا البرنامج',
    'credential.programUnconfiguredCta': 'افتح البرنامج لتحديد وحداته الإلزامية',
    'credential.renewTitle': 'تجديد',
    'credential.renewNote': 'التجديد ينشئ شهادة جديدة؛ تبقى هذه سجلًا تاريخيًا لها.',
    'credential.renewConfirm': 'تجديد',
    'credential.revokeTitle': 'سحب',
    'credential.revokeWarning': 'سحب {publicNo} تصريح عام دائم — المتحقق المجهول سيُظهره لا يخفيه.',
    'credential.revokeReason': 'السبب',
    'credential.revokeConfirm': 'سحب',

    // ─── محرّر وحدات البرنامج ───────────────────────────────────────────────
    'track.moduleId': 'معرّف الوحدة',
    'track.module': 'الوحدة',
    'track.saveWholeSet': 'حفظ كل المتطلبات ({count})',

    // ─── إطار الكفاءات (الحوكمة) ─────────────────────────────────────────────
    'framework.effectiveFrom': 'ساري من',
    'framework.roleTitle': 'العنوان',

    // ─── الجاهزية ────────────────────────────────────────────────────────────

    // ─── المنهج (التنسيق) ────────────────────────────────────────────────────
    'curriculum.versionLabel': 'الإصدار',
    'curriculum.current': 'الحالي',
    'curriculum.frozen': 'مجمّد',
    'curriculum.frozenBadge': 'مجمّد',
    'curriculum.levels': 'المستويات',
    'curriculum.modules': 'الوحدات',
    'curriculum.retiredOn': 'أُحيل',
    'curriculum.retired': 'أُحيل {date}',
    'curriculum.createVersion': 'إصدار جديد',
    'curriculum.emptyList': 'لا إصدارات منهج',
    'curriculum.emptyListHint': 'أنشئ الإصدار الذي ستثبّته الدفعات.',
    'curriculum.frozenExplanation': 'ثبّتت دفعةٌ هذا الإصدار فجمّدت بنيته: تُرفض تعديلات المستويات والوحدات والأرصدة ودرجات النجاح (curriculum_frozen) لأنها بأثر رجعي. الدروس والمواد والموجزات تبقى قابلة للتعديل — المحتوى لا يدخل في أي مقام. التغييرات البنيوية مكانها إصدار جديد.',
    'curriculum.createNewVersionCta': 'أنشئ إصدارًا جديدًا بدلًا من ذلك',
    'curriculum.publish': 'نشر',
    'curriculum.retire': 'إحالة',
    'curriculum.createLevel': 'مستوى جديد',
    'curriculum.levelCreated': 'أُنشئ المستوى.',
    'curriculum.levelIdHint': 'يظهر المستوى الجديد في الهيكل أدناه — أضف الوحدات من هناك.',
    'curriculum.levelId': 'معرّف المستوى',
    'curriculum.levelIdPasteHint': 'من إيصال إنشاء المستوى.',
    'curriculum.level': 'المستوى',
    'curriculum.createModule': 'وحدة جديدة',
    'curriculum.codePermanent': 'دائم منذ الإنشاء — تشير إليه المتطلبات ولا يمكن تغييره أبدًا.',
    'curriculum.ordinal': 'الترتيب',
    'curriculum.overview': 'نظرة عامة',
    'curriculum.flagship': 'رائد',
    'curriculum.treeTitle': 'الهيكل',
    'curriculum.noLevels': 'لا مستويات بعد',
    'curriculum.noLevelsHint': 'لا يُنشر الإصدار إلا بعد أن تكون له مستويات — أنشئ الأول.',
    'curriculum.levelOrdinal': 'المستوى {ordinal}',
    'curriculum.levelNoModules': 'لا وحدات في هذا المستوى بعد.',
    'curriculum.creditsShort': '{credits} ساعة',
    'curriculum.capstone': 'المشروع الختامي',
    'curriculum.dimensionsTitle': 'الأبعاد',
    'curriculum.differentiator': 'مُميِّز',
    'curriculum.dimensionNoModules': 'لا وحدات خلف هذا البُعد — فجوة حقيقية، لا مشكلة عرض.',
    'curriculum.dimensionModuleCount': '{count} وحدة/وحدات',
    'curriculum.dimensionNotTaught': 'لا يُدرَّس في {curriculum}.',
    'curriculum.dimensionsNoneTaught': 'لا توجد بعد وحدة في {curriculum} موسومة ببُعد.',
    'curriculum.dimensionsShowUntaught': 'عرض الأبعاد التي لا يدرّسها {curriculum} ({count})',
    'curriculum.dimensionsHideUntaught': 'إخفاء الأبعاد التي لا يدرّسها {curriculum} ({count})',
    'curriculum.codeNotEditable': 'الرمز {code} غير قابل للتعديل عمدًا — محتويات البرامج وكل رسالة متطلب غير مستوفى تشير إليه.',
    'curriculum.retroactiveHint': 'بأثر رجعي — يُرفض بعد تجميد الإصدار.',
    'curriculum.isAssessed': 'مُقيَّمة',
    'curriculum.passScore': 'درجة النجاح',
    'curriculum.assessmentMarking': 'الجهة التي تضع الدرجة الأولى للتقييم',
    'curriculum.assessmentMarkingAiHint': 'الذكاء الاصطناعي يضع مسودة درجة وملاحظات، والمدرب يعتمدها دائمًا.',
    'curriculum.assessmentMarkingNoCodesHint': 'مسودات الذكاء الاصطناعي تحتاج إلى رموز تحقق. أضفها في',
    'curriculum.checkCodesLinkLabel': 'رموز التحقق',
    'curriculum.assessmentMarkingNoCodesAskAdmin': 'مسودات الذكاء الاصطناعي تحتاج إلى رموز تحقق — اطلب من مسؤول النظام إضافتها.',
    'curriculum.assessed': 'مُقيَّمة · نجاح ≥ {score}',
    'curriculum.notAssessed': 'غير مُقيَّمة — تغذي التقدم فقط، لا الإتقان',
    'curriculum.dimensions': 'الأبعاد',
    'curriculum.tools': 'المهارات والأدوات',
    'curriculum.noCodes': 'لا رموز بعد.',

    // ─── المناهج: برامج الدراسة نفسها ────────────────────────────────────────
    'curriculum.curriculum': 'المنهج',
    'curriculum.curricula': 'المناهج',
    'curriculum.curriculaHint': 'برامج الدراسة التي تدرّسها الأكاديمية.',
    'curriculum.allCurricula': 'كل المناهج',
    'curriculum.createCurriculum': 'منهج جديد',
    'curriculum.curriculumCode': 'الرمز',
    'curriculum.curriculumCodeHint': 'قصير وبأحرف كبيرة ودائم منذ الإنشاء — تشير إليه التقارير والمتطلبات.',
    'curriculum.curriculumName': 'الاسم',
    'curriculum.curriculumSummary': 'نبذة',
    'curriculum.curriculumSummaryHint': 'جملة أو جملتان للصفحة العامة.',
    'curriculum.createCurriculumNext': 'لا يدرّس المنهج شيئًا حتى يصير له إصدار بمستويات ووحدات. أنشئ إصدارًا تاليًا — وإن كانت هذه المادة تبدأ من مادة قائمة، فانسخ بنيتها.',
    'curriculum.versionCount': '{count} إصدار',
    'curriculum.noCurricula': 'لا مناهج',
    'curriculum.noCurriculaHint': 'أنشئ برنامج الدراسة الذي تتفرّع عنه الإصدارات والدفعات.',
    'curriculum.deleteCurriculum': 'حذف المنهج',
    'curriculum.deleteCurriculumConfirm': 'حذف {name}؟ لا يُحذف إلا منهج بلا إصدارات — أي لم يُدرَّس تحته شيء.',
    'curriculum.editCurriculum': 'تعديل المنهج',
    'curriculum.curriculumCodeLocked': 'يُحدَّد مرة واحدة ولا يتغير — التقارير والمتطلبات تشير إليه. المنهج ذو الرمز الخاطئ يُحذف ما دام بلا إصدارات، ثم يُنشأ من جديد.',
    'curriculum.curriculumOrdinal': 'ترتيب العرض',
    'curriculum.curriculumOrdinalHint': 'الأصغر يظهر أولًا، هنا وفي الصفحة العامة. لا بد لأحد أن يحدد أي مادة تتصدر؛ وتاريخ الإنشاء يجيب عن ذلك بمحض المصادفة.',
    'curriculum.versions': 'الإصدارات',
    'curriculum.statCurricula': 'المناهج',
    'curriculum.statTotalVersions': 'الطبعات',
    'curriculum.statLive': 'مُفعَّلة الآن',
    'curriculum.statMultiLive': 'ازدواج التفعيل',
    'curriculum.versionsOfAll': 'كل طبعات كل المناهج. اختر منهجًا أعلاه لحصر هذا في مادة واحدة.',
    'curriculum.versionsOfScoped': 'طبعات {curriculum}. تُثبَّت الدفعات على واحدة منها وتُقيَّم بها تحديدًا.',
    'curriculum.editVersion': 'تعديل الإصدار',
    'curriculum.editVersionHint': 'التسمية وتاريخ سريان هذه الطبعة.',
    'curriculum.dimensionsUnscoped': 'أعداد الوحدات عبر كل المناهج وكل الطبعات — ما وضعته الأكاديمية يومًا خلف كل محور. اختر منهجًا أعلاه لعدّ وحداته وحده.',
    'curriculum.dimensionsScoped': 'أعداد الوحدات لـ {curriculum} عبر كل طبعاته. الصفر هنا يعني أن هذه المادة لا تدرّس شيئًا تحت ذلك المحور، لا أن أحدًا لا يدرّسه.',
    'curriculum.pickCurriculum': 'اختر منهجًا',
    'curriculum.versionCurriculumHint': 'برنامج الدراسة الذي يُعدّ هذا طبعةً منه. الدفعات على المناهج الأخرى لا تتأثر.',

    // ─── إصدار مناهج ثانٍ ────────────────────────────────────────────────────
    'curriculum.live': 'ساري',
    'curriculum.rendered': 'المعروض للعامة',
    'curriculum.multiLiveTitle': '{curriculum}: {count} إصدارات سارية في آنٍ واحد',
    'curriculum.multiLiveBody': 'جميعها سارية اليوم ولم يُتقاعد أيٌّ منها، لكن الصفحة العامة تعرض واحدًا فقط — {label}. الباقي سارٍ وغير مرئي. هذا خطأ في الغالب: قاعِد ما ليس أكاديميةً فعلية، أو غيّر تواريخ سريانه.',
    'curriculum.costsTitle': 'ما الذي يفعله إنشاء إصدار — وما لا يفعله',
    'curriculum.costCohorts': 'تبقى الدفعات القائمة على إصدارها الحالي وتُقيَّم عليه. لا شيء يتحرك من تحتها.',
    'curriculum.costRequirements': 'محتويات البرامج — ومعها درجات وحداتها — لا تنتقل. فهي تشير إلى معرّفات وحدات، وللإصدار الجديد وحدات جديدة — وحتى تُنقل، قد تجتاز دفعةٌ على هذا الإصدار كل شيء دون أن تُمنح أي شهادة.',
    'curriculum.costPublic': 'تتجاهل الصفحة العامة الإصدار الجديد حتى يحين تاريخ سريانه، ولا يجوز أن يتشارك إصداران التاريخ نفسه.',
    'curriculum.copyFrom': 'انسخ البنية والبرامج من',
    'curriculum.copyFromNone': 'ابدأ فارغًا (إدخال البنية يدويًا)',
    'curriculum.copyFromHint': 'ينسخ المستويات والوحدات ووسومها، ويعيد ربط محتويات البرامج (مع درجات وحداتها) بالوحدات الجديدة عبر الرمز.',
    'curriculum.copyPreview': 'معاينة النسخ',
    'curriculum.copyPreviewTitle': 'ما الذي سيُنقل',
    'curriculum.copyAppliedTitle': 'ما نُقل',
    'curriculum.copyCounts': '{levels} مستوى، {modules} وحدة، {programModules} وحدة برنامج.',
    'curriculum.copyUnresolved': 'لم يُنقل',
    'curriculum.copyClean': 'تمّت تسوية كل شيء — لم يُترك شيء.',
    'curriculum.copyFailed': 'أُنشئ الإصدار وفشل نسخ بنيته. أعد النسخ من شاشة الإصدار.',
    'curriculum.deleteVersion': 'حذف',
    'curriculum.deleteVersionConfirm': 'حذف الإصدار {label}؟ يزيل ذلك مستوياته ووحداته نهائيًا. ويُرفض إن اعتمدت عليه أي دفعة أو برنامج — وللإصدار ذي السجل الفعلي، قاعِده بدلًا من حذفه.',
    'curriculum.deleteVersionDone': 'حُذف الإصدار.',

    // ─── البرامج ─────────────────────────────────────────────────────────────
    'nav.programs': 'البرامج',
    'program.name': 'الاسم',
    'program.roleSku': 'رمز الدور',
    // النصوص — خطة المنصة 5 §5b.2.
    'program.about': 'عن البرنامج',
    // لمن يُباع — PLATFORM-PLAN-5 §5b.1. مفتاح `noneChosen` يقول ما يعنيه
    // الفراغ، لأن الفراغ هنا عكسه في حقل الأسواق المجاور.
    'program.audience': 'يُباع لـ',
    'program.audienceHint': 'أيّ من الأبواب العامة الثلاثة تُدرج هذا البرنامج. يبقى في الكتالوج في الحالتين.',
    'program.audience.businesses': 'الشركات',
    'program.audience.individuals': 'الأفراد',
    'program.audience.universities': 'الجامعات',
    'program.audience.noneChosen': 'لم يُحدَّد بعد — لا يظهر هذا البرنامج تحت أيٍّ من الأبواب الثلاثة، ويبقى في الكتالوج.',
    'program.overview': 'نبذة',
    'program.overviewHint': 'الفقرة التي يقرأها المشتري أولاً. حتى {max} حرفاً — الأطول يُرفض ولا يُقتطع.',
    'program.overviewMissing': 'لم تُكتب نبذة بعد.',
    'program.outcomes': 'المخرجات',
    'program.outcomesHint': 'ما سيتمكن المتعلم من فعله بعد البرنامج، بالترتيب الذي يُقرأ به. حتى {max} مخرجاً، كل منها حتى {each} حرفاً.',
    'program.outcomesCount': '{count} من {max}',
    'program.outcomesEmpty': 'لم تُكتب مخرجات بعد.',
    'program.outcomeAdd': 'إضافة مخرج',
    'program.outcomePlaceholder': 'ما سيتمكن المتعلم من فعله…',
    'program.outcomeOrdinal': 'المخرج {n}',
    'program.durationWeeks': 'المدة (بالأسابيع)',
    'program.durationWeeksHint': 'المدة الاسمية للدفعة التي تدرّس هذا البرنامج. اتركه فارغاً إن لم تُحدَّد.',
    'program.weeks': '{n} أسبوعاً',
    'program.notWritten': 'لم يُكتب بعد. تعرض الصفحة العامة هذا البرنامج باسمه ووحداته فقط حتى تُكتب هنا نبذة أو مخرجات أو مدة.',
    'program.standards': 'المعايير',
    'program.statTotal': 'البرامج',
    'program.statFlagship': 'البرامج الرائدة',
    'program.statUnbundled': 'بلا وحدات بعد',
    'program.create': 'برنامج جديد',
    'program.codePermanent': 'الرمز هو المرجع الذي تستخدمه السجلات الأخرى — غير قابل للتعديل لاحقًا.',
    'program.emptyList': 'لا برامج',
    'program.emptyListHint': 'البرنامج هو ما تدرّسه الدفعة — وحدات بترتيب، وفق معايير.',
    'program.modulesNote': 'يُحفظ الترتيب كاملًا — الترتيبات والأعلام الاختيارية ترتيب واحد، لا تعديلات صفوف.',
    'program.optional': 'اختياري',
    'program.requiresCapstone': 'يتطلب مشروع تطبيقي',
    'program.minScore': 'الحد الأدنى للدرجة',
    'program.minScorePlaceholder': 'مثلاً 70',
    'program.addModule': 'إضافة وحدة',
    'program.noModules': 'لا وحدات مرفقة — ستكون قوائم وحدات التسجيلات فارغة حتى تُرفق.',

    // ─── رموز الفحص ──────────────────────────────────────────────────────────
    'nav.checkCodes': 'رموز الفحص',
    'checkCode.create': 'رمز فحص جديد',
    'checkCode.edit': 'تعديل {code}',
    'checkCode.empty': 'لا رموز فحص معرّفة',
    'checkCode.emptyHint': 'الحالة الأولية الصحيحة: يقيّم المدرّبون دون مساعدة ويبقى الذكاء الاصطناعي متوقفًا. هذا نظام يعمل.',
    'checkCode.showRetired': 'إظهار المتقاعدة',
    'checkCode.retired': 'متقاعد',
    'checkCode.retire': 'تقاعد',
    'checkCode.reactivate': 'إعادة تفعيل',
    'checkCode.neverDelete': 'لا تُحذف الرموز أبدًا — رمز على تقييم سابق يجب أن يبقى قابلًا للحل دائمًا.',
    'checkCode.everyKind': 'كل الأنواع',
    'checkCode.label': 'التسمية',
    'checkCode.description': 'الوصف',
    'checkCode.severity': 'الخطورة',
    'checkCode.versionLabel': 'تسمية الإصدار',
    'checkCode.versionLabelHint': 'مطلوبة — معنى الفحص وقت رفعه لا يُستعاد من الصف الحالي.',
    'checkCode.kinds': 'ينطبق على الأنواع',
    'checkCode.kindsHint': 'لا شيء محدد = ينطبق على كل أنواع التقييم.',
    'checkCode.permanentNote': 'الإدخالات دائمة: لا يُعاد تسمية الرمز ولا يُحذف، بل يُقاعد فقط.',
    'checkCode.codeImmutable': 'الرمز نفسه لا يتغير — مكتوب على صفوف التقييم. قاعِد وأضِف بدلًا من ذلك.',

    'severity.advisory': 'إرشادي',
    'severity.minor': 'طفيف',
    'severity.major': 'كبير',
    'severity.critical': 'حرج',

    // ─── مسار المدرّبين ──────────────────────────────────────────────────────

    // ─── صحة النظام ──────────────────────────────────────────────────────────

    // ─── سجلاتي (بوابة المتعلم) ──────────────────────────────────────────────
    'my.title': 'سجلاتي',
    'my.subtitle': 'التحاقاتك وشهاداتك كما تحفظها الأكاديمية.',
    'my.profile': 'الملف الشخصي',
    'my.enrollments': 'التحاقاتي',
    'my.noEnrollments': 'لا التحاقات بعد',
    'my.noEnrollmentsHint': 'عندما تُسجَّل في فوج، يظهر هنا.',
    'my.enrolledOn': 'التحق في {date}',
    'my.continueLearning': 'متابعة التعلّم',
    'my.credentials': 'شهاداتي',
    'my.noCredentials': 'لا شهادات بعد',
    'my.noCredentialsHint': 'الشهادات التي تحصل عليها تظهر هنا، مع رابط تحقق عام لكل منها.',
    'my.verifyLink': 'صفحة التحقق العامة',
    'my.noRecord': 'لا يوجد لك سجل متدرِّب',
    'my.noRecordHint': 'حسابك غير مرتبط بالأكاديمية. تواصل مع المسؤول لربط هويتك.',
    'my.staffNoLearner': 'لا سجل تدريب بعد',
    'my.staffNoLearnerHint': 'حسابك الوظيفي يمكنه أيضًا تلقي التدريب. اضغط الزر أدناه لبدء رحلتك كمتدرب.',
    'my.becomeLearner': 'ابدأ كمتدرب',

    // ───────────────────────────── تأليف محتوى الوحدات (المرحلة 8)

    'contentKind.text': 'نص',
    'contentKind.link': 'رابط',
    'contentKind.video': 'فيديو',
    'contentKind.document': 'مستند',
    'contentKind.meeting': 'اجتماع',

    'lessons.title': 'الدروس',
    'lessons.addLesson': 'إضافة درس',
    'lessons.editLesson': 'تعديل الدرس',
    'lessons.summary': 'ملخّص',
    'lessons.emptyTitle': 'لا دروس بعد',
    'lessons.emptyHint': 'أضف الدرس الأول — الخطة المرجعية التي تدرّس منها كل الدفعات. تبقى الدروس قابلة للتعديل حتى على إصدار مجمّد.',
    'lessons.noContent': 'لا مواد في هذا الدرس بعد.',
    'lessons.deleteRefused': 'لا يمكن حذف هذا الدرس — سبق أن أشّر عليه متدرّبون أو دوّنوا ملاحظات. عدّل الدرس بدلًا من ذلك.',
    'lessons.addContent': 'إضافة مادة',
    'lessons.editContent': 'تعديل المادة',
    'lessons.kind': 'النوع',
    'lessons.body': 'المتن',
    'lessons.url': 'الرابط',
    'lessons.urlMustBeAbsolute': 'يجب أن يكون رابط http(s) مطلقًا.',
    'lessons.uploadFile': 'رفع ملف',
    'lessons.uploadHint': 'أو ارفع الملف نفسه بدل الربط إليه.',
    'lessons.videoUploadOnly': "يجب رفع الفيديو. لا يُسمح بالربط إلى فيديو خارجي: يستطيع أي شخص لديه الرابط مشاهدته أو تنزيله.",
    'lessons.uploadUnavailable': 'تخزين الملفات غير مُعدّ في هذا النشر — اربط إلى الملف برابط بدلًا من ذلك.',
    'lessons.uploading': 'جارٍ الرفع… {pct}%',
    'lessons.uploaded': 'مرفوع',

    'assignment.title': 'التكليف',
    'assignment.create': 'كتابة الموجز',
    'assignment.delete': 'حذف الموجز',
    'assignment.brief': 'الموجز',
    'assignment.files': 'ملفات مرفقة مع هذا التكليف',
    'assignment.attachFile': 'إرفاق ملف',
    'assignment.requirement': 'ما يسلّمه المتدرّبون',
    'assignment.requirementPlaceholder': 'اختر ما يُسلَّم…',
    'assignment.requirementUndecided': 'لا قيمة افتراضية — اختر عمدًا. هذا يحدد ما تتوقعه شاشة التقييم.',
    'assignment.emptyTitle': 'لا موجز تكليف',
    'assignment.emptyHint': 'بدون موجز، يكتب المتدرّبون في خانة تسليم بلا سؤال مرفق بها.',
    'assignment.passMarkLivesOnModule': 'درجة النجاح على الوحدة أعلاه (تتجمّد مع الإصدار) — وهي عمدًا غير مكررة هنا.',

    'submissionRequirement.text': 'نص مكتوب',
    'submissionRequirement.link': 'رابط',
    'submissionRequirement.file': 'ملف مرفوع',

    'cohortContent.modulePicker': 'الوحدة',
    'cohortContent.moduleLayerHeading': 'من الوحدة (تراه كل الدفعات)',
    'cohortContent.readOnlyLabel': 'للقراءة فقط هنا',
    'cohortContent.moduleLayerEmpty': 'لا توفر الوحدة موادًا بعد.',
    'cohortContent.cohortLayerHeading': 'مواد هذه الدفعة',
    'cohortContent.addItem': 'إضافة مادة',
    'cohortContent.emptyTitle': 'لم يُضف شيء لهذا التقديم',
    'cohortContent.emptyHint': 'التسجيلات والشرائح وروابط الاجتماعات والأمثلة الإضافية لهذه الدفعة توضع هنا — دون المساس بما تدرّس منه الدفعات الأخرى.',
    'cohortContent.readOnlyNotYourCohort': 'للقراءة فقط: لست المدرّب المعيَّن لهذه الدفعة.',
    'cohortContent.readOnlyDelisted': 'للقراءة فقط: صفتك كمدرّب مشطوبة. إعادة الاعتماد تعيد صلاحية التأليف — تسجيل الخروج لن يفعل.',
    'cohortContent.readOnlyClosed': 'للقراءة فقط: هذه الدفعة مكتملة أو ملغاة، فمحتوى تقديمها سجلٌّ الآن.',

    // ───────────────────────────── تأليف الاختبارات (المرحلة 9)

    'quizKind.singleChoice': 'اختيار واحد',
    'quizKind.multiChoice': 'اختيارات متعددة',

    'quiz.title': 'الاختبارات',
    'quiz.create': 'إضافة اختبار',
    'quiz.emptyTitle': 'لا اختبارات بعد',
    'quiz.emptyHint': 'الاختبار فحص ذاتي غير مُقيَّم — يُصحَّح آليًا ولا يمكن أن يصل إلى درجة أو مستوى أو شهادة أبدًا.',
    'quiz.questionCount': '{count} أسئلة',
    'quiz.attemptCount': '{count} محاولات',
    'quiz.editorTitle': 'محرر الاختبار',
    'quiz.backToModule': 'عودة إلى الوحدة',
    'quiz.backToAssessment': 'عودة إلى التقييم',
    'quiz.backToLesson': 'عودة إلى الدرس',
    'quiz.locked': 'لهذا الاختبار {count} محاولات مسجلة، لذا بنيته — الأسئلة والخيارات والنقاط — مقفلة. الدرجة المسجلة التي تغيّرت أسئلتها رقم لا يستطيع أحد تفسيره. يبقى العنوان والتعليمات وسقف المحاولات والعلامة الإرشادية قابلة للتعديل.',
    'quiz.instructions': 'التعليمات',
    'quiz.lesson': 'الدرس',
    'quiz.lessonHint': 'أين يظهر الاختبار للمتدرّبين.',
    'quiz.moduleLevelCheck': 'فحص على مستوى الوحدة (بدون درس محدد)',
    'quiz.maxAttempts': 'سقف المحاولات',
    'quiz.maxAttemptsHint': 'فارغ = بلا حد.',
    'quiz.passPct': 'العلامة الإرشادية (%)',
    'quiz.passPctAdvisory': 'إرشادية فقط — تُعرض للمتدرّب بصيغة «حصلت على 60%، والعلامة 70%». لا تحجب شيئًا: الاختبارات لا تُحسب أبدًا في الدرجات أو المستويات أو الشهادات. درجة النجاح الحقيقية على الوحدة.',
    'quiz.questions': 'الأسئلة',
    'quiz.addQuestion': 'إضافة سؤال',
    'quiz.newPrompt': 'سؤال جديد — عدّل النص',
    'quiz.noQuestionsTitle': 'لا أسئلة بعد',
    'quiz.noQuestionsHint': 'اختبار بلا أسئلة لا يمكن أداؤه (quiz_unconfigured) — التأليف غير مكتمل، ولا شيء معطّل.',
    'quiz.prompt': 'نص السؤال',
    'quiz.kind': 'النوع',
    'quiz.points': 'النقاط',
    'quiz.options': 'الخيارات',
    'quiz.oneCorrect': 'صحيح واحد بالضبط',
    'quiz.manyCorrect': 'صحيح واحد أو أكثر',
    'quiz.markCorrect': 'وضع الخيار {n} صحيحًا',
    'quiz.optionText': 'نص الخيار {n}',
    'quiz.removeOption': 'إزالة الخيار {n}',
    'quiz.optionOrdinal': 'الخيار {n}',
    'quiz.addOption': 'إضافة خيار',
    'quiz.needTwoOptions': 'يحتاج السؤال إلى خيارين على الأقل.',
    'quiz.needACorrectOption': 'ضع خيارًا واحدًا على الأقل صحيحًا.',
    'quiz.saveOptions': 'حفظ الخيارات',
    'quiz.saveQuestion': 'حفظ السؤال',
    'quiz.deleteQuestion': 'حذف السؤال',
    'quiz.questionLocked': 'مقفل — {count} محاولات مسجلة.',
    'quiz.delete': 'حذف الاختبار',
    'quiz.deleteHint': 'حذف الاختبار يزيل أسئلته وخياراته. ممكن فقط ما دامت لا محاولات مسجلة.',
    'quiz.deleteLocked': 'لهذا الاختبار {count} محاولات مسجلة ولا يمكن حذفه — الدرجة المسجلة التي اختفى اختبارها رقم لا يستطيع أحد تفسيره.',

    // ───────────────────────── الأسئلة المفتوحة والتصحيح (المرحلة 2، خطة الذكاء الاصطناعي)
    'quizKind.shortAnswer': 'إجابة قصيرة',
    'quizKind.essay': 'مقالي',
    'quiz.freeTextBadge': 'نص حر',
    'quiz.gateBadge': 'بوابة',
    'quiz.markingModeHint': 'تُصحَّح الإجابات المفتوحة فقط؛ أسئلة الاختيار تُقيَّم تلقائيًا دائمًا.',
    'quiz.markingGuide': 'دليل التصحيح',
    'quiz.markingGuideHint': 'ما تحتويه الإجابة الكاملة. يستخدمه المصحح فقط، ولا يظهر للمتعلم أبدًا.',
    'quiz.markingGuideRequired': 'يحتاج السؤال المفتوح إلى دليل تصحيح قبل حفظه.',
    'quiz.maxAnswerChars': 'أقصى طول للإجابة',
    'quiz.maxAnswerCharsHint': 'بين 50 و10,000 حرف.',

    // ───────────────────── التأليف بالذكاء الاصطناعي (المرحلة 5) — المسودة
    // لا تُحفظ أبدًا من هذه الشاشات؛ زر الحفظ الحالي للمنسّق هو ما يحفظ أي شيء.
    'aiDraft.generate': '✦ إنشاء بالذكاء الاصطناعي',
    'aiDraft.optionsTitle': 'إنشاء اختبار بالذكاء الاصطناعي',
    'aiDraft.reviewTitle': 'مراجعة المسودة',
    'aiDraft.questionCount': 'عدد الأسئلة',
    'aiDraft.kinds': 'أنواع الأسئلة',
    'aiDraft.difficulty': 'مستوى الصعوبة',
    'aiDraft.difficulty.intro': 'تمهيدي',
    'aiDraft.difficulty.core': 'أساسي',
    'aiDraft.difficulty.stretch': 'متقدم',
    'aiDraft.notes': 'ملاحظات للذكاء الاصطناعي (اختياري)',
    'aiDraft.notesHint': 'إرشادات حول الموضوع أو التركيز. تُعامَل كبيانات فقط، ولا تُستخدم أبدًا كتعليمات تتجاوز قواعد الاستناد إلى المحتوى.',
    'aiDraft.draftTitle': 'العنوان',
    'aiDraft.truncatedBanner': 'الدرس طويل — استُخدم الجزء الأول منه فقط لكتابة هذه المسودة.',
    'aiDraft.droppedBanner': 'لم يستوفِ {count} من الأسئلة قواعد الاختبار فاستُبعد.',
    'aiDraft.removeQuestion': 'حذف السؤال {n}',
    'aiDraft.correct': 'صحيح',
    'aiDraft.saveAsQuiz': 'حفظ كاختبار',
    // ─── Screening (for HR) — SKILL-ASSESSMENT-PLAN.md §4 ───────────────────
    'screening.title': 'اختبارات الفرز (للموارد البشرية)',
    'screening.intro': 'اختبارات ترسلها الموارد البشرية إلى المتقدمين والموظفين لقياس مهارة تدرّسها هذه الوحدة — لا يراها المتعلمون، ولا يُعرض على الموارد البشرية إلا المنشور منها.',
    'screening.newQuiz': 'اختبار فرز جديد',
    'screening.draftQuiz': 'صياغة اختبار بالذكاء الاصطناعي',
    'screening.newTask': 'مهمة عملية جديدة',
    'screening.editTask': 'تعديل المهمة العملية',
    'screening.noSkills': 'أضف أولًا مهارات هذه الوحدة وأدواتها في الأعلى — فكل عنصر فرز يقيس واحدة منها.',
    'screening.empty': 'لا توجد عناصر فرز بعد. أنشئ اختبارًا أو مهمة عملية لإحدى مهارات هذه الوحدة.',
    'screening.quizzes': 'الاختبارات',
    'screening.tasks': 'المهام العملية',
    'screening.quizFacts': '{count} أسئلة · {minutes} دقيقة',
    'screening.taskFacts': '{requirement} · {minutes} دقيقة',
    'screening.published': 'منشور',
    'screening.draft': 'مسودة',
    'screening.publish': 'نشر',
    'screening.unpublish': 'إلغاء النشر',
    'screening.copy': 'نسخ',
    'screening.copyHint': 'أنشئ نسخة مسودة قابلة للتعديل — استخدمها لتغيير اختبار له محاولات مسجلة.',
    'screening.translate': 'ترجمة بالذكاء الاصطناعي',
    'screening.translateTitle': 'ترجمة هذا الاختبار',
    'screening.translateInto': 'الترجمة إلى',
    'screening.translateHint': 'يصوغ الذكاء الاصطناعي الترجمة بالأسئلة والإجابات نفسها. تراجعها أنت، ثم تُحفظ كاختبار مسودة جديد بتلك اللغة.',
    'screening.saveAsQuiz': 'حفظ كاختبار فرز',
    'screening.skill': 'المهارة المقيسة',
    'screening.skillHint': 'إحدى مهارات هذه الوحدة وأدواتها — بالرمز نفسه الذي تستخدمه الموارد البشرية للمهارة.',
    'screening.level': 'المستوى المستهدف',
    'screening.levelHint': 'يجب أن تميّز الأسئلة من هو في هذا المستوى عمّن هو دونه بمستوى واحد.',
    'screening.levelName.1': '1 — أساسي',
    'screening.levelName.2': '2 — نامٍ',
    'screening.levelName.3': '3 — عملي',
    'screening.levelName.4': '4 — متقدم',
    'screening.levelName.5': '5 — خبير',
    'screening.language': 'اللغة',
    'screening.language.en': 'الإنجليزية',
    'screening.language.ar': 'العربية',
    'screening.language.fr': 'الفرنسية',
    'screening.minutes': 'الوقت المقترح (بالدقائق)',
    'screening.createAndAddQuestions': 'إنشاء وإضافة الأسئلة',
    'screening.draftBrief': 'صياغة الموجز بالذكاء الاصطناعي',
    'screening.draftBriefHint': 'يملأ العنوان والموجز وما يُسلَّم. اكتب دليل التصحيح بنفسك.',
    'screening.brief': 'المطلوب من المرشح',
    'screening.briefHint': 'يظهر للمرشح. حدّد بدقة ما يجب إنتاجه وتسليمه.',
    'screening.markingGuide': 'دليل التصحيح',
    'screening.markingGuideHint': 'ما تتضمنه الإجابة الكاملة. يراه المصححون فقط — لا يراه المرشح أبدًا.',
    'screening.badge': 'اختبار فرز (للموارد البشرية)',
    'screening.editorHint': 'ليس جزءًا من الدورة. محاولة واحدة ولا توجد علامة نجاح — تذهب النتيجة إلى الموارد البشرية كمستوى مهارة.',
    'screening.lockedHint': 'مقفل: لهذا الاختبار محاولات مسجلة. انسخه لتغيير المهارة أو اللغة.',
    'screening.skillHintStandalone': 'اختياري. رمز مهارة لمرجع الموارد البشرية — غير مرتبط بأي وحدة.',
    'screening.skillPlaceholder': 'مثال: Revit, Dynamo, AutoCAD',
    'aiDraft.regenerate': 'إعادة الإنشاء',
    'aiDraft.partialQuizCreated': 'تم إنشاء اختبار جزئي قبل حدوث هذا الفشل.',
    'aiDraft.viewPartialQuiz': 'عرض الاختبار الجزئي',
    'aiDraft.briefModalTitle': 'إنشاء موجز تكليف بالذكاء الاصطناعي',
    'aiDraft.useThisDraft': 'استخدام هذه المسودة',
    'aiDraft.suggestedChecks': 'الفحوصات التي يخدمها هذا التكليف: {codes}',
    'aiDraft.noSuggestedChecks': 'لا توجد رموز فحص بعد — لن تقترح المسودة أيًا منها.',

    // شاشة المتعلم للوحدة (LearnModule) — رقمان للتقدم، لا يُدمجان أبداً.
    'learn.title': 'الوحدة',
    'learn.position': '{position} من {count}',
    'learn.credits': '{credits} ساعات معتمدة',
    'learn.assessed': 'خاضعة للتقييم',
    'learn.recordedProgress': 'التقدم المسجل',
    'learn.selfReportedProgress': 'تقدمي الخاص',
    'learn.selfReportedHint': 'علاماتك أنت — تُعرض بجانب الرقم المسجل ولا تُدمج معه أبداً.',
    'learn.noLessonsYet': 'لا دروس بعد',
    'learn.bestScore': 'أفضل درجة {score}',
    'learn.lessonTitle': 'الدرس',
    'learn.material': 'المواد',
    'learn.noMaterialHint': 'لم تُرفق أي مواد بهذا الدرس بعد. يضيف المدرب التسجيلات والقراءات والروابط أثناء سير الدفعة.',
    'learn.readOnly': 'أنت تعرض تسجيل هذا المتعلم وليس تسجيلك. علامات الإنجاز والملاحظات والاختبارات وزر التالي خاصة بالمتعلم، لذلك لا تتوفر هنا.',
    'learn.lessonQuizzes': 'اختبار هذا الدرس',
    'learn.moduleQuizzes': 'بعد هذه الوحدة',
    'learn.lessonNav': 'الدروس',
    'learn.backToModule': 'العودة إلى الوحدة',
    'learn.lessonMissingTitle': 'هذا الدرس ليس ضمن هذه الوحدة',
    'learn.lessonMissingHint': 'ربما أُزيل من المنهج بعد إنشاء الرابط.',
    'learn.yourSubmission': 'تسليمك',
    'learn.yourAnswer': 'إجابتك',
    'learn.answerPlaceholder': 'اكتب إجابتك هنا، أو أرفق ملفاتك أدناه، أو كليهما.',
    'learn.attachFile': 'إرفاق ملف',
    'learn.uploading': 'جارٍ الرفع… {pct}%',
    'learn.uploadFailed': 'تعذّر إرسال الملف إلى وحدة التخزين. إذا كان اتصالك يعمل، فاطلب من المسؤول التحقق من إعدادات التخزين.',
    'learn.saveDraft': 'حفظ المسودة',
    'learn.handItIn': 'تسليم',
    'learn.handInWarning': 'بعد التسليم لا يمكنك التعديل — على المدرب إعادته إليك أولاً.',
    'learn.handedIn': 'تم التسليم. الملف لدى مدربك.',
    'learn.handedInAt': 'سُلّم في {when}. الملف لدى مدربك.',
    'learn.returnedBecause': 'أعاده مدربك: {reason}',
    'learn.uploadRefused': 'تعذّر رفع الملف. إن تكرر ذلك فأبلغوا المدرب — قد تحتاج إعدادات التخزين إلى مراجعة.',
    'submissionState.draft': 'مسودة',
    'submissionState.awaitingInstructor': 'لدى المدرب',
    'submissionState.confirmed': 'مُقيَّم',
    'submissionState.returned': 'أُعيد إليك',
    'learn.lessons': 'الدروس',
    'learn.noLessonsTitle': 'لا دروس بعد',
    'learn.noLessonsHint': 'المادة قيد الإعداد لهذه الوحدة — لا شيء ناقص من جانبك.',
    'learn.cohortExtras': 'من دفعتك',
    'learn.cohortLayer': 'دفعتك',
    'learn.tick': 'تم',
    'learn.status.done': 'تم',
    'learn.status.liveOn': 'مباشر · {when}',
    'learn.status.held': 'انعقدت المحاضرة',
    'learn.status.quizPending': 'اختبار مطلوب',
    'learn.status.quizPassed': 'اجتاز الاختبار',
    'learn.materialCount': 'المواد: {count}',
    'learn.openLesson': 'افتح الدرس',
    'learn.materialList': 'مواد الدرس',
    'learn.opened': 'تم فتحه',
    'learn.group.videos': 'الفيديوهات',
    'learn.group.documents': 'المستندات',
    'learn.group.readings': 'القراءات',
    'learn.group.files': 'ملفات التصميم',
    'learn.group.links': 'الروابط',
    'learn.pdfFallback': 'إن لم يظهر المستند هنا فقم بتنزيله.',
    'learn.steps': 'خطوات الدرس',
    'learn.step.attend': 'احضر المحاضرة المباشرة',
    'learn.step.attendHint': 'تكتمل عندما يحدد المدرب المحاضرة كمنعقدة.',
    'learn.step.attendDone': 'انعقدت المحاضرة.',
    'learn.step.watch': 'شاهد المادة',
    'learn.step.watchHint': 'تُحتسب مكتملة عند الانتقال بزر التالي.',
    'learn.step.watchDone': 'تمت المشاهدة.',
    'learn.step.complete': 'اطّلع على المادة',
    'learn.step.noQuiz': 'لا يحتوي هذا الدرس على اختبار.',
    'learn.step.next': 'المتابعة',
    'learn.step.doneLabel': 'تم',
    'learn.markComplete': 'تحديد كمكتمل',
    'learn.fileOpensElsewhere': 'يُفتح في البرنامج المثبت له، مثل Revit أو AutoCAD.',
    'learn.download': 'تنزيل',
    'learn.noMaterial': 'لا مادة في هذا الدرس بعد.',
    'learn.openFile': 'فتح الملف',
    'learn.openLink': 'فتح',
    'learn.noteToggle': 'ملاحظتي',
    'learn.noteTitle': 'ملاحظتي',
    'learn.notePlaceholder': 'خاصة بك وحدك — لا يراها المدربون ولا الموظفون أبداً.',
    'notes.aiSummaryButton': '✦ تلخيص الدرس في ملاحظتي',
    'notes.aiSummaryTitle': 'مسودة النقاط الرئيسية — لم تُحفظ بعد',
    'notes.aiSummaryInsert': 'إدراج في ملاحظتي',
    'notes.aiSummaryDiscard': 'تجاهل',
    'tutor.title': 'اسأل عن هذا الدرس',
    'tutor.askPlaceholder': 'اطرح سؤالاً عن هذا الدرس…',
    'tutor.send': 'اسأل',
    'tutor.thinking': 'جارٍ التفكير…',
    'tutor.remaining': 'تبقّى لك {count} سؤال اليوم',
    'tutor.ungrounded': 'غير مغطى في هذا الدرس — اسأل مدربك',
    'tutor.clearHistory': 'مسح السجل',
    'tutor.clearConfirm': 'هل تريد مسح كل أسئلة هذا الدرس؟',
    'learn.quizzes': 'اختبارات ذاتية',
    'learn.noQuizzesTitle': 'لا اختبارات ذاتية',
    'learn.noQuizzesHint': 'لا اختبارات في هذه الوحدة — هي تدريب اختياري وليست متطلباً.',
    'learn.quizBest': 'الأفضل {score}%',
    'learn.attemptsOf': '{used} من {max} محاولات',
    'learn.attemptsUnlimited': '{used} محاولات',
    'learn.takeQuiz': 'ابدأ',
    'learn.retakeQuiz': 'أعد المحاولة',
    'learn.quizAttemptsExhausted': 'استنفدت جميع محاولاتك. أعد مشاهدة مادة الدرس وحاول مرة أخرى.',
    'learn.restartLesson': 'إعادة الدرس',
    'learn.quizUnconfiguredTitle': 'ليس جاهزاً بعد',
    'learn.quizUnconfiguredHint': 'هذا الاختبار الذاتي ما زال قيد الإعداد — لا خطأ من جانبك.',
    'learn.quizAdvisoryMark': 'العلامة {pct}% — إرشادية فقط؛ لا تُحتسب في درجتك أبداً.',
    'learn.submitAttempt': 'إرسال',
    'learn.attemptNumber': 'المحاولة {n}',
    'learn.quizScoredAgainstMark': 'حصلت على {score}% — العلامة {pct}%.',
    'learn.questionCorrect': 'صحيح',
    'learn.questionIncorrect': 'خطأ',
    'learn.questionN': 'السؤال {n}',
    'learn.quizAwaitingMarking': 'في انتظار التصحيح',
    'learn.viewFeedback': 'عرض الملاحظات',
    'learn.quizAwaitingAiMark': 'تم الإرسال — يتم تصحيحه بالذكاء الاصطناعي. يستغرق هذا أقل من دقيقة عادةً.',
    'learn.quizAwaitingInstructorMark': 'تم الإرسال — سيصحح مدرّبك إجاباتك المكتوبة.',
    'learn.canContinueToNextLesson': 'يمكنك الاستمرار إلى الدرس التالي.',
    'learn.charsRemaining': 'باقي {count} حرف',
    'learn.markedByAi': 'صحّحه الذكاء الاصطناعي',
    'learn.markedByInstructor': 'صحّحه مدرّبك',
    'learn.pointsAwarded': '{points} من {max} نقطة',
    'learn.assignment': 'التكليف',
    'learn.noAssignmentTitle': 'لا تكليف',
    'learn.noAssignmentHint': 'لا يوجد موجز تكليف لهذه الوحدة بعد.',
    'learn.handIn': 'التسليم: {what}',
    'learn.locked': 'مُقفل',
    'learn.lockedByQuiz': 'اجتز اختبار «{lesson}» لفتح هذا الدرس.',
    'learn.lockedBySessionDated': 'يُفتح بعد الجلسة المباشرة في «{lesson}»، {when}.',
    'learn.lockedBySessionUndated': 'يُفتح بعد الجلسة المباشرة في «{lesson}». لم يُحدَّد موعد بعد.',
    'learn.moduleLocked': 'يجب اجتياز الوحدة {code} قبل فتح هذه الوحدة. يمكنك القراءة مسبقًا، لكن علاماتك لن تُحتسب بعد.',
    'learn.liveLesson': 'جلسة مباشرة',
    'learn.liveLessonHint': 'هذا الدرس محاضرة مباشرة مع دفعتك، وموادها أدناه.',
    'learn.sessionStarts': 'تبدأ {when}',
    'learn.sessionStarted': 'بدأت {when}',
    'learn.sessionDuration': '{minutes} دقيقة',
    'learn.sessionJoin': 'انضم إلى الجلسة',
    'learn.sessionHeld': 'انعقدت هذه الجلسة.',
    'learn.sessionNotScheduled': 'لم يحدد المدرب موعدًا لهذه الجلسة بعد.',
    'learn.sessionRecording': 'التسجيل',
    'learn.liveNow': 'مباشر الآن',
    'learn.sessionEnter': 'ادخل إلى الفصل',
    'learn.sessionOpensAt': 'يفتح الفصل عند {when}.',
    'learn.sessionCancelled': 'أُلغيت هذه الجلسة. سيحدد المدرب موعدًا آخر.',
    'learn.sessionRecorded': 'تم تسجيل هذه الجلسة.',
    'learn.watchRecording': "مشاهدة التسجيل",
    'learn.videoNotUploaded': "لم يُرفع هذا الفيديو إلى الأكاديمية بعد، لذا لا يمكن تشغيله هنا. تواصلوا مع المدرب.",
    'learn.mediaRetry': "إعادة المحاولة",
    'learn.play': "تشغيل",
    'learn.hidePlayer': "إخفاء المشغّل",
    'learn.fullScreen': "ملء الشاشة",
    'learn.exitFullScreen': "الخروج من ملء الشاشة",
    'learn.mediaUnavailable': "تعذّر تشغيل هذا التسجيل. أعيدوا المحاولة، أو أبلغوا المدرب إن تكرر الأمر.",
    'learn.sessionEnded': 'انتهت هذه الجلسة.',
    'learn.liveConnecting': 'جارٍ توصيلك بالفصل…',
    'learn.liveEmbedFailed': 'تعذّر تحميل الفصل.',
    'learn.liveRetry': 'أعد المحاولة',
    'learn.next.nextQuiz': 'التالي: {title}',
    'learn.next.nextLesson': 'الدرس التالي: {title}',
    'learn.next.nextLessonGeneric': 'الدرس التالي',
    'learn.next.moduleAssessment': 'التالي: تقييم الوحدة',
    'learn.next.awaitingAssessmentMark': 'التقييم لدى مدرّبك',
    'learn.next.continueToNextModule': 'المتابعة إلى الوحدة التالية',
    'learn.next.nextModule': 'الوحدة التالية: {title}',
    'learn.next.programmeComplete': 'اكتمل البرنامج',
    'learn.next.goToMyLearning': 'الذهاب إلى تعلّمي',
    'learn.completedAutomatically': 'أُكمل تلقائيًا',
    'cohort.tabSessions': 'الجلسات',
    'cohortSessions.module': 'الوحدة',
    'cohortSessions.schedule': 'جدولة جلسة',
    'cohortSessions.noneTitle': 'لا توجد جلسات مجدولة',
    'cohortSessions.noneHint': 'تحتاج الدروس المباشرة في هذه الوحدة إلى موعد قبل أن يتمكن المتدربون من الحضور، وقبل أن تُفتح الدروس التالية لها.',
    'cohortSessions.state.scheduled': 'مجدولة',
    'cohortSessions.state.held': 'انعقدت',
    'cohortSessions.state.cancelled': 'أُلغيت',
    'cohortSessions.gatesNothing': 'لا تفتح شيئًا',
    'cohortSessions.markHeld': 'تحديد كمنعقدة',
    'cohortSessions.markHeldHint': 'يفتح كل درس ينتظر هذه الجلسة، للمجموعة بأكملها.',
    'cohortSessions.reopen': 'تحديد كغير منعقدة',
    'cohortSessions.reschedule': 'إعادة الجدولة',
    'cohortSessions.rescheduleHint': 'ستُبلَّغ الدفعة بالموعد الجديد ويصلها التذكير مرة أخرى.',
    'cohortSessions.saveNewTime': 'حفظ الموعد الجديد',
    'cohortSessions.lessonScheduledOn': '{lesson} — مجدولة بالفعل في {when}',
    'cohortSessions.lessonHeldOn': '{lesson} — انعقدت بالفعل في {when}',
    'cohortSessions.closeOut.question': 'هل انتهت هذه المحاضرة؟',
    'cohortSessions.closeOut.hint': 'إلى أن تُجيب تبقى الدروس التالية مقفلة على الدفعة، والتسجيل وحده لا يكفي لأنه يتوقف أيضًا عند انقطاع الاتصال.',
    'cohortSessions.closeOut.done': 'نعم، انتهت',
    'cohortSessions.closeOut.continuing': 'انقطع الاتصال — سأُكمل الآن',
    'cohortSessions.closeOut.redo': 'يجب إعادتها',
    'cohortSessions.closeOut.continuingUntil': 'تبقى القاعة مفتوحة حتى {when}، وبعدها سنسألك مرة أخرى.',
    'cohortSessions.closeOut.awaitingNewDate': 'حُددت لإعادتها. أعد جدولتها، أو حدّدها كمنعقدة إن كانت قد انتهت.',
    'cohortSessions.cancel': 'إلغاء الجلسة',
    'cohortSessions.opensLessons': 'الدروس التي كانت تنتظر هذه الجلسة مفتوحة الآن للمجموعة.',
    'cohortSessions.titleField': 'العنوان',
    'cohortSessions.lesson': 'الدرس',
    'cohortSessions.noLesson': 'بدون درس — ساعات مكتبية أو جلسة مراجعة',
    'cohortSessions.noLiveLessons': 'لا تحتوي هذه الوحدة على دروس مباشرة، لذا لن تفتح الجلسة هنا شيئًا. هذا مناسب للساعات المكتبية.',
    'cohortSessions.startsAt': 'تبدأ في',
    'cohortSessions.duration': 'المدة (دقائق)',
    'cohortSessions.joinUrl': 'رابط الانضمام',
    'cohortSessions.joinUrlHint': 'الصق الرابط من أداة الاجتماعات لديك. يُعرض للمجموعة ولا تفتحه الأكاديمية أبدًا.',
    'cohortSessions.delivery': 'كيف تُعقد',
    'cohortSessions.deliveryPasted': 'رابط خارجي',
    'cohortSessions.deliveryIntegrated': 'داخل الأكاديمية',
    'cohortSessions.deliveryIntegratedHint': 'تُعقد الحصة داخل صفحة الدرس.',
    'cohortSessions.deliveryUnavailable': 'الاجتماعات غير مُعدّة في هذا النشر، لذا يتوفر رابط خارجي فقط.',
    'cohortSessions.joinBefore': 'يُفتح الباب (دقائق قبل)',
    'cohortSessions.joinBeforeHint': 'متى يُسمح للمتدربين بالدخول. يفرضها الخادم، وليس الشاشة وحدها.',
    'cohortSessions.integratedBadge': 'داخل الأكاديمية',
    'cohortSessions.enter': 'ادخل كمُضيف',
    'nextClass.title': 'الحصة التالية',
    'nextClass.none': 'لا توجد حصة لك خلال الأسبوعين القادمين.',
    'nextClass.openLink': 'فتح رابط الاجتماع',
    'nextClass.manage': 'إدارة الجلسة',
    'cohortSessions.attachRecording': 'إرفاق التسجيل',
    'cohortSessions.changeRecording': 'تغيير التسجيل',
    'cohortSessions.recording': 'التسجيل',
    'cohortSessions.noRecording': 'لا شيء',
    'cohortSessions.noRecordings': 'لم يُرفع أي فيديو لهذه المجموعة في هذه الوحدة بعد. أضفه من تبويب المحتوى أولًا.',
    'engagement.waitingOn': 'في انتظار',
    'engagement.waitingQuiz': 'اختبار «{lesson}»',
    'engagement.waitingSession': 'الجلسة المباشرة في «{lesson}»',
    'lessons.requirement': 'طريقة التقديم',
    'lessons.requirementSelfPaced': 'ذاتي الوتيرة — مادة يدرسها المتدرب بمفرده',
    'lessons.requirementSynchronous': 'جلسة مباشرة — تجتمع لها المجموعة',
    'lessons.requirementSelfPacedHint': 'يحتوي تسجيلات وقراءات وروابط. يدرسه المتدربون بالوتيرة التي تناسبهم.',
    'lessons.requirementSynchronousHint': 'تجدول كل دفعة تدرس هذه الوحدة هذه المحاضرة، وتبقى الدروس التالية مقفلة حتى تنعقد، وتظهر أي مادة أسفل الجلسة.',
    'lessons.liveBadge': 'جلسة مباشرة',
    'lessons.sessionSpecHint': 'هذا الدرس هو الجلسة نفسها — لا يحمل مادة. حدد موعده من تبويب الجلسات في المجموعة.',
    'lessons.sessionObjectives': 'ما تتناوله الجلسة',
    'lessons.sessionObjectivesHint': 'جدول أعمال اللقاء. نفسه في كل مجموعة — يختلف الموعد فقط.',
    'lessons.sessionPreparation': 'ما يُحضره المتدربون',
    'lessons.sessionPreparationHint': 'يظهر على بطاقة الجلسة قبل الحصة، وهي اللحظة الوحيدة المفيدة.',
    'lessons.expectedDuration': 'المدة المتوقعة (دقائق)',
    'lessons.expectedDurationHint': 'تملأ نموذج الجدولة مسبقًا. يمكن للمدرب تمديدها أو تقصيرها.',
    'lessons.requiresAttendance': 'الحضور',
    'lessons.attendanceOptional': 'اختياري — تفتح الجلسة الدروس التالية للجميع',
    'lessons.attendanceRequired': 'مطلوب للمتابعة',
    'lessons.attendanceRequiredHint': 'تُفتح الدروس التالية للحاضرين فقط، أو للجميع بمجرد أن يصبح للمحاضرة تسجيل.',
    'lessons.requiresAttendanceOnHint': 'تُفتح الدروس التالية لكل متدرب على حدة: من سُجل حاضرًا يتابع، ومن لم يُسجل ينتظر مدربه. لا يمكن إعادة حضور حصة فائتة، لذا صحّح السجل أو أعد عقد الجلسة.',
    'lessons.requiresAttendanceOffHint': 'تعليم الجلسة كمنعقدة يفتح الدروس التالية للمجموعة كلها دفعة واحدة.',
    'lessons.quizMarking': 'الجهة التي تصحح الإجابات المفتوحة في اختبار هذا الدرس',
    'lessons.quizMarkingHint': 'أسئلة الاختيار تُقيَّم تلقائيًا دائمًا. هذا يحدد من يصحح الإجابات المكتوبة.',
    'lessons.quizMarkingAiBadge': 'يصححه الذكاء الاصطناعي',
    'lessons.quizMarkingInstructorBadge': 'يصححه المدرب',
    'markingMode.instructor': 'المدرب',
    'markingMode.ai': 'الذكاء الاصطناعي',
    'markingMode.assessmentAi': 'الذكاء الاصطناعي (يضع مسودة درجة؛ والمدرب يعتمدها دائمًا)',
    'markingMode.aiNotConfigured': 'التصحيح بالذكاء الاصطناعي غير مُفعَّل.',
    'learn.lockedByAttendance': 'لم يُسجَّل حضورك في {lesson}. راجع مدربك — يمكنه تصحيح السجل أو إعادة عقد الجلسة.',
    'cohortSessions.register': 'سجل الحضور',
    'cohortSessions.registerHint': 'يُسجَّل الجميع حاضرين عند عقد الجلسة. أزل علامة من لم يحضر.',
    'cohortSessions.present': 'حاضر',
    'cohortSessions.saveRegister': 'احفظ السجل',
    'cohortSessions.registerSaved': 'تم حفظ السجل.',
    'cohortSessions.noRoster': 'لا يوجد مسجلون في هذه المجموعة بعد.',
    'learn.openAssessmentFlow': 'فتح سجل التحاقي',

    // تبويب التفاعل للمدرب (المرحلة 7). عمودان للتقدم، لا يُدمجان أبداً.
    'engagement.statEnrolled': 'المسجّلون',
    'engagement.statActive': 'نشطون',
    'engagement.statFinished': 'منتهون',
    'engagement.modulePicker': 'الوحدة',
    'engagement.progress': 'التقدم',
    'engagement.learner': 'المتعلم',
    'engagement.recorded': 'المسجل',
    'engagement.selfReported': 'المبلغ ذاتياً',
    'engagement.noLessons': 'لا دروس بعد',
    'engagement.noEnrollments': 'لا التحاقات',
    'engagement.noEnrollmentsHint': 'لم يلتحق أحد بهذه الدفعة بعد.',
    'engagement.loadMore': 'تحميل المزيد',
    'engagement.quizzes': 'اختبارات ذاتية',
    'engagement.quizPicker': 'الاختبار الذاتي',
    'engagement.noQuizzes': 'لا اختبارات ذاتية في هذه الوحدة',
    'engagement.noQuizzesHint': 'تُؤلف الاختبارات في شاشة الوحدة؛ وتظهر النتائج هنا بعد أن يخوضها المتعلمون.',
    'engagement.noAttempts': 'لا محاولات بعد',
    'engagement.noAttemptsHint': 'بعد أن يخوض المتعلمون هذا الاختبار، تُظهر نسبة الإجابات الصحيحة لكل سؤال أي المواضيع رسخت.',
    'engagement.noAttemptsShort': 'لا محاولات',
    'engagement.correctRate': '{pct}% صحيح',
    'engagement.attempts': 'المحاولات',
    'engagement.best': 'الأفضل',
    'engagement.state': 'الحالة',
    'engagement.quizStateAwaiting': 'بانتظار التصحيح',
    'engagement.quizStateMarkedByAi': 'صحّحه الذكاء الاصطناعي',
    'engagement.quizStateMarkedByInstructor': 'صحّحه المدرّب',
    'engagement.lastAttempt': 'آخر محاولة',
    'engagement.submissions': 'التسليمات',
    'engagement.noSubmissions': 'لا تسليمات',
    'engagement.noSubmissionsHint': 'تظهر هنا التقييمات المفتوحة لهذه الدفعة مع حالاتها.',
    'engagement.fileMissing': 'الملف مطلوب ولم يُرفق',
    'engagement.tutorQuestions': 'أسئلة المرشد',
    'engagement.tutorQuestionsHint': 'الدروس التي لم يغطِّ محتواها ما سأل عنه المتعلمون.',
    'engagement.tutorLesson': 'الدرس',
    'engagement.tutorQuestionsCount': 'الأسئلة',
    'engagement.tutorNotCovered': 'غير مغطى',
    'engagement.noTutorQuestionsTitle': 'لا توجد أسئلة للمرشد بعد',
    'engagement.noTutorQuestionsHint': 'بمجرد أن يسأل المتعلمون مرشد الدرس، تُحصى أسئلتهم هنا.',
    'engagement.actions': 'إجراءات',
    'engagement.message': 'مراسلة',
    'engagement.messageTitle': 'مراسلة {name}',
    'engagement.messageHint': 'القناة الوحيدة المتاحة للتطبيق للتواصل معه: بريده الإلكتروني.',
    'engagement.noEmail': 'لا يوجد بريد إلكتروني مسجَّل لهذا الشخص.',

    // ─── Public landing page ─────────────────────────────────────────────────
    // See en.js for the line between this dictionary and
    // src/content/landing/ar.js: controls here, prose there.
    // THE PUBLIC PAGES' OWN NAME, on the landing header and footer lockups
    // only. `app.name` stays the product's name inside the application; the
    // marketing site is sold as the VDC Academy.
    'landing.brandName': 'أكاديمية VDC',
    'landing.skipToContent': 'الانتقال إلى المحتوى',
    'landing.sectionsNavLabel': 'أقسام الصفحة',
    'landing.openMenu': 'فتح القائمة',
    'landing.closeMenu': 'إغلاق القائمة',
    'landing.goToPortal': 'الانتقال إلى البوابة',
    'landing.cta.primary': 'اطلب برنامجًا تدريبيًا مخصّصًا',
    'landing.cta.secondary': 'استكشف المنهج',
    'landing.cta.plan': 'استفسار',
    'landing.pillars.modules': '{count} وحدة',
    'landing.pillars.modulesOne': 'وحدة واحدة',
    'landing.framework.level': 'المستوى {ordinal}',
    'landing.curriculum.noModules': 'وحدات هذا المستوى قيد الإعداد.',
    'landing.footer.linksTitle': 'روابط سريعة',
    'landing.backToTop': 'العودة إلى الأعلى',
    'landing.form.name': 'الاسم الكامل',
    'landing.form.email': 'البريد الإلكتروني للعمل',
    'landing.form.organisation': 'المؤسسة',
    'landing.form.phone': 'الهاتف',
    'landing.form.programmes': 'البرامج التي تهمك',
    'landing.form.programmesHint': 'اختياري — حدّد البرامج التي تودّ أن نقدّم لك عرض سعر لها.',
    'landing.form.role': 'المسمّى الوظيفي',
    'landing.form.country': 'الدولة',
    'landing.form.countrySelect': 'اختر دولة…',
    'landing.form.countryHint': 'لنوجّه استفسارك إلى الفريق المناسب.',
    'landing.form.seats': 'عدد المقاعد المطلوبة',
    'landing.form.seatsUnspecified': 'غير محدّد بعد',
    'landing.form.updates': 'أرسلوا لي عبر البريد الإلكتروني مستجدات البرامج ومواعيد الدفعات الجديدة. يمكن إلغاء الاشتراك في أي وقت.',
    'landing.form.submit': 'إرسال الاستفسار',
    'landing.form.acknowledged': 'شكراً لكم — وصل استفساركم إلى فريقنا، وسنرد على البريد الذي ذكرتموه. لا يُنشأ لكم أي حساب قبل التحدث معكم.',
    'intake.sending': 'جارٍ الإرسال…',
    'intake.failed': 'لم يصل استفساركم ولم يُحفظ شيء. نرجو المحاولة مرة أخرى بعد قليل.',
    'intake.failedThrottled': 'وردت محاولات كثيرة من هذا الاتصال. انتظروا دقيقة ثم أعيدوا الإرسال.',
    'intake.captchaPending': 'أكملوا التحقق أعلاه لإرسال استفساركم.',
    'intake.captchaUnavailable': 'تعذّر تحميل التحقق الأمني. السبب المعتاد إضافة في المتصفح أو مانع إعلانات؛ عطّلوه لهذه الصفحة أو راسلونا مباشرة.',
    'intake.failedCaptcha': 'انتهت صلاحية التحقق الأمني قبل إرسال الاستفسار. لم يضع شيء — أكملوه مرة أخرى ثم أعيدوا الإرسال.',
    'landing.backToSite': 'العودة إلى الصفحة الرئيسية',
    // وافدو الأكاديمية نفسها: عضويات اشتُريت من الصفحة العامة. لا جهة ضمنت
    // هؤلاء، فالصف يحمل طلبًا بلا شخص، وقبولهم فعلٌ يقوم به المنسّق.
    'arrivals.academy': 'طلبات الأكاديمية',
    'arrivals.order': 'الطلب',
    'arrivals.quoted': 'مبلغ معروض، غير محصَّل',
    'arrivals.admit': 'قبول',
    'arrivals.admitted': 'أُضيف {name} إلى السجل. أصدر له بيانات الدخول أدناه.',
    'arrivals.awaitingAdmission': 'تعذّر القبول — اقبله يدويًا',
    'arrivals.academyEmpty': 'لم تُشترَ أي عضوية من الصفحة العامة بعد.',
    'arrivals.academyLead': 'اشتُريت من الصفحة العامة. المشتري مُسجَّل بالفعل — تحقّق من هويته ثم أصدر له بيانات الدخول.',

    // ─── العضوية والدفع التجريبي ─────────────────────────────────────────────
    // الدفع تجريبي ولا يُحصَّل منه شيء: يُسجَّل الطلب في طابور الوافدين ويكمله
    // منسّق يدويًا. كل نص هنا مكتوب حتى لا يظن المشتري أنه دُفع منه مبلغ أو أن
    // هناك حسابًا جاهزًا بانتظاره.
    'landing.membership.talkToUs': 'تحدّث إلى منسّق',
    'checkout.back': 'العودة إلى الموقع',
    'checkout.title': 'عضوية {tier}',
    'checkout.otherTiers': 'عضويات أخرى',
    'checkout.seats': 'المقاعد',
    'checkout.oneSeatOnly': 'مقعد واحد — العضوية الفردية لصاحبها وحده.',
    'checkout.seatsBounds': 'بين {min} و {max} مقعدًا',
    'checkout.volumeBreak': '{seats}+ مقعدًا: خصم {percent}%',
    'checkout.programmes': 'البرامج',
    'checkout.subjects': 'المجالات',
    'checkout.allSubjects': 'كل المجالات',
    'checkout.selectAll': 'تحديد الكل',
    'checkout.clearAll': 'مسح',
    'checkout.perSeat': '{price} لكل مقعد',
    'checkout.pickProgramme': 'اختر برنامجًا واحدًا على الأقل — سعر المقعد هو مجموع البرامج التي يشملها.',
    'checkout.noProgrammesForTier': 'لا توجد برامج معروضة للبيع ضمن هذه العضوية بعد. تواصل معنا وسنقدّم لك عرض سعر مباشرة.',
    'checkout.programmesHint': 'كل برنامج تختاره يضيف سعره إلى كل مقعد. يتحقق منسق من الملاءمة قبل تسجيل أي شخص.',
    'checkout.details': 'بيانات المشتري',
    'checkout.detailsHint': 'يتحقق المنسّق من هذه البيانات قبل إصدار الدخول، لذا يُفضَّل رقم هاتف يمكن الوصول إليه.',
    'checkout.summary': 'طلبك',
    'checkout.seatsLine': '{seats} × {price}',
    'checkout.volumeDiscount': 'خصم الكمية ({seats}+ مقعدًا، {percent}%)',
    'checkout.promoDiscount': 'عرض {code} ({percent}%)',
    'checkout.vat': 'ضريبة القيمة المضافة ({percent}%)',
    'checkout.pricing': 'نحسب إجماليك…',
    'checkout.priceUnavailable': 'تعذّر تسعير هذا الطلب الآن. يُرجى المحاولة بعد قليل.',
    'checkout.redirectNotice': 'سننقلك إلى مزوّد الدفع لإتمام السداد بأمان. تبدأ عضويتك فور تأكيده الدفع — ولا نطّلع مطلقًا على بيانات بطاقتك.',
    'checkout.pay': 'ادفع {total}',
    'checkout.paying': 'ننقلك إلى صفحة الدفع…',
    'checkout.failed': 'لم يصلنا طلبك ولم يُخصم أي مبلغ. يُرجى المحاولة بعد قليل.',
    'checkout.paymentsUnavailable': 'خدمة الدفع غير متاحة حاليًا ولم يُخصم أي مبلغ. تواصل معنا وسنسجّل طلبك يدويًا.',
    // ── التحقق من البريد الإلكتروني، بين النموذج وصفحة الدفع.
    'checkout.verify.title': 'تحقق من بريدك الإلكتروني',
    'checkout.verify.body': 'أرسلنا رمزًا من ستة أرقام إلى {email}. أدخله للمتابعة إلى الدفع.',
    'checkout.verify.label': 'رمز التحقق',
    'checkout.verify.submit': 'المتابعة إلى الدفع',
    'checkout.verify.checking': 'جارٍ التحقق…',
    'checkout.verify.resend': 'إرسال رمز جديد',
    'checkout.verify.resent': 'رمز جديد في الطريق إليك.',
    'checkout.verify.wrong': 'الرمز غير صحيح أو انتهت صلاحيته. راجع آخر رسالة أو اطلب رمزًا جديدًا.',
    'checkout.verify.locked': 'محاولات كثيرة بهذا الرمز. اطلب رمزًا جديدًا.',
    'checkout.verify.resendLimit': 'أُرسل رمز قبل لحظات. انتظر دقيقة قبل الطلب مجددًا — وبعد ثلاثة رموز يرجى بدء الطلب من جديد.',
    'checkout.verify.expired': 'انتهت صلاحية هذا الطلب ولم يُخصم أي مبلغ. يرجى البدء من جديد.',
    'checkout.confirmedTitle': 'تم تأكيد الدفع',
    'checkout.orderRef': 'رقم الطلب',
    'checkout.total': 'الإجمالي',
    // ── صفحة العودة. أربع حالات، والانتظار ليس منها السيّئة: تتسابق العودة مع
    // تأكيد المزوّد، فالانتظار هو الحالة الطبيعية الأولى، ولا تعتذر عنه الرسائل
    // ولا توحي بحدوث خطأ.
    'checkout.returnWaitingTitle': 'بانتظار تأكيد الدفع',
    'checkout.returnWaitingLead': 'يؤكّد مصرفك عملية الدفع الآن. لا يستغرق ذلك عادةً سوى ثوانٍ — يمكنك ترك هذه الصفحة مفتوحة.',
    'checkout.returnStillWaitingLead': 'لم يصلنا التأكيد بعد، وهذا لا يعني حدوث خطأ — فقد يستغرق التأكيد بضع دقائق. احتفظ برقم طلبك وسنراسلك فور وصوله.',
    'checkout.returnPaidLead': 'شكرًا لك — تم سداد عضويتك. احتفظ برقم طلبك؛ به نصل إليك.',
    'checkout.returnClosedTitle': 'هذا الطلب مغلق',
    'checkout.returnClosedLead': 'انتهت صلاحية عرض السعر لهذا الطلب أو جرى إلغاؤه، ولم يُخصم عليه أي مبلغ. ابدأ من صفحة العضويات وسنعيد تسعيره لك.',
    'checkout.returnRefundedTitle': 'تم ردّ مبلغ هذا الطلب',
    'checkout.returnRefundedLead': 'أُعيد مبلغ هذا الطلب. إن لم يكن ذلك متوقعًا، تواصل معنا مع ذكر رقم طلبك.',
    'checkout.returnUnknownTitle': 'لم نعثر على هذا الطلب',
    'checkout.returnUnknownLead': 'قد يكون الرابط مختصرًا أو مكتوبًا بشكل خاطئ. إن كان لديك رقم طلب فتواصل معنا مع ذكره — لم يضع شيء.',
    'checkout.promo': 'رمز العرض',
    'checkout.promoPlaceholder': 'أدخل الرمز',
    'checkout.promoApply': 'تطبيق',
    'checkout.promoApplied': 'طُبِّق {code}',
    'checkout.promoUnknown': 'هذا الرمز غير معروف لدينا.',
    'checkout.emailNotice': 'سيتحقق منسّق من بياناتك ويرسل إليك بيانات الدخول بالبريد. لا يلزمك شيء آخر الآن — لا يوجد حساب لتهيئته بعد.',

    // The renewal page — screens/subscribe/Renew.jsx. Where the renewal
    // letter sends a member; it asks the Academy what the order is and, on
    // a click, for the provider's page. Nothing is charged unattended.
    'renew.title': 'جدّد عضويتك',
    'renew.lead': 'تقترب فترة عضويتك من نهايتها. جدّدها لفترة أخرى بالسعر أدناه — نفس الخطة ونفس المقاعد.',
    'renew.loadingTitle': 'نبحث عن طلب التجديد…',
    'renew.loadingLead': 'لحظة من فضلك بينما نراجع الطلب الوارد في رسالتك.',
    'renew.paidTitle': 'تم تجديد عضويتك',
    'renew.paidLead': 'تم دفع هذا التجديد وتمديد فترة عضويتك. لا يلزمك شيء آخر.',
    'renew.closedTitle': 'انتهى عرض التجديد هذا',
    'renew.closedLead': 'كان السعر في رسالتك محفوظًا حتى تاريخ مضى، ولم يُخصم أي مبلغ. تواصل معنا واذكر رقم طلبك وسنجدد عضويتك يدويًا.',
    'renew.unknownTitle': 'لم نعثر على طلب التجديد هذا',
    'renew.unknownLead': 'ربما اختُصر الرابط أو كُتب بشكل خاطئ. إن كان لديك رقم طلب فتواصل معنا واذكره — لم يضع شيء.',
    'renew.plan': 'العضوية',
    'renew.termEnds': 'تنتهي الفترة الحالية في',
    'renew.renewsUntil': 'تُجدَّد حتى',
    'renew.priceHeldUntil': 'السعر محفوظ حتى',
    'renew.nothingCharged': 'لن يُخصم أي مبلغ ما لم تختر التجديد. لا نحتفظ بأي بطاقة — إن لم تفعل شيئًا تنتهي عضويتك ببساطة في التاريخ أعلاه ولن تُفوتر.',
    'renew.failed': 'تعذّر فتح صفحة الدفع الآن ولم يُخصم أي مبلغ. حاول مرة أخرى بعد قليل.',

    // ─── حسابات الشركات (B2B) ────────────────────
    // «المقعد» يعني تسجيلاً في دفعة، لا شخصاً: تشتري الشركة عشرين
    // مقعداً وتنفق واحداً كلما أُلحق شخص بدفعة، ويعود المقعد عند الانسحاب.
    'nav.company': 'شركتي',
    'nav.companies': 'الشركات',

    'company.title': 'الشركة',
    'company.titleUniversity': 'الجامعة',
    'company.subtitle': 'مقاعدكم ومتدربوكم والدفعات المخصصة لحسابكم.',
    'company.noAccount': 'لا توجد شركة مرتبطة بحسابكم',
    'company.noAccountHint': 'سجلكم في الأكاديمية غير مرتبط بشركة، فلا مقاعد لعرضها. اطلبوا من مسؤول الأكاديمية ربطه؛ تسجيل الخروج والدخول لن يغيّر ذلك.',

    'company.seatsBought': 'المقاعد المشتراة',
    'company.seatsUsed': 'المقاعد المستخدمة',
    'company.seatsLeft': 'المقاعد المتبقية',
    'company.seatsLeftHint': 'يُنفق المقعد بالإلحاق بدفعة ويعود بالانسحاب.',
    'company.allowance': 'رصيد المقاعد',
    'company.allowanceSpent': 'كل المقاعد المشتراة قيد الاستخدام. اسحبوا متدرباً من دفعة لتحرير مقعد، أو تحدثوا مع مسؤول الأكاديمية لشراء المزيد.',
    'company.learners': 'المتدربون',
    'company.ourLearners': 'منكم',

    'company.cohorts': 'دفعاتكم',
    'company.noCohorts': 'لا توجد دفعات بعد',
    'company.noCohortsHint': 'تظهر الدفعات هنا بعد أن تجدول الأكاديمية واحدة على حسابكم.',

    'company.noLearners': 'لم يُضف أحد بعد',
    'company.noLearnersHint': 'أضيفوا الأشخاص الذين تريدون تدريبهم. تسمية شخص لا تكلّف مقعداً — يُستهلك المقعد عند إلحاقه بدفعة.',
    'company.people': 'الأشخاص',
    'company.peopleHint': 'المسجّلون على حسابكم. التسمية لا تكلّف مقعداً.',
    'company.accountHolder': 'صاحب الحساب:',
    'company.accountHolderAlsoLearner': 'ملتحق أيضاً',
    'company.addPerson': 'إضافة شخص',
    'company.addPersonHint': 'يمكن إلحاقهم بعد إضافتهم. إضافة شخص لا تستهلك مقعداً — يُستهلك المقعد عند الإلحاق بدفعة.',
    'company.signIn': 'الدخول',
    'company.hasSignIn': 'صدر',
    'company.loginIssuedBy': 'أصدره {name} في {date}',
    'company.seatsHeld': 'المقاعد المشغولة',
    'company.seatsHeldCount': '{count} مقعد',
    'company.lastEnrolled': 'آخر إلحاق',
    'company.enrollable': 'قابل للإلحاق',
    'company.notEnrollable': 'ليس بعد',
    'company.issueLogin': '\u0637\u0644\u0628 \u062f\u062e\u0648\u0644',
    'company.signInRequestedFor': '\u062a\u0645 \u0637\u0644\u0628 \u062f\u062e\u0648\u0644 \u0644\u0640 {name}.',
    'company.signInRequestedHint': '\u0633\u064a\u0635\u0644\u0647\u0645 \u0631\u0627\u0628\u0637 \u0644\u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062e\u0627\u0635\u0629 \u0628\u0647\u0645. \u0644\u0627 \u064a\u0631\u0627\u0647\u0627 \u0623\u062d\u062f \u0647\u0646\u0627.',
    'company.signInRequested': '\u062a\u0645 \u0637\u0644\u0628 \u0627\u0644\u062f\u062e\u0648\u0644. \u0633\u064a\u0635\u0644\u0647\u0645 \u0631\u0627\u0628\u0637 \u0644\u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.',
    'company.loginIssued': 'يستطيع الدخول',
    'company.organisation': 'الجهة',
    'company.organisationHint': 'أنت تدير أكثر من جهة. اختر الجهة التي تريد عرضها.',
    'company.manager': 'مدير',
    'company.managerAria': 'تعيين {name} مديرًا',
    'company.managerHint': 'المدير يفتح بوابة الشركة لهذا الشخص. مسؤول الأكاديمية وحده يحدّد من يدير الجهة.',
    // ─── لوحة قيادة بوابة العميل ─────────────────────────────────────────────
    // تسع شاشات، وبلغة العميل لا بلغة قاعدة البيانات: هذا القارئ لم يرَ يومًا
    // «تسجيلًا» ولا «نطاق إتقان» بهذه الأسماء، فالعناوين تقول ما الشيء بالنسبة
    // إليه هو.
    //
    // التفريق بين المقعد والشخص قائم في كل سطر هنا: المقعد يُنفَق بالتسجيل
    // ويعود بالانسحاب، وإضافة اسم لا تكلّف شيئًا.
    'nav.group.company': 'شركتي',
    'nav.companyProgrammes': 'البرامج',
    'nav.companyProgrammes.what': 'ما تم بيعه لكم',
    'nav.companyCohorts': 'الدفعات',
    'nav.companyCohorts.what': 'متى يجري تدريبكم',
    'nav.companyPeople': 'الأشخاص',
    'nav.companyPeople.what': 'من يمكنكم إرساله',
    'nav.companyEnrollments': 'المقاعد المستخدمة',
    'nav.companyEnrollments.what': 'من في أي دفعة',
    'nav.companyRequests': 'الطلبات',
    'nav.companyRequests.what': 'اطلبوا منا تشغيل دفعة',
    'nav.companyLearning': 'التعلّم',
    'nav.companyLearning.what': 'إلى أين وصلت الوحدات',
    'nav.companyReadiness': 'الجاهزية',
    'nav.companyReadiness.what': 'من جاهز، وإلى أي مدى',
    'nav.companyAttendance': 'الحضور',
    'nav.companyAttendance.what': 'من حضر',

    'company.signals': 'يستحق النظر',
    'company.signal.notStarted': 'لم يبدأوا بعد',
    'company.signal.notStartedHint': 'مقاعد مدفوعة ولم تُمسّ — ولا درس واحد، ولا محاولة واحدة.',
    'company.signal.notStartedCta': 'اعرف من هم',
    'company.signal.noSignIn': 'لا يستطيعون الدخول بعد',
    'company.signal.noSignInHint': 'هم على حسابكم بلا بيانات دخول، فلا يرون شيئًا مما اشتريتموه.',
    'company.signal.noSignInCta': 'أصدروا بيانات الدخول',
    'company.signal.openRequests': 'لدينا',
    'company.signal.openRequestsHint': 'طلبات دفعات لم نردّ عليها بعد.',
    'company.signal.openRequestsCta': 'اعرضوا طلباتكم',
    'company.signal.allowanceSpent': 'مقعدًا، جميعها مستخدمة',
    'company.signal.allowanceSpentCta': 'اعرفوا من يشغلها',

    'company.activity': 'النشاط',
    'company.modulesPassed': 'وحدات مجتازة',
    'company.modulesPassedHint': 'لكل المسجَّلين حاليًا.',
    'company.modulesInProgress': 'وحدات جارية',
    'company.credentialsHeld': 'شهادات مملوكة',
    'company.credentialsHeldHint': 'سارية في السجل العام.',
    'company.attendanceRate': 'الحضور',
    'company.attendanceRateHint': 'في الجلسات التي رُصد حضورها.',
    'company.attendanceUnknown': 'لم يُرصد الحضور بعد',
    'company.hoursDelivered': 'الساعات المُنفَّذة',
    'company.hoursDeliveredHint': 'عبر {held} جلسة عُقدت لكم.',
    'company.hoursAttended': 'الساعات المحضورة',
    'company.hoursAttendedHint': 'حضرها موظفوكم فعليًا.',
    'company.hoursScheduled': 'الساعات المجدولة',
    'company.hoursScheduledHint': '{ahead} جلسة لم تنعقد بعد — ولم تُنفَّذ.',
    'company.enrollmentStates': 'المقاعد حسب الحالة',
    'company.enrollmentStatesHint': 'المقاعد المنسحبة محسوبة هنا وليست ضمن «المقاعد المستخدمة» — والمقعد العائد هو سبب انخفاض الرقم.',
    'company.noEnrollmentsYet': 'لم يُسجَّل أحد بعد.',
    'company.whatsNext': 'إلى أين تنظرون بعد ذلك',
    'company.goLearning': 'إلى أين وصلت الوحدات',
    'company.goReadiness': 'من جاهز',
    'company.goAttendance': 'الحضور — {count} جلسة قادمة',

    'company.peopleLead': 'الأشخاص الذين يمكنكم إرسالهم للتدريب. تسمية شخص لا تكلّف مقعدًا؛ المقعد يُنفَق عند التسجيل.',
    'company.peopleTotal': 'الأشخاص المُسمّون',
    'company.peopleTotalHint': 'في قائمتكم، سواء سُجِّلوا أم لا.',
    'company.peopleWithSignIn': 'يمكنهم الدخول',
    'company.peopleWithoutSignIn': 'بلا تسجيل دخول بعد',
    'company.peopleWithoutSignInHint': 'على حسابكم لكن لا يمكنهم رؤية ما اشتريتموه.',
    'company.peopleEnrollable': 'جاهزون للتسجيل',
    'company.peopleEnrollableHint': 'لديهم ملف متعلّم ويمكن إدراجهم في دفعة.',
    'company.cohortsLead': 'الدفعات المحجوزة على حسابكم. الدفعة الفارغة ما زالت لكم — املؤوها من «المقاعد المستخدمة».',
    'company.cohortsTotal': 'الدفعات المحجوزة',
    'company.cohortsRunning': 'جارية الآن',
    'company.cohortsOpenToEnrol': 'لا تزال بها أماكن',
    'company.cohortsOpenToEnrolHint': 'يمكنها استقبال المزيد من أشخاصكم.',
    'company.cohortsOurLearners': 'مقاعدكم عبر الدفعات',

    'company.programmes': 'البرامج',
    'company.programmesLead': 'ما نصّ عليه عرضكم المعتمد. ليست هذه قائمتنا كاملة، بل ما بيع لكم.',
    'company.noProgrammes': 'لا يوجد برنامج مرتبط بحسابكم بعد',
    'company.verifiedPath': 'مؤكَّد',
    'company.verified': 'مؤكَّد معكم',
    'company.asRequested': 'كما طُلب',
    'company.programmesToRequests': 'اطلبوا منا تشغيل أحدها',
    'company.programmesTotal': 'البرامج المعروضة',
    'company.programmesConfirmedCount': 'مؤكَّدة معكم',
    'company.programmesAsRequestedCount': 'كما طُلبت',

    'company.enrollments': 'المقاعد المستخدمة',
    'company.enrollmentsLead': 'سطر لكل مقعد تنفقونه وما آل إليه. الانسحابات تبقى ظاهرة: لا تكلّف شيئًا، وهي سبب انخفاض استهلاككم.',
    'company.noEnrollments': 'لا مقاعد مستخدمة بعد',
    'company.noEnrollmentsHint': 'سجّلوا أحد أشخاصكم في إحدى دفعاتكم أدناه.',
    'company.enrolledAt': 'تاريخ التسجيل',
    'company.progress': 'التقدّم',
    'company.modulesOf': 'اجتاز {passed} من {total} وحدة',
    'company.lastPassed': 'آخر اجتياز',
    'company.enrollmentsTotal': 'المقاعد المُنفَقة',
    'company.enrollmentsActive': 'نشطة',
    'company.enrollmentsCompleted': 'مكتملة',
    'company.enrollmentsWithdrawn': 'منسحبة',
    'company.enrollmentsWithdrawnHint': 'لا تكلّف شيئًا — وهي سبب انخفاض الاستهلاك.',

    'company.learning': 'التعلّم',
    'company.learningLead': 'حسب الوحدة لا حسب الشخص: أربعون شريط تقدّم لا تقول شيئًا، و«أحد عشر متوقفون عند الوحدة نفسها» تقول ما العمل.',
    'company.noLearning': 'لا شيء يُذكر بعد',
    'company.noLearningHint': 'ما إن يُسجَّل أشخاصكم وتُفتح وحداتهم حتى تمتلئ هذه الصفحة وحدها.',
    'company.module': 'الوحدة',
    'company.onThisModule': 'الأشخاص عليها',
    'company.averageProgress': 'متوسط التقدّم',
    'company.spread': 'أين وصلوا',
    'company.spreadNotStarted': '{count} لم يبدأوا',
    'company.spreadInProgress': '{count} جارٍ',
    'company.spreadPassed': '{count} اجتازوا',
    'company.spreadFailed': '{count} رسبوا',
    'company.averageScore': 'متوسط الدرجة',
    'company.notGradedYet': 'لم تُصحَّح بعد',
    'company.notAssessed': 'غير مُقيَّمة',
    'company.learningModulesTotal': 'الوحدات الجارية',
    'company.learningNotStartedTotal': 'لم يبدأ بعد',
    'company.learningPassedTotal': 'اجتازوا',
    'company.learningFailedTotal': 'رسبوا',

    'company.readiness': 'الجاهزية',
    'company.readinessLead': 'ثلاثة أمور مختلفة جنبًا إلى جنب: كم قطعوا من المحتوى، وكم اجتازوا منه، وأين يضعهم ذلك.',
    'company.noReadiness': 'لا أحد مسجَّل بعد',
    'company.noReadinessHint': 'تظهر الجاهزية ما إن يلتحق أشخاصكم بدفعة ويبدأ تصحيح أعمالهم.',
    'company.passedCredit': 'المجتاز',
    'company.mandatory': 'الوحدات الإلزامية',
    'company.mandatoryDone': 'اجتازها كلها',
    'company.mandatoryOpen': 'بقي بعضها',
    'company.competencies': 'المهارات المستوفاة',
    'company.readinessTotal': 'الأشخاص المقيَّمون',
    'company.readinessMandatoryDoneCount': 'اجتازوا كل المطلوب',
    'company.readinessAvgPassedCredit': 'متوسط المُجتاز',
    'company.readinessMeetsBarCount': 'يستوفون حدّ البرنامج',
    'company.readinessMeetsBarHint': 'جاهزون لاعتماد برنامجهم.',
    'company.unmetModules': 'الوحدات المتبقية',

    'company.attendanceLead': 'يرصده المدرّب في القاعة كما يُرصد كشف الحضور. لا شيء هنا مُقاس من شاشة أحد، وهو قابل للتصحيح.',
    'company.noSessions': 'لا جلسات مجدولة',
    'company.noSessionsHint': 'تظهر الجلسات المباشرة ما إن تُدرَج على تقويم دفعتكم.',
    'company.sessions': 'الجلسات',
    'company.when': 'الموعد',
    'company.session': 'الجلسة',
    'company.ourAttendance': 'أشخاصكم',
    'company.notHeldYet': 'لم تُعقد بعد',
    'company.registerNotTaken': 'لم يُرصد الحضور',
    'company.presentOf': 'حضر {present} من {enrolled}',
    'company.attendanceByPerson': 'حسب الشخص',
    'company.sessionsExpected': 'جلسات متوقَّعة',
    'company.sessionsAttended': 'حضرها',

    'person.phone': 'الهاتف',
    'program.code': 'الرمز',
    'common.copy': 'نسخ',
    'common.copied': 'تم النسخ',
    'common.done': 'تم',

    // ─── الإلحاق بدفعة ──────────────────────────────────────────────────────
    'placement.action': 'إلحاق بدفعة',
    'placement.title': 'إلحاق {subject} بدفعة',
    'placement.confirmedProgramme': 'البرنامج المؤكد',
    'placement.programmeUnknown': 'غير معروف',
    'placement.confirmedSeats': '{count} مقاعد مؤكدة',
    'placement.inferred': 'استُنتج من الوحدات المطلوبة — يغطي هذا البرنامج {matched} من {requested}. غير المغطّى: {uncovered}.',
    'placement.unrecognised': 'يطلب العرض {codes}، وهي غير معروضة في هذا الكتالوج. راجع العرض في قبل إلحاق أي شخص.',
    'placement.noOffer': 'لا عرض مؤكد لهذا العميل — لم يُنشأ من صفقة مكسوبة. اختر دفعة من السجل بدلًا من ذلك.',
    'placement.who': 'الإلحاق: {count}',
    'placement.notEnrollable': 'لا ملف متعلّم',
    'placement.candidates': 'الدفعات المناسبة',
    'placement.noCandidates': 'لا توجد دفعة مفتوحة لهذا البرنامج بعد — ابدأ واحدة أدناه.',
    'placement.otherMarket': 'دولة أخرى',
    'placement.alreadyThere': 'مُلتحق بالفعل',
    'placement.place': 'الإلحاق هنا',
    'placement.notEnoughSeats': 'المتاح {available} مقاعد فقط، والمطلوب {needed}.',
    'placement.startNew': 'بدء دفعة جديدة',
    'placement.newCohort': 'دفعة جديدة لـ {programme}',
    'placement.newCohortHint': 'البرنامج والسوق والمقاعد من الصفقة المؤكدة، ومنهج {version} يُثبَّت عند الإنشاء. اختر لها اسمًا وتاريخًا.',
    'placement.createAndPlace': 'إنشاء وإلحاق {count}',

    // ─── طلبات الدفعات ──────────────────────────────────────────────────────
    'cohortRequest.title': 'طلبات الدفعات',
    'cohortRequest.lead': 'أخبرنا بالبرنامج الذي تريد تشغيله وموعده تقريبًا. نحن نحجز المدرّب ونبدأ الدفعة، ثم تملأ مقاعدها بنفسك.',
    'cohortRequest.ask': 'طلب دفعة',
    'cohortRequest.programme': 'البرنامج',
    'cohortRequest.pickProgramme': 'اختر برنامجًا…',
    'cohortRequest.seats': 'المقاعد المستخدمة',
    'cohortRequest.seatsHint': 'لديك {count} متبقية.',
    'cohortRequest.preferredStart': 'البداية المفضّلة',
    'cohortRequest.note': 'أي شيء ينبغي أن نعرفه',
    'cohortRequest.send': 'إرسال الطلب',
    'cohortRequest.none': 'لا طلبات بعد.',
    'cohortRequest.noProgrammes': 'لا يذكر عرضكم برنامجاً نستطيع مطابقته بدليلنا بعد. يمكن لمسؤول الأكاديمية تأكيد ما تم الاتفاق عليه.',
    'cohortRequest.noSeats': 'استُنفدت كل مقاعدك. تواصل معنا لإضافة المزيد قبل طلب دفعة أخرى.',
    'cohortRequest.waiting': 'لدى الأكاديمية',
    'cohortRequest.fulfilled': 'بدأت الدفعة',
    'cohortRequest.declined': 'مرفوض',
    'cohortRequest.summary': '{seats} مقاعد · البداية المفضّلة {when}',
    'cohortRequest.noPreference': 'دون تفضيل',
    'cohortRequest.queueLead': 'شركات تطلب تشغيل دفعة. ابدأ لها واحدة، أو وضّح سبب الرفض.',
    'cohortRequest.openTab': 'مفتوحة',
    'cohortRequest.allTab': 'الكل',
    'cohortRequest.queueEmpty': 'لا طلبات دفعات',
    'cohortRequest.queueEmptyHint': 'عندما تطلب شركة لديها مقاعد دفعةً، تصل هنا.',
    'cohortRequest.asking': 'تطلب {seats} مقاعد · البداية المفضّلة {when}',
    'cohortRequest.askedBy': 'طلبها {who} · {when}',
    'cohortRequest.fulfil': 'بدء دفعة',
    'cohortRequest.decline': 'رفض',
    'cohortRequest.fulfilTitle': 'الردّ على {company}',
    'cohortRequest.fulfilHint': 'حدّد الدفعة التي بدأتها لهم. لم تُنشأ بعد؟',
    'cohortRequest.createCohort': 'أنشئ واحدة',
    'cohortRequest.cohort': 'الدفعة',
    'cohortRequest.pickCohort': 'اختر دفعة…',
    'cohortRequest.noteToCompany': 'ملاحظة للشركة',
    'cohortRequest.declineTitle': 'رفض طلب {company}',
    'cohortRequest.reason': 'السبب',
    'cohortRequest.reasonHint': 'يُعرض هذا على الشركة.',

    // ─── إشعارات فورية ──────────────────────────────────────────────────────
    'toast.crmArrival': 'وصل عميل جديد للتو.',
    'toast.viewPeople': 'عرض الأشخاص',

    'company.enrol': 'إلحاق متدربين',
    'company.chooseCohort': 'الدفعة',
    'company.chooseCohortPlaceholder': 'اختاروا إحدى دفعاتكم…',
    'company.noOpenCohorts': 'لا تتسع أي من دفعاتكم حالياً',
    'company.addLearner': 'إضافة متدرب',
    'company.noEnrollableLearners': 'لم يبق أحد لإضافته',
    'company.enrolSubmit': 'إلحاق {count} متدرب',

    'company.name': 'الشركة',
    'company.segment': 'القطاع',
    'company.kind': 'النوع',
    'company.kind.company': 'شركة',
    'company.kind.university': 'جامعة',
    'company.kindHint': 'يحدده نظام إدارة العملاء بناءً على ما أخبرنا به العميل؛ صحّحه هنا إن كان خاطئًا.',
    'company.seats': 'المقاعد',
    'company.memberCount': 'الأعضاء',
    'company.members': 'أعضاء {name}',
    'company.status': 'الحالة',
    'company.open': 'مفتوح',
    'company.closed': 'مغلق',
    'company.statTotal': 'الشركات',
    'company.statActive': 'نشطة',
    'company.statMembers': 'الأعضاء',
    'company.statNoSeatsBought': 'بلا مقاعد مشتراة',
    'company.edit': 'تعديل الشركة',
    'company.noneYet': 'لا توجد حسابات شركات بعد',
    'company.noneYetHint': 'تصل الحسابات مع الصفقات المكسوبة من نظام العملاء، ومعها المقاعد التي اشترتها كل صفقة.',
    'company.noSeatsBought': 'لا مقاعد مشتراة',
    'company.seatAllowance': 'المقاعد المشتراة',
    'company.seatAllowanceFrozen': 'تحدده الصفقة المكسوبة في نظام العملاء، وترفعه الصفقة التالية. لا يُعدَّل هنا — المقاعد هي ما اشتراه العميل.',
    'company.crmAccountId': 'معرّف حساب إدارة العلاقات',
    'company.crmAccountFrozen': 'ثابت بعد الإنشاء: فهو هوية الحساب، وتغييره ينقل قائمة الدفعات بأكملها.',
    'company.active': 'مفتوح لتسجيلات جديدة',
    'company.activeHint': 'الإغلاق يحفظ كل السجلات ويمنع التسجيلات الجديدة.',
    'company.noMembers': 'لا أحد في هذه الشركة بعد',
    'company.noMembersHint': 'تصل الأسماء مع الصفقة المكسوبة، أو من مدير الشركة عبر بوابته.',
    'company.rosterOwnerHint': 'الصفقة المكسوبة تسمّي الأشخاص الذين تغطيهم، ويضيف مدير الشركة البقية من بوابته. أما تسليم بيانات الدخول فيتم من هنا.',

    'error.seat_allowance': 'لم يتبق لهذه الشركة أي مقعد.',


    // ═══════════════════════════════════════════════════════════════════════
    // نطاق المنهج — كل ما يلي يخص المادة التي ينتمي إليها العنصر.
    // ═══════════════════════════════════════════════════════════════════════

    'curriculum.levelTitle': 'العنوان',
    'curriculum.editLevel': 'تعديل المستوى',
    'curriculum.editLevelHint': 'كل حقل هنا قابل للتعديل: المستوى لا يحمل رمزًا، وكل متطلب في النظام يسمّي وحدة.',
    'curriculum.deleteLevel': 'حذف المستوى',
    'curriculum.deleteLevelConfirm': 'حذف {title}؟ لا يُحذف إلا مستوى فارغ.',
    'curriculum.deleteLevelWhy': 'حذف المستوى يأخذ معه وحداته — ومعها الدروس والاختبارات والمتطلبات المرتبطة بها. لذلك لا يُتاح إلا والمستوى خالٍ.',
    'curriculum.levelNotEmpty': 'يحتوي على {count} وحدة — أزلها أولًا لحذف هذا المستوى.',
    'curriculum.levelOrdinalTaken': 'لا يمكن لمستويين تقاسم الترتيب نفسه. انقل الآخر أولًا.',

    'curriculum.createDimension': 'بُعد جديد',
    'curriculum.editDimension': 'تعديل البُعد',
    'curriculum.deleteDimension': 'حذف البُعد',
    'curriculum.deleteDimensionConfirm': 'حذف {name}؟ لا يُحذف إلا بُعد لا يشير إليه شيء.',
    'curriculum.dimensionCode': 'الرمز',
    'curriculum.dimensionCodeHint': 'قصير وبأحرف كبيرة ودائم منذ الإنشاء — تسمّيه وسوم الوحدات وصفحة الأركان العامة.',
    'curriculum.dimensionCodeLocked': 'يُحدَّد مرة واحدة ولا يتغير. وسوم الوحدات وأدوات البُعد تحمله كمفتاح خارجي، والصفحة العامة تسمّيه برمزه — فإعادة التسمية تعيد توجيه بعضها وتُيتّم بعضها الآخر بصمت.',
    'curriculum.dimensionName': 'الاسم',
    'curriculum.dimensionContentCore': 'جوهر المحتوى',
    'curriculum.dimensionContentCoreHint': 'سطر واحد يصف ما يغطيه هذا المحور. هو ما يُطبع تحت الاسم في قسم الأركان العامة.',
    'curriculum.dimensionOrdinal': 'ترتيب العرض',
    'curriculum.dimensionTools': 'الأدوات المعيارية',
    'curriculum.dimensionToolsHint': 'ما يدّعي هذا المحور أنه يُدرَّس عليه، مقابل أدوات الوحدة نفسها التي تُدرَّس فعلًا.',
    'curriculum.dimensionsShared': 'المفردات على مستوى الأكاديمية ولا تضيق مع المنهج أعلاه: البُعد يُسمّى برمزه من وسوم الوحدات والصفحة العامة معًا، فلا يمكن لمادتين أن تحمل كل منهما «3D» خاصًا بها. الأعداد وحدها هي ما يخص كل منهج.',
    'curriculum.noDimensions': 'لا أبعاد',
    'curriculum.noDimensionsHint': 'أنشئ المحاور التي يَسِم بها المنهج وحداته.',
    'curriculum.dimensionInUse': 'تشير إليه {count} وحدة — أزل الوسم عنها أولًا.',

    'curriculum.publicVersion': 'الصفحة العامة',
    'curriculum.publicVersionAuto': 'تلقائي',
    'curriculum.publicVersionAutoHint': 'لا إصدار مثبّت، فتعرض الصفحة العامة أحدث إصدار سارٍ.',
    'curriculum.publicVersionPinnedHint': 'مثبّت على {label}. تعرض الصفحة العامة هذا الإصدار بدل الاشتقاق — ما دام ساريًا وغير متقاعد.',
    'curriculum.setPublicVersion': 'اعرض هذا على الصفحة العامة',
    'curriculum.clearPublicVersion': 'العودة إلى التلقائي',
    'curriculum.publicVersionNotEffective': 'مثبّت لكنه غير سارٍ اليوم — تعرض الصفحة العامة إصدارًا آخر حتى يحلّ تاريخه. التثبيت لا ينشر مبكرًا أبدًا.',
    'curriculum.pinnedBadge': 'مثبّت',

    'program.curriculum': 'المنهج',
    'program.curriculumHint': 'المادة التي يُباع هذا البرنامج ضمنها. اخترها أولًا: حزمة الوحدات التي تحددها بعد ذلك يجب أن تأتي من هذا المنهج، والخادم يرفض وحدة مستعارة من غيره.',
    'program.curriculumLocked': 'يُحدَّد مرة واحدة. نقل البرنامج إلى مادة أخرى يترك كل وحدة في حزمته خلفه — والحزمة هي ما يُسجَّل عليه الفوج.',
    'program.pickCurriculumFirst': 'اختر منهجًا لإنشاء برنامج.',
    'program.noCurricula': 'لا مناهج بعد — أنشئ واحدًا من شاشة المنهج أولًا. البرنامج يُباع ضمن مادة، فلا يوجد ما يُدرَج تحته.',
    'program.allCurricula': 'كل المناهج',
    'program.curriculumFilterHint': 'برامج من كل المواد. اختر واحدة لترى ما تبيعه وحدها.',



    // ── دفتر الأسعار (آخر شاشة في المرحلة 4 من الخطة 3) ─────────────────────
    'nav.priceBook': 'دفتر الأسعار',
    'nav.priceBook.what': 'كم تكلّف العضوية، وكل رمز خصم',
    'priceBook.lede': 'ما تتقاضاه الأكاديمية مقابل العضوية، لكل سوق، والرموز التي تخصمه. تغيير السعر يحرّك ما يُعرض على المشتري التالي؛ ولا يعيد صياغة طلب دُفع ثمنه بالفعل.',
    'priceBook.tab.plans': 'الخطط والأسعار',
    'priceBook.tab.promotions': 'رموز الخصم',
    'priceBook.edit': 'تعديل',
    'priceBook.showRetired': 'إظهار الخطط المتقاعدة',
    'priceBook.onSale': 'معروضة للبيع',
    'priceBook.retired': 'متقاعدة',
    'priceBook.noDefaultPrice': 'غير مسعّرة — غير معروضة للبيع',
    'priceBook.retire': 'تقاعد',
    'priceBook.restore': 'إعادة',
    'priceBook.accountKind.person': 'مشترٍ فرد',
    'priceBook.accountKind.company': 'منشأة',

    'priceBook.plan.create': 'خطة جديدة',
    'priceBook.plan.edit': 'تعديل الخطة',
    'priceBook.plan.createNote': 'لا تُعرض الخطة الجديدة للبيع حتى تُحدَّد لها عملة افتراضية ويُسعَّر برنامج واحد على الأقل. تقرير وجود الخطة وتقرير سعرها قراران منفصلان.',
    'priceBook.plan.code': 'الرمز',
    'priceBook.plan.codeHint': 'الكلمة التي ستستخدمها صفحة الهبوط وشاشة الواردين وثلاث لغات لهذه الخطة. بحروف صغيرة.',
    'priceBook.plan.codeFixed': 'ثابت: هذا الرمز مدوَّن على كل طلب اشتُري بهذه الخطة.',
    'priceBook.plan.name': 'الاسم',
    'priceBook.plan.accountKind': 'المشتري',
    'priceBook.plan.accountKindHint': 'أيّ تبويب في طابور الواردين يقع فيه مشتري هذه الخطة. لا يمكن تغييره لاحقًا.',
    'priceBook.plan.accountKindFixed': 'ثابت: تغييره ينقل أشخاصًا وصلوا بالفعل.',
    'priceBook.plan.minSeats': 'أقل عدد مقاعد',
    'priceBook.plan.maxSeats': 'أكبر عدد مقاعد',
    'priceBook.plan.displayOrder': 'الترتيب',
    'priceBook.plan.displayOrderHint': 'موضعها بين بطاقات العضوية.',
    'priceBook.plan.seatBand': 'من {min} إلى {max} مقعدًا',
    'priceBook.plan.statTotal': 'الخطط',
    'priceBook.plan.statOnSale': 'معروضة للبيع',
    'priceBook.plan.statNoDefaultPrice': 'غير مسعّرة',
    'priceBook.plan.statMarketOverrides': 'استثناءات الأسواق',
    'priceBook.plan.none': 'لا خطط في الدفتر',
    'priceBook.plan.noneHint': 'لا شيء معروض للبيع حتى توجد خطة تحمل سعرًا افتراضيًا.',

    'priceBook.price.add': 'إضافة سوق',
    'priceBook.price.edit': 'تعديل العملة والضريبة',
    'priceBook.price.market': 'السوق',
    'priceBook.price.marketHint': 'اتركه فارغًا للسعر الافتراضي — ما تدفعه كل سوق بلا سعر محلي.',
    'priceBook.price.default': 'افتراضي',
    'priceBook.price.defaultOption': 'افتراضي (كل سوق أخرى)',
    'priceBook.price.defaultNote': 'الافتراضي صفٌّ وليس فراغًا: العملة والضريبة التي يستخدمها كل سوق ليس له صف خاص. الخطة التي تخلو منه لا تُعرض للبيع في أي مكان. أما سعر المقعد فيُحدَّد لكل برنامج أدناه.',
    'priceBook.price.currency': 'العملة',
    'priceBook.price.currencyHint': 'يُسجَّل السطر الجديد بالعملة المختارة في الترويسة. لتسعير هذا السوق بعملة أخرى، غيّرها أولًا.',
    'priceBook.price.currencyStoredHint': 'عملة هذا السطر ثابتة بعد حفظه؛ يمكن تغيير الضريبة فقط.',
    'publicPrice.approxTitle': 'قيمة تقريبية بسعر الصرف الإرشادي اليوم. المبلغ المحصَّل {price}.',
    'publicPrice.approxLabel': 'أسعار تقريبية',
    'priceBook.price.unitPrice': 'للمقعد',
    'priceBook.price.unitPriceHint': 'ما يضيفه هذا البرنامج إلى المقعد الواحد قبل أي خصم.',
    'priceBook.price.tax': 'الضريبة',
    'priceBook.price.taxPercent': 'الضريبة',
    'priceBook.price.taxPercentHint': 'تُحتسب على المجموع بعد الخصم وتُعرض للمشتري في سطر مستقل.',
    'priceBook.price.none': 'لم تُحدَّد عملة بعد — هذه الخطة غير معروضة للبيع.',
    'priceBook.price.remove': 'إزالة عملة هذا السوق وضريبته',
    'priceBook.programs.heading': 'أسعار البرامج',
    'priceBook.programs.lede': 'سعر المقعد هو مجموع البرامج التي يختارها المشتري. البرنامج الذي لا سعر له هنا لا يُباع ضمن هذه الخطة.',
    'priceBook.programs.add': 'تسعير برنامج',
    'priceBook.programs.edit': 'تعديل سعر البرنامج',
    'priceBook.programs.none': 'لا يوجد برنامج مسعّر — هذه الخطة غير معروضة للبيع.',
    'priceBook.programs.programme': 'البرنامج',
    'priceBook.programs.pick': 'اختر برنامجًا',
    'priceBook.programs.notFiled': 'غير مصنَّف لهذه الفئة',
    'priceBook.programs.remove': 'إزالة سعر هذا البرنامج',
    'priceBook.programs.marketHint': 'اتركه فارغًا للسعر الافتراضي — ما يكلّفه هذا البرنامج في كل سوق ليس له سعر خاص.',
    'priceBook.programs.currencyNote': 'بعملة {currency}، عملة هذه الخطة في ذلك السوق.',
    'priceBook.programs.needsCurrency': 'حدّد العملة والضريبة الافتراضيتين لهذه الخطة أولًا — سعر البرنامج يُذكر بها.',
    'priceBook.breaks.button': 'خصومات الكمية ({count})',
    'priceBook.breaks.title': 'خصومات الكمية — {plan}',
    'priceBook.breaks.oneApplies': 'يُطبَّق خصم واحد فقط: أعلى عتبة يبلغها الطلب. ولا تتراكم أبدًا.',
    'priceBook.breaks.minSeats': 'ابتداءً من',
    'priceBook.breaks.rate': 'الخصم',
    'priceBook.breaks.add': 'إضافة عتبة',
    'priceBook.breaks.remove': 'إزالة هذه العتبة',
    'priceBook.breaks.none': 'لا خصومات كمية. الخطة التي تُباع مقعدًا واحدًا لا كمية فيها لتُخصم.',
    'priceBook.breaks.summary': 'الكمية:',
    'priceBook.breaks.item': '{seats} مقعدًا فأكثر، خصم {rate}',

    'priceBook.promo.create': 'إصدار رمز',
    'priceBook.promo.edit': 'تعديل الرمز',
    'priceBook.promo.scopeNote': 'النطاق بالغياب: بلا خطة يعني كل الخطط، وبلا سوق يعني كل الأسواق. اتركهما لرمز إطلاق؛ وضيّق أحدهما لشراكة.',
    'priceBook.promo.code': 'الرمز',
    'priceBook.promo.codeHint': 'يُحوَّل إلى حروف كبيرة عند الحفظ، فتكون الهجاءات الواحدة رمزًا واحدًا.',
    'priceBook.promo.codeFixed': 'ثابت: هذا الرمز مسمّى في كل طلب سُعِّر به.',
    'priceBook.promo.rate': 'الخصم',
    'priceBook.promo.rateHint': 'من المجموع الفرعي. ولا يُركَّب مع خصم الكمية — كلاهما يُخصم من الرقم ذاته.',
    'priceBook.promo.from': 'من',
    'priceBook.promo.to': 'آخر يوم',
    'priceBook.promo.windowHint': 'الفراغ يعني منذ الأزل.',
    'priceBook.promo.toHint': 'آخر يوم يعمل فيه. والفراغ يعني حتى إشعار آخر.',
    'priceBook.promo.plan': 'الخطة',
    'priceBook.promo.planHint': 'أيّ عضوية ينطبق عليها.',
    'priceBook.promo.everyPlan': 'كل الخطط',
    'priceBook.promo.market': 'السوق',
    'priceBook.promo.marketHint': 'الرمز المقيَّد بسوق يُرفض في تسعيرة لم تُسمَّ فيها الدولة.',
    'priceBook.promo.everyMarket': 'كل الأسواق',
    'priceBook.promo.maxRedemptions': 'سقف الاستخدام',
    'priceBook.promo.maxRedemptionsHint': 'الفراغ يعني بلا حد. ويُحتسب بالمدفوعات المؤكَّدة لا بالطلبات المتروكة.',
    'priceBook.promo.unlimited': 'بلا حد',
    'priceBook.promo.spent': 'استُخدم {count} مرة بالفعل — وأي سقف دون ذلك يُرفض.',
    'priceBook.promo.statTotal': 'الرموز',
    'priceBook.promo.statLive': 'فعّالة',
    'priceBook.promo.statNotPricing': 'لا تُسعّر حاليًا',
    'priceBook.promo.statRedemptions': 'مرات الاستخدام',
    'priceBook.promo.activeOnly': 'الرموز العاملة فقط',
    'priceBook.promo.live': 'عامل',
    'priceBook.promo.notPricing': 'لا يُسعِّر',
    'priceBook.promo.withdrawn': 'مسحوب',
    'priceBook.promo.withdraw': 'سحب',
    'priceBook.promo.reinstate': 'إعادة',
    'priceBook.promo.scope': 'ينطبق على',
    'priceBook.promo.window': 'النافذة',
    'priceBook.promo.alwaysOn': 'بلا نافذة',
    'priceBook.promo.redeemed': 'الاستخدام',
    'priceBook.promo.ofUnlimited': '{count} من بلا حد',
    'priceBook.promo.none': 'لا رموز خصم',
    'priceBook.promo.noneHint': 'الخصم قرار تجاري له مُصدِر ونافذة وسقف. ولم يُتخذ أي قرار بعد.',

    // ─── ما ينتظرك (§6b.2) ──────────────────────────────────────────────────
    'needsYou.grading': 'تقييمات للتصحيح',
    'needsYou.grading.what': 'أعمال مُسلَّمة تنتظر مصححًا',
    'needsYou.quizMarking': 'إجابات اختبارات للتصحيح',
    'needsYou.quizMarking.what': 'إجابات مكتوبة أُرسلت وتنتظر مصححًا',
    'needsYou.completion': 'شهادات للإصدار',
    'needsYou.completion.what': 'من أنهوا ولم تُغلق سجلاتهم',
    'needsYou.unstaffed': 'دفعات بلا مدرّب',
    'needsYou.unstaffed.what': 'تجاوزت المسودة ولم يُكلَّف أحد بتدريسها',
    'needsYou.requests': 'طلبات دفعات',
    'needsYou.requests.what': 'شركات تطلب دفعة لم تبدأ بعد',
    'needsYou.arrivalsCrm': 'وافدون للقبول',
    'needsYou.arrivalsCrm.what': 'صفقات فائزة تنتظر التحقق وتسجيل الدخول',
    'needsYou.arrivalsHrm': 'وافدو الموارد البشرية للقبول',
    'needsYou.arrivalsHrm.what': 'موظفون كُلِّفوا بالتدريب أو التدريس وينتظرون تسجيل الدخول',
    'needsYou.arrivalsAcademy': 'وافدو العضويات للقبول',
    'needsYou.arrivalsAcademy.what': 'عضويات اشتُريت من الصفحة العامة وتنتظر التحقق',
    // ─── Screen intros (§6d.3) ────────────────────────────────────────────
    'screen.cohortCreate.intro': 'اختر نسخة المنهج هنا — إنشاء الدفعة يثبّتها ويجمّدها، فاختر بعناية قبل الحفظ.',
    'screen.cohortDetail.intro': 'سجل هذه الدفعة وجدولها ومشاركة المتدربين في مكان واحد — أضف جلسة أو سجّل متدربًا من هنا مباشرة.',
    'screen.enrollBatch.intro': 'سجّل عدة أشخاص في هذه الدفعة دفعة واحدة — اختر النمط الذري أو أفضل جهد قبل لصق القائمة.',
    'screen.completionBatch.intro': 'الصق صفوف الإنجاز من تصدير نظام تعلّم لتسجيل تقدّم عدة تسجيلات دفعة واحدة.',
    'screen.grading.intro': 'كل عمل مُسلَّم بانتظار مصحّح — أكّد الدرجة أو أعد العمل دون فتح كل عنصر على حدة.',
    'screen.enrollmentsQueue.intro': 'الأشخاص الذين أنجزوا العمل وينتظرون منسّقًا — طابور القمرة الثاني، كقائمة يمكنك العمل منها.',
    'screen.assessmentDetail.intro': 'عمل واحد بالكامل — اقرأه، شغّل الفحوصات، ثم أكّد الدرجة أو أعده لمحاولة أخرى.',
    'screen.credentials.intro': 'اطّلع على ما يحمله شخص، أو أصدر شهادة — اختر الحامل أولًا؛ الشهادات لا تُسرد بالجملة أبدًا.',
    'screen.credentialDetail.intro': 'شهادة واحدة كما صدرت — جدّدها أو ألغِها، أو افتح نفس الرابط الذي يستخدمه صاحب العمل للتحقق منها.',
    'screen.curriculum.intro': 'كل نسخة منهج، مثبَّتة أو متقاعدة — افتح واحدة لتحرير مستوياتها ووحداتها قبل أن تتجمّد.',
    'screen.curriculumVersionDetail.intro': 'بنية هذه النسخة تُقفل لحظة تثبيت دفعة عليها — حرّر مستوياتها ووحداتها وهي ما تزال مفتوحة.',
    'screen.curriculumModuleDetail.intro': 'رمز هذه الوحدة الدائم، نصّها القابل للتحرير، ومجموعات الأبعاد والأدوات التي تُدرّسها.',
    'screen.quizEditor.intro': 'أنشئ أسئلة هذا الاختبار وخياراته هنا — رتّبها ثم انشرها حين تكون الوحدة جاهزة للاختبار.',
    'screen.programs.intro': 'ما تبيعه الأكاديمية، حسب المنهج — افتح برنامجًا لترى وحداته والدرجات التي يشترطها اعتماده.',
    'screen.programDetail.intro': 'وحدات هذا البرنامج ومعاييره، ودرجات الوحدات التي يُصدَر اعتماده على أساسها.',
    // THE TESTS HR SENDS (STANDALONE-ASSESSMENTS-PLAN §1).
    'nav.assessments': 'التقييمات',
    'nav.assessments.what': 'الاختبارات التي ترسلها الموارد البشرية',
    'screen.assessments.intro': 'الاختبارات المسماة التي ترسلها الموارد البشرية للمتقدمين والموظفين — كل اختبار مجموعة من اختبارات الفرز والمهام المنشورة، موسومة بالمهارات التي يقيسها.',
    'screen.assessmentEditor.intro': 'ما يقول هذا الاختبار إنه يقيسه، وممّا يتكوّن من عناصر الفرز — انشره ليصبح متاحًا للموارد البشرية.',
    'assessment.create': 'تقييم جديد',
    'assessment.name': 'الاسم',
    'assessment.namePlaceholder': 'أساسيات ريفيت',
    'assessment.description': 'الوصف',
    'assessment.skills': 'المهارات المقيسة',
    'assessment.skillsHint': 'الكلمات التي تقرؤها الموارد البشرية بجانب مهارات الشاغر — لا شيء يطابقها تلقائيًا.',
    'assessment.skillAdd': 'إضافة',
    'assessment.skillPlaceholder': 'ريفيت',
    'assessment.skillRemove': 'إزالة {skill}',
    'assessment.skillDuplicate': 'هذه المهارة مدرجة بالفعل.',
    'assessment.language': 'اللغة',
    'assessment.languageHint': 'يجب أن يُكتب كل عنصر في الاختبار بها.',
    'assessment.passingScore': 'درجة النجاح',
    'assessment.passingScoreHint': 'تظهر للموارد البشرية بجانب النتيجة، ولا تقرر شيئًا هنا.',
    'assessment.timeLimit': 'المدة (بالدقائق)',
    'assessment.timeLimitHint': 'اتركها فارغة لاستخدام مجموع أوقات العناصر.',
    'assessment.items': 'محتوى الاختبار',
    'assessment.itemsHint': 'اختبارات الفرز والمهام المنشورة، بالترتيب الذي يراه المرشح. يُحفظ الترتيب والحذف فور إجرائه.',
    'assessment.itemsEmpty': 'لا شيء في هذا الاختبار بعد.',
    'assessment.addItems': 'إضافة عناصر',
    'assessment.addChosen': 'إضافة {n}',
    'assessment.itemSearchPlaceholder': 'ابحث بالعنوان أو الوحدة أو رمز المهارة…',
    'assessment.itemQuizMeta': '{questions} أسئلة · {minutes} دقيقة',
    'assessment.itemTaskMeta': 'عملي · {minutes} دقيقة',
    'assessment.itemUnpublished': 'أُلغي نشره',
    'assessment.alreadyAdded': 'مُضاف بالفعل',
    'assessment.roomLeft': 'يتسع لـ {n} إضافية',
    'assessment.noItems': 'لا عناصر فرز منشورة بهذه اللغة',
    'assessment.noItemsHint': 'تُكتب اختبارات الفرز والمهام على الوحدة التي تُدرّس المهارة، ثم تُنشر هناك.',
    'assessment.searchPlaceholder': 'ابحث بالاسم أو المهارة…',
    'assessment.empty': 'لا تقييمات بعد',
    'assessment.emptyHint': 'التقييم اختبار مسمّى يمكن للموارد البشرية إرساله — كوّنه من اختبارات الفرز والمهام المنشورة.',
    'assessment.noMatches': 'لا تقييم مطابق',
    'assessment.noMatchesHint': 'يبحث في الأسماء وكلمات المهارات.',
    'assessment.noSkills': 'لم تُذكر مهارات بعد',
    'assessment.summary': '{items} عناصر · {questions} أسئلة · {minutes} دقيقة',
    'assessment.sentCount': 'أُرسل {n} مرة',
    'assessment.draft': 'مسودة',
    'assessment.published': 'منشور',
    'assessment.archived': 'مؤرشف',
    'assessment.publish': 'نشر',
    'assessment.unpublish': 'إلغاء النشر',
    'assessment.archive': 'أرشفة',
    'assessment.restore': 'استعادة',
    'assessment.duplicate': 'نسخ',
    'assessment.backToList': 'كل التقييمات',
    'assessment.showArchived': 'إظهار المؤرشفة',
    'assessment.standalone': 'مستقل',
    'screen.checkCodes.intro': 'قائمة الملاحظات المغلقة التي قد يرفعها المصححون — قائمة فارغة تعني أن المدربين يصححون دون مساعدة.',
    'screen.priceBook.intro': 'تكلفة المقعد وأي عروض ترويجية عليه — علامتان تبويب لأن السعر والخصم قراران مختلفان.',
    'screen.enrollmentDetail.intro': 'تقدّم متدرب واحد في دفعة واحدة — سجّل الإنجازات، أعفِ من وحدة، أو حرّك مسيرته.',
    'screen.instructorAvailability.intro': 'من غائب ومتى — جدول فارغ بلا طابع زمني يعني أن أحدًا لم يُخبرنا بعد، لا أن لا أحد غائب.',
    'screen.people.intro': 'كل شخص تعرفه الأكاديمية — متدربون ومدربون وموظفون — ابحث هنا قبل فتح سجل واحد.',
    'screen.personDetail.intro': 'ملف شخص واحد وشهاداته — حرّر سجله، ضعه في دفعة، أو قيّم وضعه.',
    'screen.companies.intro': 'حسابات الشركات والمقاعد التي اشترتها — افتح حسابًا لإدارة أعضائه أو وضع أشخاص في دفعة.',
    'screen.cohortRequests.intro': 'شركات تطلب دفعة لم توجد بعد — أجب بتسمية الدفعة التي بدأتها، أو ارفض مع سبب.',
    'screen.learnModule.intro': 'هذه الوحدة كما يراها المتدرب — الدروس والتكليف وأي اختبار، مع تقدّمك مؤشّرًا أولًا بأول.',
    'screen.lessonPlayer.intro': 'درس واحد قيد التشغيل — شاهد المادة أو اقرأها، دوّن الملاحظات، وعلّمه منجزًا عند الانتهاء.',
    'screen.my.intro': 'تسجيلاتك وشهاداتك الخاصة — لا شيء هنا شاشة موظفين، فقط السجلات التي تخصك.',
    'screen.arrivals.intro': 'عملاء حوّلتهم إدارة العملاء وينتظرون التحقق — اتصل لتأكيدهم ثم أصدر تسجيل دخولهم.',
    'screen.arrivalsHrm.intro': 'موظفون كلّفتهم الموارد البشرية بالتدريب أو التدريس — تحقّق منهم ثم أصدر تسجيل الدخول الذي يبدأهم.',
    'screen.arrivalsAcademy.intro': 'عضويات اشتُريت من الصفحة العامة — اقبل أي حساب فشل إنشاؤه، ثم أصدر تسجيل الدخول.',
    'screen.company.intro': 'حسابك بلمحة — المقاعد والدفعات وما يتعلّمه أفرادك، كله من لوحتك الخاصة.',
    'screen.companyProgrammes.intro': 'ما اشتراه حسابك فعلًا — ليس الكتالوج العام، بل المسارات المتاحة لك أنت.',
    'screen.companyCohorts.intro': 'الدفعات التي شُغِّلت لحسابك، محدَّدة بشركتك لا بمن سُجِّل فيها — حتى الفارغة تبقى مدرجة.',
    'screen.companyPeople.intro': 'كل من يمكن لحسابك إرساله للتدريب — أضف شخصًا جديدًا أو أصدر تسجيل دخوله من هنا.',
    'screen.companyEnrollments.intro': 'سجّل أفرادك في دفعة تملك فيها مقعدًا بالفعل — هذا يستهلك مقعدًا فورًا.',
    'screen.companyRequests.intro': 'اطلب دفعة لم توجد بعد — يختلف عن التسجيل، لأن لا شيء يُلتزم به حتى تجيب الأكاديمية.',
    'screen.companyLearning.intro': 'ما يتعلّمه أفرادك، صفٌّ واحد لكل وحدة لا لكل شخص.',
    'screen.companyReadiness.intro': 'حكم محرك الكفاءات لكل مقعد يملكه حسابك.',
    'screen.companyAttendance.intro': 'من حضر أي جلسة، عبر كل دفعة يديرها حسابك.',

    // ─── Marking context, feedback and the learner's mark ──────────────────────
    'grading.feedbackToLearner': 'ملاحظات للمتدرّب',
    'grading.feedbackToLearnerHint': 'اختياري. تظهر بجانب الدرجة وتُرسل إلى المتدرّب بالبريد معها — اذكر ما كان جيدًا وما عليه فعله بعد ذلك.',
    'grading.waitingSince': 'سُلِّم {when}',
    'grading.handedInUnrecordedShort': 'لم يُسجَّل وقت التسليم',
    'grading.dueOn': 'موعد التسليم {date}',
    'learn.dueOn': 'موعد التسليم {date}. حدّد المدرّب هذا الموعد لدفعتك.',
    'learn.markedScore': 'الدرجة: {score}%',
    'learn.markerComments': 'ملاحظات المدرّب',
    'learn.noMarkerComments': 'لم يضف المدرّب ملاحظات.',

    // ─── Messages to learners and due dates ────────────────────────────────────
    'message.open': 'مراسلة المتدرّبين',
    'message.title': 'رسالة إلى المتدرّبين',
    'message.toCohort': 'سيصل هذا بالبريد إلى كل المسجّلين حاليًا في الدفعة {cohort}.',
    'message.toSome': 'يُرسل بالبريد إلى: {names}',
    'message.subject': 'الموضوع',
    'message.body': 'الرسالة',
    'message.bodyHint': 'تُرسل من الأكاديمية باسمك وبريدك الإلكتروني ليتمكّن المتدرّبون من الرد عليك.',
    'message.send': 'إرسال',
    'message.sent': 'أُرسلت إلى {count} متدرّب.',
    'deadline.label': 'موعد تسليم العمل',
    'deadline.save': 'حفظ الموعد',
    'deadline.clear': 'إزالة',
    'deadline.hint': 'يرى المتدرّبون هذا الموعد، ويُذكَّر من لم يسلّم قبله بيومين. يُقبل العمل المتأخر أيضًا.',
    'deadline.dueOn': 'موعد تسليم عمل هذه الوحدة {date}.',

    // ─── The learner's home, course page and schedule ──────────────────────────
    'nav.myRecords': 'السجلات والشهادات',
    'nav.myRecords.what': 'كل دوراتك وشهاداتك',
    'nav.schedule': 'جدولي',
    'nav.schedule.what': 'المحاضرات ومواعيد التسليم',
    'screen.myHome.intro': 'درسك التالي، والأعمال المستحقة أو المُعادة، ومحاضراتك للأسبوعين القادمين — في مكان واحد.',
    'screen.schedule.intro': 'كل محاضرة وموعد تسليم يخصّك، كمتدرّب أو كمدرّب. أضفها إلى تقويمك بنقرة واحدة.',
    'myHome.title': 'تعلّمي',
    'myHome.greeting': 'مرحبًا بعودتك يا {name}',
    'myHome.subtitle': 'إليك ما عليك فعله الآن.',
    'myHome.continue': 'تابع التعلّم',
    'myHome.instructor': 'المدرّب: {name}',
    'myHome.modulesDone': 'أنجزت {done} من {total} وحدات',
    'myHome.nextLesson': 'التالي: {module} — {lesson}',
    'myHome.nextModule': 'التالي: {module}',
    'myHome.allCaughtUp': 'أنت مواكب. بانتظار المدرّب للخطوة التالية.',
    'myHome.viewCourse': 'عرض الدورة',
    'myHome.askInstructor': 'اسأل مدرّبي',
    'myHome.due': 'المستحق والمُعاد',
    'myHome.nothingDue': 'لا يوجد عمل مستحق خلال الشهر القادم، ولم يُعَد إليك شيء.',
    'myHome.sentBack': 'مُعاد',
    'myHome.overdue': 'كان مستحقًا في {date}',
    'myHome.dueOn': 'مستحق في {date}',
    'myHome.classes': 'المحاضرات القادمة',
    'myHome.noClasses': 'لا توجد محاضرات مباشرة خلال الأسبوعين القادمين.',
    'myHome.openClass': 'فتح',
    'myHome.openWork': 'فتح العمل',
    'myHome.marks': 'الدرجات الواردة',
    'myHome.readComments': 'اقرأ الملاحظات',
    'myHome.certificates': 'الشهادات',
    'myHome.certificateOnItsWay': 'أنهيت {program}. يجري إعداد شهادتك — سنراسلك فور إصدارها.',
    'myHome.certificatesHeld': 'لديك {count} شهادة — اعرضها أو شاركها أو اطبعها',
    'myHome.whatNext': 'ما التالي',
    'myHome.explore': 'استكشف برامج أخرى',
    'myHome.exploreHint': 'اطّلع على ما تقدّمه الأكاديمية أيضًا وإلى أين يقود.',
    'myHome.records': 'سجلاتي وشهاداتي',
    'myHome.recordsHint': 'كل دورة التحقت بها، وكل شهادة تحملها.',
    'myHome.calendarName': 'أكاديمية بناء',
    'myCourse.title': 'دورتي',
    'myCourse.runs': 'من {from} إلى {to}',
    'myCourse.modules': 'الوحدات',
    'myCourse.standing.notStarted': 'لم يبدأ',
    'myCourse.standing.inProgress': 'قيد التقدّم',
    'myCourse.standing.done': 'مكتمل',
    'myCourse.standing.passed': 'ناجح',
    'myCourse.standing.failed': 'يحتاج محاولة أخرى',
    'myCourse.standing.waived': 'مُعفى',
    'askInstructor.title': 'رسالة إلى {name}',
    'askInstructor.intro': 'بخصوص {program}. يصل هذا إلى مدرّبك بالبريد مع عنوانك ليردّ عليك مباشرة.',
    'askInstructor.sent': 'أُرسلت. سيرد مدرّبك على بريدك الإلكتروني.',
    'credentialShare.copyLink': 'نسخ الرابط',
    'credentialShare.linkedIn': 'أضِف إلى LinkedIn',
    'credentialShare.print': 'طباعة أو حفظ PDF',
    'schedule.subtitle': 'أربعة أسابيع في كل مرة، كمتدرّب وكمدرّب.',
    'schedule.addToCalendar': 'إضافة إلى التقويم',
    'schedule.earlier': 'السابق',
    'schedule.later': 'التالي',
    'schedule.today': 'اليوم',
    'schedule.range': '{from} – {to}',
    'schedule.emptyTitle': 'لا شيء مجدول خلال هذه الأسابيع الأربعة',
    'schedule.emptyHint': 'تظهر المحاضرات ومواعيد التسليم هنا عندما يحددها المدرّبون.',
    'schedule.minutes': '{count} دقيقة',
    'schedule.dueEvent': 'موعد التسليم: {module} ({cohort})',
    'schedule.role.learner': 'متدرّب',
    'schedule.role.instructor': 'تدريس',
    'schedule.state.Held': 'عُقدت',
    'schedule.state.Cancelled': 'أُلغيت',
    'schedule.state.Scheduled': 'مجدولة',

    // ─── The instructor's own record, registers and marking ────────────────────
    'nav.myTeaching': 'تدريسي',
    'nav.myTeaching.what': 'الساعات والإجازات والملاحظات',
    'screen.myTeaching.intro': 'سجلّك كما تحفظه الأكاديمية: الساعات والإجازات والكشوف التي لم تُراجَع وما قاله متدرّبوك.',
    'myTeaching.subtitle': 'ما تسجّله الأكاديمية عن تدريسك.',
    'myTeaching.notInstructor': 'ليس لديك ملف مدرّب',
    'myTeaching.notInstructorHint': 'هذه الصفحة للمدرّبين. يمكن للمنسّق إضافة ملف مدرّب إلى سجلّك.',
    'myTeaching.delisted': 'أُوقفتَ عن تدريس دفعات جديدة في {date}. تحدّث مع المنسّق بشأن إعادة الاعتماد.',
    'myTeaching.hours30': 'الساعات خلال 30 يومًا',
    'myTeaching.hoursYear': 'ساعات هذا العام',
    'myTeaching.hoursHint': 'من المحاضرات المسجّلة كمنعقدة — وهو الرقم المُرسل إلى الموارد البشرية.',
    'myTeaching.sessionsYear': '{count} محاضرة منعقدة',
    'myTeaching.cohorts': 'الدفعات التي أدرّسها',
    'myTeaching.noCohorts': 'لست مكلّفًا بدفعة جارية حاليًا.',
    'myTeaching.learners': '{count} متدرّب',
    'myTeaching.toMark': '{count} للتصحيح',
    'myTeaching.registersIntro': 'عند تسجيل المحاضرة كمنعقدة يُسجَّل الجميع حاضرين. افتح كل محاضرة وأزل علامة الغائبين.',
    'myTeaching.toCloseOut': 'محاضرات بانتظار الإغلاق',
    'myTeaching.toCloseOutIntro': 'انتهى موعد هذه المحاضرات دون تحديدها كمنعقدة، لذا تبقى الدروس التالية مقفلة إلى أن تفتح كل واحدة وتحدّد إن كانت قد انتهت.',
    'myTeaching.awaitingNewDate': 'بحاجة إلى موعد جديد',
    'myTeaching.leave': 'إجازاتي',
    'myTeaching.noLeave': 'لا توجد إجازات معتمدة مسجّلة من اليوم فصاعدًا.',
    'myTeaching.leaveRange': '{from} – {to}',
    'myTeaching.leaveHint': 'تأتي الإجازات من الموارد البشرية بعد اعتمادها. إن نقص شيء فاسأل الموارد البشرية — لا تستطيع الأكاديمية تعديلها.',
    'myTeaching.comments': 'ما قاله المتدرّبون',
    'myTeaching.noComments': 'لا توجد ملاحظات مكتوبة بعد.',
    'myTeaching.standing': 'وضعي',
    'myTeaching.certifiedOn': 'معتمد منذ {date}',
    'myTeaching.lastAudit': 'آخر مراجعة في {date}: {outcome}',
    'myTeaching.noAudit': 'لم تُراجع جودة تدريسك بعد.',
    'dashboard.registersToCheck': 'كشوف حضور للمراجعة',
    'dashboard.registersToCheckHint': 'محاضرات منعقدة ما زالت تُظهر الجميع حاضرين',
    'dashboard.attendanceUnchecked': '{count} كشف لم يُراجَع بعد — يُحسب الجميع حاضرين',
    'cohortSessions.registerChecked': 'رُوجع في {when}',
    'cohortSessions.registerUnchecked': 'لم يُراجَع بعد — الجميع مسجّلون حاضرين حتى تحفظ هذا الكشف.',

    'needsYou.registers': 'كشوف حضور للمراجعة',
    'needsYou.registers.what': 'محاضرات منعقدة ما زالت تُظهر الجميع حاضرين',
    'needsYou.closeOut': 'محاضرات بانتظار الإغلاق',
    'needsYou.closeOut.what': 'محاضرات انتهى موعدها ولم تُحدَّد كمنعقدة',

    // ─── Company portal: seats, people, reports, billing ───────────────────────
    'export.csv': 'تصدير إلى جدول بيانات',
    'export.completedAt': 'تاريخ الإكمال',
    'export.modulesPassed': 'الوحدات المجتازة',
    'export.modulesTotal': 'الوحدات',
    'export.moduleCode': 'رمز الوحدة',
    'export.module': 'الوحدة',
    'export.credits': 'الساعات المعتمدة',
    'export.learners': 'المتدرّبون',
    'export.sessionsAttended': 'المحاضرات التي حضرها',
    'companyImport.open': 'استيراد قائمة',
    'companyImport.lead': 'الصق من جدول بيانات أو اختر ملف CSV. الأعمدة: الاسم، البريد، الهاتف (اختياري). لا بأس بصف العناوين.',
    'companyImport.pickFile': 'اختر ملف CSV',
    'companyImport.paste': 'الأشخاص المراد إضافتهم',
    'companyImport.placeholder': 'Layla Hassan, layla@company.com, +201000000000',
    'companyImport.preview': '{count} شخص جاهزون للإضافة.',
    'companyImport.submit': 'إضافة {count} شخص',
    'companyImport.result': 'أُضيف {added} من {total}. من لم يُضف مذكور أدناه مع السبب.',
    'companyImport.row': 'الصف {row}',
    'companyMember.editTitle': 'تصحيح بيانات هذا الشخص',
    'companyMember.nameHint': 'بالحروف الإنجليزية، كما يجب أن يظهر على الشهادة تمامًا.',
    'companyMember.emailLocked': 'يسجّل الدخول بهذا العنوان بالفعل. اطلب من جهة اتصالك في الأكاديمية تغييره.',
    'companyMember.remove': 'إزالة',
    'companyMember.removeTitle': 'إزالة {name} من حسابكم؟',
    'companyMember.removeMessage': 'سيُزال من قائمتكم، ويبقى سجلّه وشهاداته له. يجب سحب من ما زال في دفعة أولًا.',
    'company.notEnrollableWhy': 'لم يُجهَّز كمتدرّب بعد — اسأل جهة اتصالك في الأكاديمية.',
    'company.allOrNothing': 'سجّلهم فقط إذا حصل الجميع على مقعد',
    'company.goReport': 'تقرير للإدارة',
    'company.targetRole': 'يُعَدّ لوظيفة',
    'company.browseCatalogue': 'اطّلع على كل ما تقدّمه الأكاديمية',
    'company.askForQuote': 'اطلب مقاعد إضافية أو عرض سعر',
    'companySeat.swap': 'منحه لشخص آخر',
    'companySeat.withdraw': 'سحب',
    'companySeat.withdrawTitle': 'سحب {name} من {cohort}؟',
    'companySeat.withdrawMessage': 'يعود المقعد إلى حسابكم، ويبقى ما أنجزه في سجلّه.',
    'companySeat.swapTitle': 'منح مقعد {name} في {cohort} لشخص آخر',
    'companySeat.swapLead': 'نتحقق من أن الشخص الجديد يستطيع أخذ المقعد قبل سحب أي أحد.',
    'companySeat.replacement': 'الشخص الجديد',
    'companySeat.swapConfirm': 'تسليم المقعد',
    'companyPerson.noSignIn': 'لا يستطيع تسجيل الدخول بعد',
    'companyPerson.credits': '{credits} ساعة معتمدة مكتسبة',
    'companyPerson.noCourses': 'غير مسجّل في أي دورة بعد.',
    'companyPerson.attendance': 'حضر {attended} من {expected} محاضرة',
    'companyPerson.moduleCredits': '{credits} س.م',
    'companyPerson.signedOff': 'اعتمده {name} في {when}',
    'companyPerson.signOff': 'اعتماد هذه الدورة',
    'companyPerson.supervisorSignOff': 'اعتماد المشرف',
    'companyPerson.signOffLead': 'تعتمد مؤسستكم هذه الدورة المكتملة. يُسجَّل ذلك باسمك ولا يغيّر سجلّ الأكاديمية.',
    'companyPerson.signOffNote': 'ملاحظة (اختيارية)، مثل الساعات المعتمدة الممنوحة',
    'companyPerson.signOffConfirm': 'اعتماد',
    'nav.companyCertificates': 'الشهادات',
    'nav.companyCertificates.what': 'من يحمل ماذا وحتى متى',
    'nav.companyReport': 'التقرير',
    'nav.companyReport.what': 'صفحة واحدة لإدارتكم',
    'nav.companyBilling': 'الفواتير',
    'nav.companyBilling.what': 'الطلبات والإيصالات والتجديدات',
    'screen.companyCertificates.intro': 'كل شهادة يحملها موظفوكم، ولكل منها صفحة عامة يمكن للمدقق التحقق منها.',
    'screen.companyReport.intro': 'المقاعد والساعات والنتائج ومن يحتاج متابعة — اطبعه أو احفظه PDF.',
    'screen.companyBilling.intro': 'ما اشتريتموه من الأكاديمية مع الإيصالات، وموعد تجديد كل عضوية.',
    'companyCertificates.lead': 'الشهادات التي يحملها موظفوكم. شارك الرابط العام مع من يحتاج إثباتًا.',
    'companyCertificates.title': 'الشهادة',
    'companyCertificates.link': 'الرابط العام',
    'companyCertificates.none': 'لا توجد شهادات بعد',
    'companyCertificates.noneHint': 'تظهر هنا عندما يُنهي موظفوكم برامجهم.',
    'companyCertificates.noExpiry': 'لا تنتهي',
    'companyBilling.lead': 'الطلبات المدفوعة عبر صفحة الدفع مع الإيصالات. المقاعد المتفق عليها في عقد البيع تظهر في النظرة العامة.',
    'companyBilling.memberships': 'العضويات ومواعيد التجديد',
    'companyBilling.noMemberships': 'لا توجد عضوية مشتراة عبر صفحة الدفع.',
    'companyBilling.ref': 'المرجع',
    'companyBilling.plan': 'الخطة',
    'companyBilling.seats': 'المقاعد',
    'companyBilling.started': 'البدء',
    'companyBilling.renews': 'التجديد',
    'companyBilling.orders': 'الطلبات',
    'companyBilling.paid': 'تاريخ الدفع',
    'companyBilling.net': 'قبل الضريبة',
    'companyBilling.tax': 'الضريبة',
    'companyBilling.total': 'الإجمالي',
    'companyBilling.currency': 'العملة',
    'companyBilling.noOrders': 'لا توجد طلبات بعد',
    'companyBilling.noOrdersHint': 'المقاعد المتفق عليها مع فريق المبيعات يُصدر فريق المبيعات فواتيرها، لا هنا.',
    'companyBilling.receipt': 'إيصال',
    'companyBilling.receiptTitle': 'إيصال دفع',
    'companyBilling.billedTo': 'صادر إلى',
    'companyBilling.discount': 'الخصم',
    'companyBilling.taxAt': 'الضريبة ({rate}%)',
    'companyBilling.receiptNote': 'سجل لدفعة مستلمة. للحصول على فاتورة ضريبية باسم مؤسستكم، اسأل جهة اتصالك واذكر المرجع.',
    'companyRisk.title': 'يحتاج متابعة',
    'companyRisk.reasons': 'السبب',
    'companyRisk.lastActive': 'آخر نشاط',
    'companyRisk.none': 'لا أحد يحتاج متابعة الآن: الجميع بدأ ونشط ويحضر وملتزم بالمواعيد.',
    'companyRisk.lastActiveOn': 'آخر نشاط {date}',
    'companyRisk.neverActive': 'لا يوجد نشاط بعد',
    'companyRisk.attendance': 'الحضور {rate}',
    'companyRisk.reason.notStarted': 'لم يبدأ',
    'companyRisk.reason.inactive': 'غير نشط منذ أسبوعين أو أكثر',
    'companyRisk.reason.lowAttendance': 'حضور منخفض',
    'companyRisk.reason.overdue': 'عمل متأخر',
    'companyRisk.reason.overdueCount': '{count} متأخر',
    'companyRisk.reason.failed': 'رسب في وحدة',
    'companyReport.lead': 'كل ما يلي يُطبع في صفحة أو صفحتين. استخدم نافذة الطباعة في المتصفح لحفظه PDF.',
    'companyReport.heading': 'تقرير التدريب — {name}',
    'companyReport.asOf': 'حتى {date}',
    'companyReport.investment': 'المقاعد والأشخاص',
    'companyReport.outcomes': 'النتائج',
    'companyReport.delivery': 'التدريب المُقدَّم',
    'companyReport.hoursDelivered': 'ساعات التدريس',
    'companyReport.hoursAttended': 'ساعات حضور موظفيكم',
    'companyReport.hoursScheduled': 'الساعات المجدولة المتبقية',
    'companyReport.sessionsHeld': 'المحاضرات المنعقدة',
    'companyReport.passedOf': 'اجتاز {passed} من {learners}',
    'cohortRequest.preferredEnd': 'البدء في موعد لا يتجاوز',
    'cohortRequest.preferredEndHint': 'اختياري — يمنحنا نطاقًا بدل تاريخ واحد.',
    'cohortRequest.seating': 'طريقة التدريس',
    'cohortRequest.seating.remote': 'عن بُعد',
    'cohortRequest.seating.academyPremises': 'في الأكاديمية',
    'cohortRequest.seating.clientPremises': 'في مقرّنا',
    'cohortRequest.language': 'اللغة',
    'cohortRequest.intake': 'الفريق أو المشروع',
    'cohortRequest.intakeHint': 'اختياري — اسمكم الخاص لهذه المجموعة.',
    'cohortRequest.intakeUniversity': 'الدفعة أو الفصل الدراسي',
    'cohortRequest.intakeUniversityHint': 'مثل "ربيع 2027" أو "السنة الثالثة مدني".',
    'cohortRequest.withdrawn': 'مسحوب',
    'cohortRequest.startBy': 'البدء قبل {date}',
    'cohortRequest.withdraw': 'سحب الطلب',

    // ─── /about from the database: the public showcases and the site copy ───
    'nav.siteContent': 'نصوص الموقع العام',
    'nav.siteContent.what': 'نصوص صفحة «من نحن» العامة بكل اللغات',
    'screen.siteContent.intro': 'عدّل مقدمة صفحة «من نحن» ونتائجها ومواردها؛ كل حفظ مُسجَّل في سجل التدقيق.',
    'publicSite.published': 'منشور',
    'publicSite.draft': 'مسودة',
    'publicSite.notSetUp': 'غير معروض على الموقع العام',
    'publicSite.publish': 'إظهار على الموقع العام',
    'publicSite.publishHint': 'بموافقة فقط: يُرفض النشر حتى يُسجَّل أدناه تاريخ الموافقة.',
    'publicSite.consentAt': 'تاريخ تسجيل الموافقة',
    'publicSite.consentHint': 'التاريخ الذي وافق فيه هذا الشخص أو هذه الجهة على الظهور علنًا. مطلوب للنشر.',
    'publicSite.slug': 'العنوان العام',
    'publicSite.slugHint': 'أحرف لاتينية صغيرة وأرقام وشرطات، مثل layla-haddad.',
    'publicSite.sortOrder': 'ترتيب العرض',
    'publicSite.tags': 'الوسوم',
    'publicSite.tagsHint': 'مفصولة بفواصل، 8 كحد أقصى.',
    'publicSite.photo': 'الصورة الشخصية',
    'publicSite.logo': 'الشعار',
    'publicSite.imageHint': 'JPEG أو PNG أو WebP، حتى 5 ميغابايت.',
    'publicSite.removeImage': 'إزالة الصورة',
    'publicSite.chooseImage': 'اختر صورة',
    'publicSite.dropImage': 'أو أفلتها هنا',
    'publicSite.imagePending': 'صورة جديدة: {name}',
    'publicSite.imageRemoved': 'ستُزال الصورة عند الحفظ.',
    'publicSite.allLanguages': 'اكتبه باللغات الثلاث للنشر؛ لا تحل لغة محل أخرى.',
    'publicProfile.title': 'الملف العام',
    'publicProfile.edit': 'تعديل الملف العام',
    'publicProfile.jobTitle': 'المسمى',
    'publicProfile.bio': 'نبذة',
    'publicProfile.none': 'غير معروض على صفحة «من نحن» العامة.',
    'publicProfile.shownAs': 'العنوان العام: {slug}',
    'showcase.action': 'العرض العام',
    'showcase.edit': 'العرض العام — {name}',
    'showcase.group': 'يُعرض ضمن',
    'showcase.group.corporate': 'عملاء من القطاع الخاص',
    'showcase.group.academic': 'شركاء أكاديميون',
    'showcase.displayName': 'الاسم العام',
    'showcase.displayNameHint': 'الاسم الذي وافق العميل على الظهور به.',
    'showcase.descriptor': 'وصف مختصر',
    'showcase.summary': 'ما تم تقديمه',
    'showcase.facts': 'أرقام',
    'showcase.factsHint': 'حتى أربعة أرقام وافق عليها العميل، مثل 240 / موظف مُدرَّب.',
    'showcase.factValue': 'القيمة',
    'showcase.factLabel': 'التسمية',
    'showcase.addFact': 'إضافة رقم',
    'siteContent.block.about.hero': 'من نحن — المقدمة',
    'siteContent.block.about.outcomes': 'من نحن — النتائج',
    'siteContent.block.about.resources': 'من نحن — الموارد',
    'siteContent.unwritten': 'لم يُكتب بعد — لا تعرض صفحة «من نحن» شيئًا لهذا القسم',
    'siteContent.editedAt': 'آخر حفظ {date}',
    'siteContent.reload': 'تحميل أحدث نسخة',
    'siteContent.saved': 'تم الحفظ',
    'siteContent.addRow': 'إضافة',
    'siteContent.remove': 'إزالة',
    'siteContent.moveUp': 'نقل لأعلى',
    'siteContent.moveDown': 'نقل لأسفل',
    'siteContent.field.title': 'العنوان',
    'siteContent.field.lead': 'المقدمة',
    'siteContent.field.heading': 'العنوان الرئيسي',
    'siteContent.field.note': 'ملاحظة',
    'siteContent.field.body': 'النص',
    'siteContent.field.icon': 'الأيقونة',
    'siteContent.field.tag': 'الوسم',
    'siteContent.field.items': 'العناصر',
    'siteContent.field.groups': 'المجموعات',
    // ─── استطلاع الأوقات والجلسات المُنشأة (SCHEDULING-PLAN A1, A2) ───
    'availability.cardTitle': 'ساعدنا في اختيار مواعيد حصصك',
    'availability.cardIntro': 'حدّد الأوقات التي تناسبك، ويختار المدرّب مواعيد الحصص من إجابات الجميع.',
    'availability.deadline': 'آخر موعد للرد: {when}',
    'availability.zone': 'الأوقات بتوقيتك: {zone}',
    'availability.answered': 'تمت الإجابة',
    'availability.notAnswered': 'لم تُجب بعد',
    'availability.mark': 'حدّد أوقاتي',
    'availability.change': 'تعديل إجاباتي',
    'availability.save': 'حفظ إجاباتي',
    'availability.saved': 'تم الحفظ. يمكنك تعديل إجاباتك حتى آخر موعد.',
    'availability.gridLabel': 'الأوقات التي تناسبك',
    'scheduling.title': 'تخطيط مواعيد الحصص',
    'scheduling.intro': 'اسأل المتعلّمين متى يتفرّغون، ثم أنشئ جلسات الدفعة من إجاباتهم.',
    'scheduling.ask': 'اسأل المتعلّمين متى يتفرّغون',
    'scheduling.generate': 'إنشاء الجلسات',
    'scheduling.lessonsWaiting': '{count} دروس مباشرة بلا جلسة بعد.',
    'scheduling.allScheduled': 'لكل درس مباشر جلسة بالفعل.',
    'scheduling.lastPattern': 'آخر إنشاء: {rule} الساعة {time}.',
    'scheduling.pollHeading': 'أوقات تفرّغ المتعلّمين',
    'scheduling.state.open': 'مفتوح',
    'scheduling.state.closed': 'مغلق',
    'scheduling.state.expired': 'منتهٍ',
    'scheduling.state.cancelled': 'ملغى',
    'scheduling.progress': 'أجاب {answered} من {total}',
    'scheduling.pollDeadline': 'تُغلق الإجابات {when}',
    'scheduling.heatmapLabel': 'عدد المتعلّمين القادرين على الحضور في كل وقت',
    'scheduling.zone': 'الأوقات بتوقيت الدفعة: {zone}.',
    'scheduling.busyLegend': 'الخانات الرمادية: أنت مشغول عادةً في هذا الوقت (حصص أخرى أو إجازة).',
    'scheduling.nobody': 'لا أحد بعد',
    'scheduling.ifNeededBy': 'إن لزم: {names}',
    'scheduling.busyWeeks': 'أنت مشغول في هذا الوقت في {busy} من {weeks} أسابيع.',
    'scheduling.suggestion': 'الأفضل حتى الآن: {days} الساعة {time}.',
    'scheduling.unanswered': 'لم يُجب بعد: {names}',
    'scheduling.remind': 'ذكّر البقية',
    'scheduling.reminded': 'أُرسل التذكير إلى {count}.',
    'scheduling.remindedNone': 'لا أحد لتذكيره الآن (وصلت رسالة للجميع خلال اليوم الماضي).',
    'scheduling.cancelPoll': 'إلغاء الاستطلاع',
    'scheduling.create.title': 'اسأل المتعلّمين متى يتفرّغون',
    'scheduling.create.intro': 'اختر الأيام والساعات بتوقيت الدفعة، وسيصل البريد إلى كل متعلّم مسجّل.',
    'scheduling.create.days': 'الأيام',
    'scheduling.create.from': 'من',
    'scheduling.create.to': 'حتى',
    'scheduling.create.duration': 'مدة الحصة (بالدقائق)',
    'scheduling.create.deadline': 'آخر موعد للرد',
    'scheduling.create.message': 'ملاحظة للمتعلّمين (اختيارية)',
    'scheduling.create.mailNote': 'من لا حساب له بعد يجيب من رابط شخصي في البريد.',
    'scheduling.create.send': 'إرسال إلى المتعلّمين',
    'scheduling.generate.title': 'إنشاء الجلسات',
    'scheduling.generate.intro': 'اختر النمط. تُنشأ جلسة لكل درس مباشر بلا جلسة، بالترتيب، ابتداءً من أول يوم في الدفعة.',
    'scheduling.generate.prefilled': 'مُعبّأ من أفضل أوقات المتعلّمين.',
    'scheduling.generate.closed': 'هذه الدفعة مغلقة فلا يمكن تغيير جلساتها.',
    'scheduling.generate.time': 'تبدأ الساعة',
    'scheduling.generate.duration': 'المدة (بالدقائق)',
    'scheduling.generate.zone': 'الأوقات بتوقيت الدفعة ({zone}).',
    'scheduling.generate.holidays': 'تواريخ تُتجاوز (إجازات)',
    'scheduling.generate.addHoliday': 'تجاوز هذا التاريخ',
    'scheduling.generate.unskip': 'إيقاف تجاوز {date}',
    'scheduling.generate.skipDate': 'تجاوز {date}',
    'scheduling.generate.notify': 'أرسل إلى المتعلّمين جدولهم بالبريد',
    'scheduling.generate.integrated': 'عقد الحصص في فصل الأكاديمية',
    'scheduling.generate.preview': 'معاينة',
    'scheduling.generate.save': 'إنشاء {count} جلسات',
    'scheduling.generate.noDates': 'هذا النمط لا يعطي أي تاريخ قبل انتهاء الدفعة.',
    'scheduling.generate.colDate': 'التاريخ',
    'scheduling.generate.colTime': 'الوقت',
    'scheduling.generate.colLesson': 'الدرس',
    'scheduling.generate.flag.instructorAbsent': 'المدرّب غائب',
    'scheduling.generate.flag.holiday': 'متجاوَز',
    'scheduling.generate.flag.extraOccurrence': 'لا درس متبقٍ',
    'scheduling.generate.flag.instructorBusy': 'حصة أخرى في الوقت نفسه',
    'scheduling.generate.extra': '…و{count} تواريخ أخرى بلا درس متبقٍ.',
    'scheduling.generate.unplaced': 'لا تاريخ لـ: {lessons}. وسّع النمط أو حدّد تاريخ نهاية أبعد.',
    'scheduling.generate.done': 'أُنشئت {count} جلسات وأُرسل الجدول إلى {mailed} من المتعلّمين.',

    // ── HR's screening test page (screens/screening/ScreeningTestPage.jsx) ──
    'screenTest.title': 'تقييم المهارات',
    'screenTest.greeting': 'مرحبًا {name}،',
    'screenTest.intro': 'أرسل إليك فريق الموارد البشرية هذا التقييم لقياس المهارات التي تتطلبها الوظيفة.',
    'screenTest.timeLimit': 'المدة المسموح بها: {minutes} دقيقة',
    'screenTest.startBy': 'ابدأ قبل {date}',
    'screenTest.rules.title': 'قبل أن تبدأ',
    'screenTest.rules.once': 'يمكنك أداء التقييم مرة واحدة فقط.',
    'screenTest.rules.device': 'استخدم جهازًا ومتصفحًا واحدًا من البداية حتى النهاية. بعد أن تبدأ لن يعمل الرابط في أي مكان آخر.',
    'myAssessments.title': 'تقييمات المهارات',
    'myAssessments.subtitle': 'اختبارات طلبت منك الموارد البشرية إجراءها. تذهب نتائجك إلى الموارد البشرية، لا إلى هذه الصفحة.',
    'myAssessments.linkHint': 'اختبارات المهارات التي أرسلتها لك الموارد البشرية',
    'myAssessments.toTake': 'تقييمات مهارات بانتظارك',
    'myAssessments.empty': 'لا توجد تقييمات',
    'myAssessments.emptyHint': 'عندما ترسل لك الموارد البشرية اختبار مهارات، يظهر هنا.',
    'myAssessments.startBy': 'ابدأ قبل {date} · {minutes} دقيقة',
    'myAssessments.endsAt': 'قيد التنفيذ · ينتهي {date}',
    'myAssessments.submittedOn': 'سُلِّم {date}',
    'myAssessments.status.ready': 'بانتظارك',
    'myAssessments.status.inProgress': 'قيد التنفيذ',
    'myAssessments.status.submitted': 'مُسلَّم',
    'screenTest.rules.timer': 'يبدأ المؤقّت عند الضغط على «ابدأ» ولا يتوقف. عند انتهاء الوقت يُرسَل ما حفظته.',
    'screenTest.rules.autosave': 'تُحفظ إجاباتك تلقائيًا أثناء العمل.',
    'screenTest.section.quiz': 'أسئلة',
    'screenTest.section.task': 'مهمة عملية',
    'screenTest.section.minutes': 'حوالي {minutes} دقيقة',
    'screenTest.section.questions': '{count} سؤال',
    'screenTest.start': 'ابدأ التقييم',
    'screenTest.timeLeft': 'الوقت المتبقي',
    'screenTest.saving': 'جارٍ الحفظ…',
    'screenTest.saved': 'حُفظت جميع الإجابات',
    'screenTest.saveFailed': 'لم يُحفظ بعد. تحقّق من اتصالك وسنواصل المحاولة.',
    'screenTest.points': '{points} درجة',
    'screenTest.chooseOne': 'اختر إجابة واحدة.',
    'screenTest.chooseMany': 'اختر كل ما ينطبق.',
    'screenTest.answer': 'إجابتك',
    'screenTest.chars': '{used} / {max} حرفًا',
    'screenTest.task.answer': 'إجابتك',
    'screenTest.task.link': 'رابط عملك',
    'screenTest.task.linkHint': 'عنوان كامل يبدأ بـ https://',
    'screenTest.task.file': 'ملفك',
    'screenTest.task.upload': 'ارفع ملفًا',
    'screenTest.task.replace': 'استبدل الملف',
    'screenTest.task.uploaded': 'تم الرفع: {name}',
    'screenTest.task.uploading': 'جارٍ الرفع… {percent}%',
    'screenTest.task.uploadFailed': 'فشل الرفع. حاول مرة أخرى.',
    'screenTest.task.uploadsOff': 'رفع الملفات غير متاح حاليًا. تواصل مع من أرسل إليك هذا التقييم.',
    'screenTest.submit': 'أرسل التقييم',
    'screenTest.submitConfirm': 'هل تريد الإرسال الآن؟ لن تتمكّن من تغيير إجاباتك بعد ذلك.',
    'screenTest.submitYes': 'نعم، أرسل',
    'screenTest.submitNo': 'متابعة العمل',
    'screenTest.timeUp': 'انتهى الوقت. جارٍ إرسال ما حفظته…',
    'screenTest.done.title': 'شكرًا لك. تم إرسال تقييمك.',
    'screenTest.done.body': 'سيتواصل معك فريق الموارد البشرية بخصوص الخطوات التالية. يمكنك إغلاق هذه الصفحة.',
    'screenTest.done.auto': 'انتهى الوقت، فأُرسلت الإجابات التي حفظتها.',
    'screenTest.dead.title': 'هذا الرابط غير صالح',
    'screenTest.dead.body': 'ربما انتهت صلاحيته أو استُبدل أو استُخدم من قبل أو فُتح على جهاز آخر. تواصل مع من أرسله إليك.',
    'screenTest.error': 'حدث خطأ. تحقّق من اتصالك وحاول مرة أخرى.',
    'screenTest.retry': 'حاول مرة أخرى',

    // ── HR's screening marking (screens/grading/Screening*) ──
    'grading.screeningTab': 'تقييمات التوظيف',
    'grading.screening.intro': 'اختبارات الموارد البشرية، تُصحَّح دون معرفة الاسم: ترى العمل ورقمًا مرجعيًا فقط.',
    'grading.screening.empty': 'لا شيء للتصحيح',
    'grading.screening.emptyHint': 'تظهر هنا الإجابات المكتوبة والمهام العملية من اختبارات الموارد البشرية بعد إرسالها.',
    'grading.screening.reference': 'المرجع {reference}',
    'grading.screening.kindQuiz': 'إجابات مكتوبة',
    'grading.screening.kindTask': 'مهمة عملية',
    'grading.screening.aiDrafted': 'مسودة الذكاء الاصطناعي جاهزة',
    'grading.screening.quizTitle': 'تصحيح اختبار توظيف',
    'grading.screening.taskTitle': 'تصحيح مهمة عملية',
    'grading.screening.correction': 'تصحيح لاحق',
    'grading.screening.askAi': 'اطلب مسودة من الذكاء الاصطناعي',
    'grading.screening.aiDraftBadge': 'مسودة ذكاء اصطناعي',
    'grading.integrity.title': 'مؤشرات النزاهة',
    'grading.integrity.noFlags': 'لا توجد تنبيهات',
    'grading.integrity.flag.fastFinish': 'أنهى بسرعة كبيرة',
    'grading.integrity.flag.leftPage': 'غادر الصفحة كثيراً',
    'grading.integrity.flag.copiedFromPage': 'نسخ من الصفحة',
    'grading.integrity.flag.pastedAnswers': 'إجابات ملصقة',
    'grading.integrity.timeTaken': 'الوقت المستغرق',
    'grading.integrity.timeWriting': 'الوقت والمحرر مفتوح',
    'grading.integrity.durationOfLimit': '{minutes} دقيقة {seconds} ثانية من {limit} دقيقة',
    'grading.integrity.duration': '{minutes} دقيقة {seconds} ثانية',
    'grading.integrity.autoSubmitted': 'سُلّم عند انتهاء الوقت',
    'grading.integrity.leftPage': 'مغادرة الصفحة',
    'grading.integrity.copied': 'النسخ من الصفحة',
    'grading.integrity.pasted': 'اللصق في الإجابات',
    'grading.integrity.timesSeconds': '{count} مرة، {seconds} ثانية إجمالاً',
    'grading.integrity.timesChars': '{count} مرة، {chars} حرفاً',
    'grading.integrity.notRecorded': 'لم تسجّل الصفحة مؤشرات لهذا العمل (أُدّي قبل بدء التسجيل، أو حجبه المتصفح).',
    'grading.integrity.weighNote': 'للاستئناس فقط، ولا تُعدّ درجة بحد ذاتها. لا يُبلَّغ الشخص المختبَر بأنها تُسجَّل.',
    'grading.integrity.answerPasted': '{pasted} من {chars} حرفاً ملصقة',
    'grading.integrity.aiLeftToYou': 'ترك الذكاء الاصطناعي هذا العمل لتصحّحه بنفسك.',
    'grading.integrity.aiFailedBadge': 'تعذّر على الذكاء الاصطناعي التصحيح',
    'grading.integrity.flagsBadge': '{count} تنبيه',
    'grading.screening.brief': 'المهمة',
    'grading.screening.handedIn': 'ما تم تسليمه',
    'grading.screening.aiScore': 'الدرجة المقترحة: {score} / 100',
    'grading.screening.aiNoScore': 'لم تُقترح درجة: المعلومات غير كافية.',
    'grading.screening.aiNoFile': 'قرأ الذكاء الاصطناعي الإجابة المكتوبة والرابط فقط، وليس الملف.',
    'grading.screening.scoreLabel': 'الدرجة (0–100)',
};
